// ✅ FIX: Import 'useCallback'
import React, { useState, useEffect, useRef, useCallback, useLayoutEffect, useMemo, Suspense } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import MessageComponent from './MessageComponent';
import AnswerMarkdown from './AnswerMarkdown';
import MemorySubjectPickerDialog from './MemorySubjectPickerDialog';
import { memoryTargetErrorCode, memoryTargetsForThread } from '../lib/memoryTargets';
import BlinkingPlaceholderTextarea from './BlinkingPlaceholderTextarea';
import NotificationBanner from './NotificationBanner';
import MobileActionsMenu from './MobileActionsMenu';
import CosmicLoader from './CosmicLoader';
import styles from './ChatPage.module.css'; // Make sure this is imported
import bgBird from '../assets/background-bird.jpg';
import bgCow from '../assets/background-cow.jpg';
import bgKrishna from '../assets/background-krishna.jpg';
import chatLeaf from '../assets/New folder/background-04 half tree small.png';
import personalAstroQuestions from '../../personalastro_questions.json';
import { Menu, MessageSquarePlus, PenLine, Image, Lightbulb,ArrowLeftCircle, MoreHorizontal, Plus, Edit2, Trash2, ArrowRightCircle, ArrowRight, Copy, Bookmark, ArrowUp, ChevronUp, Settings, Check, X, SlidersVertical, Headphones, Zap, Trophy, RotateCcw, Info, Languages, Wrench, User, Heart, Square, BookOpen, Loader2 } from 'lucide-react';
import BirthChartForm from './astrology/BirthChartForm';
import AdvancedAuthenticTagline from './astrology/AdvancedAuthenticTagline';
import MarriageCompatibilityForm from './astrology/MarriageCompatibilityForm';
import CompatibilityDisplay from './astrology/CompatibilityDisplay';
import DayQualityTimeline, { type DayTimelinePayload } from './astrology/DayQualityTimeline';
import DayQualityDatePicker from './astrology/DayQualityDatePicker';
import AstroSpotlightTour from './astrology/AstroSpotlightTour';
import AstroFirstTimeDemo from './astrology/AstroFirstTimeDemo';
import DinacharyaCTACard from './astrology/DinacharyaCTACard';
import DinacharyaActionsBar from './astrology/DinacharyaActionsBar';
import { addMessageToThread, chatfn, createChatThread, getThreadMessages, getUserThreadsMetadata, deleteThread, renameThread, getSecureHeaders, createBookmark, getUserBookmarks, deleteBookmark, expandAnswer, createMemory, getMemory } from '../services';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { onAuthStateChanged, signOut } from 'firebase/auth';
// Retained 'appCheck' and 'getToken' imports as they were in your "current erroring file" - if not used, consider removing them for cleaner code.
import { auth, db, appCheck } from '../firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import { useUserHits } from '../contexts/UserContext';
import { getToken } from 'firebase/app-check'; // Retained this as per your "current erroring file"
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton, TelegramShareButton } from 'react-share';
import { useLocalizedPath } from '../utils/navigation';
import LocalizedLink from './LocalizedLink';
import { AcUnit, Facebook, Spa, Telegram, Twitter, WhatsApp } from '@mui/icons-material';
import Explore from './Explore';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

// Previous filter glyph was lucide-react's Filter funnel. Keep the local name so
// all existing filter-button JSX and behavior stay untouched while the icon changes.
const Filter = SlidersVertical;
import {
  AccountBalance as ArthashashtraIcon,
  Architecture as SilpashashtraIcon,
  SelfImprovement as YogashashtraIcon,
  Science as RasayanaIcon,
  Calculate as GanitashashtraIcon,
  Stars as JyotishashashtraIcon,
  Gavel as DharmashashtraIcon,
  Psychology as TantraIcon,
  Lightbulb as VedantaIcon,
  LocalHospital as AyurvedaIcon,
} from "@mui/icons-material";
import questionsData from "./questions.json";
import TTSButton from './TTSButton';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import SpeechToText from './STT';
import { JourneyPage } from './Explore';
import VerticalCitationToggle from './VerticalCitationToggle';
import { useWelcomeAudioOnce } from '../hooks/useWelcomeAudioOnce';
import { useAudioPlayer } from '../context/AudioPlayerContext';
import { useLoadingTips } from '../hooks/useLoadingTips';
import NewTicker from './NewTicker';
import { useTranslation } from 'react-i18next';
import HandDrawnArrow from './HandDrawnArrow';
import ReadingNudgePill from './ReadingNudgePill';
import AudioModeReminderBubble from './AudioModeReminderBubble';
import { SEO } from './SEO';
import InfoTipsPopup from './InfoTipsPopup';
import { NoiseBackground } from "@/components/ui/noise-background";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { trackEvent } from '../services/analytics';
import { useAudioModeReminder } from '../hooks/useAudioModeReminder';
import SystemAnnouncementCard from './SystemAnnouncementCard';
import { useSystemAnnouncements } from '../hooks/useSystemAnnouncements';
import type { SystemAnnouncementAction } from '../data/systemAnnouncements';
import { buildLocalizedHomepageShareUrl } from '../utils/shareLinks';
import HomeShortcutPrompt from './HomeShortcutPrompt';
import LanguageDiscoveryBanner, { type IndianLanguageCode } from './LanguageDiscoveryBanner';
import { isManualLanguageSelection, storeLanguagePreference, SUPPORTED_LANGS } from '../utils/languageStorage';
import {
  buildAdIntentSearchParams,
  clearPendingAdMode,
  getAdModeFromUrl,
  readPendingAdMode,
  storePendingAdMode,
} from '../utils/adLandingIntent';
import {
  cacheAuthUser,
  clearCachedAuthUser,
  ensureAuthUserDoc,
  ensureUserErrorMessage,
  isEnsureUserBlockedError,
  needsUserDocRepair,
  providerIdForUser,
} from '../utils/authUserDoc';

const loadQuizModal = () => import('./QuizModal');
const QuizModalLazy = React.lazy(loadQuizModal);

const loadPranayamaModal = () => import('./PranayamaModal');
const PranayamaModalLazy = React.lazy(loadPranayamaModal);

const loadQuestlogModal = () => import('./questlog/QuestlogModal');
const QuestlogModalLazy = React.lazy(loadQuestlogModal);

const loadReadingModal = () => import('./ReadingModal');
const ReadingModalLazy = React.lazy(loadReadingModal);

const loadChatAtmospherePlayer = () => import('./ChatAtmospherePlayer');
const ChatAtmospherePlayerLazy = React.lazy(loadChatAtmospherePlayer);

const CHAT_INPUT_MAX_CHARS = 12000;

const getAstroNudgeScore = (value: string) => {
  const text = value.trim();
  if (!text) return 0;

  let score = 0;
  if (/\b(i|my|me|mine|we|our)\b/i.test(text)) score += 1;
  if (/\b(will I|should I|can I|am I|when will|is it good|what happens|what should)\b/i.test(text)) score += 1;
  if (/\b(marriage|job|career|travel|move|child|relationship|health|court|business|money|exam|promotion|study|abroad)\b/i.test(text)) score += 1;
  if (/\b(horoscope|rashi|kundli|chart|dasha|transit|gochara|nakshatra|graha|prediction)\b/i.test(text)) score += 1;

  return score;
};

const getClientTimezone = () => ({
  client_tz_offset: -new Date().getTimezoneOffset() / 60,
  client_tz_name: Intl.DateTimeFormat().resolvedOptions().timeZone,
});

const DAY_QUALITY_DATE_PICK_HIT_COST = 20;
const DAY_QUALITY_PICKER_RANGE_YEARS = 5;
const ASTRO_TOUR_SEEN_STORAGE_BASE = 'astro_tour_seen_v1';
const ASTRO_CHAT_INPUT_DEMO_SEEN_STORAGE_BASE = 'astro_chat_input_demo_seen_v1';
const ASTRO_DIRECT_ENTRY_STORAGE_BASE = 'astro_direct_entry_used_v1';
const HOME_SHORTCUT_PROMPT_STATE_BASE = 'home_shortcut_prompt_state_v1';
const HOME_SHORTCUT_CHAT_VISIT_COUNT_BASE = 'home_shortcut_chat_visit_count_v1';
const HOME_SHORTCUT_CHAT_VISIT_SESSION_BASE = 'home_shortcut_chat_visit_session_v1';
const HOME_SHORTCUT_ASTRO_VISIT_COUNT_BASE = 'home_shortcut_astro_visit_count_v1';
const HOME_SHORTCUT_ASTRO_VISIT_SESSION_BASE = 'home_shortcut_astro_visit_session_v1';
const HOME_SHORTCUT_PROMPT_SESSION_BASE = 'home_shortcut_prompt_shown_session_v1';
const HOME_SHORTCUT_SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;
const CHAT_TIP_VISIT_COUNT_KEY = 'sarvalok_chat_tip_visit_count_v1';
const CHAT_TIP_SESSION_SEEN_KEY = 'sarvalok_chat_tip_seen_session_v1';
const CHAT_TIP_DISMISSED_KEY = 'sarvalok_chat_tip_dismissed_v1';
const CHAT_TIP_AUTO_HIDE_MS = 30000;
const ASTRO_CONVERSATION_TIP_AUTO_HIDE_MS = 15000;
const LANGUAGE_DISCOVERY_DISMISSED_KEY = 'sarvalok_language_discovery_dismissed_v1';
const LANGUAGE_DISCOVERY_COMPLETED_KEY = 'sarvalok_language_discovery_completed_v1';
const LANGUAGE_DISCOVERY_SEEN_COUNT_KEY = 'sarvalok_language_discovery_seen_count_v1';
const LANGUAGE_DISCOVERY_SESSION_SEEN_KEY = 'sarvalok_language_discovery_seen_session_v1';
const LANGUAGE_DISCOVERY_AUTO_HIDE_MS = 20000;
const LANGUAGE_DISCOVERY_MAX_SESSIONS = 2;

type HomeShortcutPromptState = {
  snoozedUntil?: number;
  dismissedForever?: boolean;
  completedAt?: number;
};

const getHomeShortcutKey = (base: string, uid?: string | null) => `${base}_${uid || 'anon'}`;

const readHomeShortcutState = (uid?: string | null): HomeShortcutPromptState => {
  if (typeof window === 'undefined' || !uid) return {};
  try {
    const raw = localStorage.getItem(getHomeShortcutKey(HOME_SHORTCUT_PROMPT_STATE_BASE, uid));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const writeHomeShortcutState = (uid: string | null | undefined, state: HomeShortcutPromptState) => {
  if (typeof window === 'undefined' || !uid) return;
  try {
    localStorage.setItem(getHomeShortcutKey(HOME_SHORTCUT_PROMPT_STATE_BASE, uid), JSON.stringify(state));
  } catch {}
};

const readHomeShortcutCount = (base: string, uid?: string | null) => {
  if (typeof window === 'undefined' || !uid) return 0;
  try {
    const value = Number(localStorage.getItem(getHomeShortcutKey(base, uid)) || '0');
    return Number.isFinite(value) ? value : 0;
  } catch {
    return 0;
  }
};

const isRunningFromHomeShortcut = () => {
  if (typeof window === 'undefined') return false;
  try {
    const standaloneMedia = window.matchMedia?.('(display-mode: standalone)').matches;
    const iosStandalone = Boolean((window.navigator as Navigator & { standalone?: boolean }).standalone);
    return Boolean(standaloneMedia || iosStandalone);
  } catch {
    return false;
  }
};

const shouldShowInitialChatTip = () => {
  if (typeof window === 'undefined') return false;

  try {
    if (localStorage.getItem(CHAT_TIP_DISMISSED_KEY) === '1') {
      return false;
    }

    const seenThisSession = sessionStorage.getItem(CHAT_TIP_SESSION_SEEN_KEY) === '1';
    const storedVisitCount = Number(localStorage.getItem(CHAT_TIP_VISIT_COUNT_KEY) || '0');
    const visitCount = Number.isFinite(storedVisitCount) ? storedVisitCount : 0;
    const nextVisitCount = seenThisSession ? visitCount : visitCount + 1;

    if (!seenThisSession) {
      localStorage.setItem(CHAT_TIP_VISIT_COUNT_KEY, String(nextVisitCount));
      sessionStorage.setItem(CHAT_TIP_SESSION_SEEN_KEY, '1');
    }

    return nextVisitCount >= 2;
  } catch {
    return false;
  }
};

const getLanguageDiscoverySeenCount = () => {
  if (typeof window === 'undefined') return 0;
  try {
    const value = Number(localStorage.getItem(LANGUAGE_DISCOVERY_SEEN_COUNT_KEY) || '0');
    return Number.isFinite(value) ? value : 0;
  } catch {
    return 0;
  }
};

const isLanguageDiscoveryPermanentlySuppressed = () => {
  if (typeof window === 'undefined') return true;
  try {
    return (
      localStorage.getItem(LANGUAGE_DISCOVERY_DISMISSED_KEY) === '1' ||
      localStorage.getItem(LANGUAGE_DISCOVERY_COMPLETED_KEY) === '1' ||
      getLanguageDiscoverySeenCount() >= LANGUAGE_DISCOVERY_MAX_SESSIONS ||
      isManualLanguageSelection()
    );
  } catch {
    return true;
  }
};

const padDatePart = (value: number) => String(value).padStart(2, '0');

const getClientLocalDateIso = (date = new Date()) =>
  `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())}`;

const addYearsClamped = (date: Date, years: number) => {
  const next = new Date(date);
  const originalMonth = date.getMonth();
  next.setFullYear(date.getFullYear() + years);
  if (next.getMonth() !== originalMonth) {
    next.setDate(0);
  }
  return next;
};

const addDaysClamped = (date: Date, days: number) => {
  const next = new Date(date);
  next.setDate(date.getDate() + days);
  return next;
};

const formatTimelineDateForPrompt = (isoDate: string) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate);
  if (!match) return isoDate;
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  if (Number.isNaN(date.getTime())) return isoDate;
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};

type ReadingSource = { key: string; label: string; ci: number; token: string };

// The Diya (oil lamp) icon, a symbol of knowledge.
const DiyaIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M12 2a7 7 0 0 0-7 7c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26c1.81-1.27 3-3.36 3-5.74a7 7 0 0 0-7-7z" />
    <path d="M8 17h8" />
    <path d="M12 22v-5" />
  </svg>
);

// Arrow icon for the suggestion buttons.
const ArrowUpIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 10l7-7m0 0l7 7m-7-7v18" />
  </svg>
);

const ShieldCheckIcon = ({ size = 16, className = '' }: { size?: number; className?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M12 2L4 6v5c0 5.25 3.4 10.15 8 11.4 4.6-1.25 8-6.15 8-11.4V6l-8-4z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
      fill="currentColor"
      fillOpacity="0.08"
    />
    <path
      d="M9 12.5l2 2 4-4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="5.5" r="1" fill="currentColor" opacity="0.4" />
  </svg>
);

// --- Reading Mode Dropdown Button ---
const ReadingDropdownButton = ({ sources, onSelect, t, showNudge = false, nudgeLabel, onNudgeDismiss, onOpen }: {
  sources: ReadingSource[];
  onSelect: (source: ReadingSource) => void;
  t: (...args: any[]) => any;
  showNudge?: boolean;
  nudgeLabel?: string;
  onNudgeDismiss?: () => void;
  onOpen?: () => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [dropdownPosition, setDropdownPosition] = useState<{ left: number; top: number; width: number } | null>(null);

  // Close on click outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  // Hover open/close only for mouse users — touch devices use tap (onClick toggle)
  const handleMouseEnter = () => {
    if (window.matchMedia('(pointer: fine)').matches) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setIsOpen(true);
    }
  };
  const handleMouseLeave = () => {
    if (window.matchMedia('(pointer: fine)').matches) {
      timeoutRef.current = setTimeout(() => setIsOpen(false), 200);
    }
  };

  useLayoutEffect(() => {
    if (!isOpen || typeof window === 'undefined' || !dropdownRef.current) return;

    const updatePosition = () => {
      const rect = dropdownRef.current?.getBoundingClientRect();
      if (!rect) return;

      const viewportPadding = 8;
      const width = Math.min(320, Math.max(180, window.innerWidth - viewportPadding * 2));
      const left = Math.min(
        Math.max(viewportPadding, rect.right - width),
        Math.max(viewportPadding, window.innerWidth - width - viewportPadding),
      );
      const top = Math.max(viewportPadding, rect.top - 8);
      setDropdownPosition({ left, top, width });
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition, true);
    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition, true);
    };
  }, [isOpen]);

  const dropdownMenu = isOpen && dropdownPosition ? (
    <div
      className="fixed mb-2 bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 z-[70] overflow-hidden"
      style={{
        left: dropdownPosition.left,
        top: dropdownPosition.top,
        width: dropdownPosition.width,
        backdropFilter: 'blur(12px)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08)',
        transform: 'translateY(-100%)',
      }}
    >
      <div className="px-3 py-2 text-xs text-gray-500 dark:text-gray-400 border-b border-gray-100 dark:border-gray-700 font-medium">
        {t('chat.select_source_to_read', 'Select a source to read')}
      </div>
      <div className="max-h-[200px] overflow-y-auto">
        {sources.map((src) => (
          <button
            key={src.key}
            onClick={() => { onSelect(src); setIsOpen(false); }}
            className="w-full text-left px-3 py-2.5 text-sm hover:bg-blue-50 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 transition-colors flex items-center gap-2 border-b border-gray-50 dark:border-gray-750 last:border-0"
          >
            <BookOpen className="w-3.5 h-3.5 text-blue-500 dark:text-blue-400 shrink-0" />
            <span className="truncate">{src.label}</span>
          </button>
        ))}
      </div>
    </div>
  ) : null;

  return (
    <div className="relative" ref={dropdownRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {showNudge && !isOpen && (
        <div className="absolute bottom-full right-0 mb-2 z-[60]">
          <ReadingNudgePill
            label={nudgeLabel}
            onClick={() => {
              setIsOpen(true);
            }}
            onDismiss={onNudgeDismiss}
          />
        </div>
      )}
      <button
        onClick={() => {
          setIsOpen(prev => {
            const next = !prev;
            if (next) onOpen?.();
            return next;
          });
        }}
        className="p-1 text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 mr-1 transition-colors"
        title={t('chat.reading_mode', 'Read')}
      >
        <BookOpen className="w-5 h-5" />
      </button>
      {dropdownMenu && typeof document !== 'undefined' ? createPortal(dropdownMenu, document.body) : null}
    </div>
  );
};

const ShastricBasisBadge = ({ mode }: { mode: 'citation' | 'normal' }) => {
  const label = mode === 'citation' ? 'Source Verified' : 'Tradition Based';
  const mobileLabel = mode === 'citation' ? 'Verified' : 'Tradition';
  const tooltipBody = 'Grounded in traditional scriptures. Free from internet opinions and modern distortions.';

  return (
    <Tippy
      content={
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg p-3 max-w-[280px]">
          <div className="text-xs font-semibold text-gray-900 dark:text-gray-100 mb-1">Shastric Basis</div>
          <div className="text-xs text-gray-600 dark:text-gray-300 leading-relaxed">{tooltipBody}</div>
        </div>
      }
      placement="top"
      delay={[250, 0]}
    >
      <button
        type="button"
        className="group inline-flex items-center gap-1 rounded px-1 py-1 mr-1 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 transition-colors"
        aria-label={`${label}. ${tooltipBody}`}
        title={`${label}. ${tooltipBody}`}
      >
        <ShieldCheckIcon size={16} className="text-emerald-600 dark:text-emerald-300" />
        <span className="text-[11px] font-medium text-gray-500 group-hover:text-emerald-700 dark:text-gray-400 dark:group-hover:text-emerald-300 transition-colors">
          <span className="sm:hidden">{mobileLabel}</span>
          <span className="hidden sm:inline">{label}</span>
        </span>
      </button>
    </Tippy>
  );
};

// --- NEW: UPDATED LOADING INDICATOR COMPONENT (from 18th July version) ---
interface LoadingIndicatorProps {
  isFastMode?: boolean;
  isListeningMode?: boolean;
  loading: boolean;
  currentTip?: string | null;
  isFading?: boolean;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ isFastMode = false, isListeningMode = false, loading, currentTip, isFading = false }) => {
  // Use the tip passed from parent component
  const tip = currentTip;

  const getDefaultMessage = () => {
    if (isListeningMode) {
      return 'Please hold on—Trying to fetch your request.';
    }
    if (isFastMode) {
      return 'Hold on—conducting deep multilingual analysis from trusted texts.';
    }
    return 'Hold on—conducting deep multilingual analysis from trusted texts.';
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className="mt-4 text-center text-sm text-gray-600 dark:text-gray-300"
    >
      <div className="flex flex-col items-center space-y-4">
        {/* Animated dots */}
        <div className="flex space-x-1">
          <span className="w-2 h-2 bg-gray-500 dark:bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0s' }}></span>
          <span className="w-2 h-2 bg-gray-500 dark:bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></span>
          <span className="w-2 h-2 bg-gray-500 dark:bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></span>
        </div>

        {/* Message content with smooth fade transition */}
        <div className="min-h-[60px] flex items-center justify-center">
          <p className={`text-sm text-gray-500 dark:text-gray-400 text-center max-w-md leading-relaxed transition-opacity duration-700 ease-in-out ${
            isFading ? 'opacity-0' : 'opacity-100'
          }`}>
            {tip || getDefaultMessage()}
          </p>
        </div>
      </div>
    </div>
  );
};
// --- END OF NEW COMPONENT ---

// CosmicLoader extracted to CosmicLoader.tsx — imported above


const ASTRO_TIMELINE_FACTOR_LABELS: Record<string, string> = {
  nakshatra: 'Nakshatra fit',
  tarabala: 'Tara Bala',
  chandrabala: 'Chandra Bala',
  tithi: 'Tithi',
  weekday: 'Vara / weekday',
  karana: 'Karana',
  yoga: 'Yoga',
  muhurta_yoga: 'Muhurtic yoga',
  tithi_group: 'Tithi group',
  nakshatra_category: 'Nakshatra category',
  pushkara_yoga: 'Pushkara yoga',
  varjyam_free: 'Varjya-free',
  amrita_gadiya: 'Amrita Gadiya',
  hora: 'Hora lord',
  lagna_sign_favorable: 'Lagna sign favorable',
  lagna_clear: 'Lagna clear',
  lagna_lord_dignified: 'Lagna lord dignified',
  lagna_lord_placed_well: 'Lagna lord placed well',
  benefics_in_kendra: 'Benefics in kendra',
  malefics_kendra_clear: 'Malefics clear of kendra',
  eighth_house_clear: 'Eighth house clear',
  vedha_clear: 'Vedha clear',
  dagdha_tithi_clear: 'Dagdha tithi clear',
  gandanta_clear: 'Gandanta clear',
};

const ASTRO_TIMELINE_WATCH_FACTOR_KEYS = new Set([
  'tarabala',
  'chandrabala',
  'varjyam_free',
  'hora',
  'lagna_sign_favorable',
  'lagna_clear',
  'malefics_kendra_clear',
  'eighth_house_clear',
  'vedha_clear',
  'dagdha_tithi_clear',
  'gandanta_clear',
]);

const titleCaseTimelineQuality = (quality: unknown) => {
  const q = typeof quality === 'string' ? quality : '';
  return q ? q.charAt(0).toUpperCase() + q.slice(1) : 'Neutral';
};


const ChatPage: React.FC = () => {
  const { t, i18n } = useTranslation(['chat', 'seo']);
  const isIndianLocaleUser = typeof window !== 'undefined' && Boolean((window as any).__isIndianLocale__);
  const isEnglishLocale = (i18n.language || '').toLowerCase().startsWith('en');
  const showIndianEnglishHindiAstroStrip = isIndianLocaleUser && isEnglishLocale;
  const localizedPath = useLocalizedPath();
  type BookmarkItem = {
    id: string;
    threadId: string;
    // v2: bookmarks are keyed by the stable turnIndex, not the UI array index.
    turnIndex: number;
    messageId?: string;
    question?: string;
    answerSnippet?: string;
    answerText?: string;
    createdAt?: string;
    updatedAt?: string;
    _ts?: number;
  };
  type DinacharyaBirthDetails = {
    name?: string;
    birthDate?: string;
    birthTime?: string;
    location?: string;
  };
  type AstroBirthDetailsSnapshot = DinacharyaBirthDetails & {
    subjectId?: string;
    displayName?: string;
    relation?: string | null;
  };
  type CachedAstroTimeline = {
    timeline: DayTimelinePayload;
    date: string;
    mode: 'basic' | 'advanced';
    isToday: boolean;
  };
  type ChatHistoryItem = {
    text: string;
    isUser: boolean;
    isLoading?: boolean;
    footnotes?: any;
    // v2 storage: stable per-turn identity carried on both bubbles of a turn,
    // so bookmarks/scroll survive pagination (never the UI array index).
    turnIndex?: number;
    messageId?: string;
    bubbleKind?: 'question' | 'answer';
    thoughtText?: string;
    personalMode?: boolean;
    isSystemNote?: boolean;
    expansionToken?: string;
    remainingCount?: number;
    canExpand?: boolean;
    expansionText?: string;
    isExpanding?: boolean;
    readSources?: ReadingSource[];
    canRead?: boolean;
    isDinacharya?: boolean;
    dinacharyaGeneratedForDate?: string | null;
    staticDinacharyaLibraryVersion?: string | null;
    dinacharyaSubjectDisplayName?: string | null;
    dinacharyaBirthDetails?: DinacharyaBirthDetails | null;
    dinacharyaTimelinePayload?: DayTimelinePayload | null;
    dinacharyaTimelineMode?: 'basic' | 'advanced' | null;
    dinacharyaTimelineDate?: string | null;
  };
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);
  const [sidebarTab, setSidebarTab] = useState<'history' | 'bookmarks'>('history');
  const [chatHistory, setChatHistory] = useState<ChatHistoryItem[]>([]);
  // v2 pagination: initial resume loads the latest page; older turns lazy-load
  // on scroll-up. `oldestTurnIndex` is the cursor for the next older page.
  const [hasMoreOlderMessages, setHasMoreOlderMessages] = useState<boolean>(false);
  const [oldestTurnIndex, setOldestTurnIndex] = useState<number | null>(null);
  const [isOlderMessagesLoading, setIsOlderMessagesLoading] = useState<boolean>(false);
  const THREAD_PAGE_SIZE = 10;
  const [thinkingPanelOpen, setThinkingPanelOpen] = useState<Record<number, boolean>>({});
  const [message, setMessage] = useState<string>('');
  const [isRateLimitExceeded, setIsRateLimitExceeded] = useState<boolean>(false);
  const [usageLimitKind, setUsageLimitKind] = useState<'free_trial' | 'plan_credits' | 'subscription_inactive'>('plan_credits');
  const [isFreePlan, setIsFreePlan] = useState<boolean>(false);
  const isFreePlanRef = useRef<boolean>(false);
  const {
    hitsCount: remainingHits,
    isHitsReady: isRemainingHitsReady,
    hitsKnown: isRemainingHitsKnown,
    isPaidPlan: isPaidPlanLive,
    isEnterprise: isEnterpriseUser,
    subscriptionActive: isSubscriptionActiveLive,
    razorpaySelfHealCandidate: isRazorpaySelfHealCandidate,
  } = useUserHits();
  // Proactive credit-exhaustion gate. The Firestore `hits` listener is already
  // live (no extra fetch / latency), so we can surface the upgrade modal the
  // instant the balance is known-exhausted instead of waiting for a backend
  // 403. The backend `check_rate_limit` remains the authority — this is purely
  // additive UX, so it can't be exploited to bypass billing. Deliberately
  // conservative: only fires for a numeric balance <= 0 (so "Unlimited" string
  // tiers are skipped) and never for enterprise/org-billed accounts. One
  // exception: stale Razorpay subscription state can self-heal only when a real
  // backend request reaches check_rate_limit, so don't locally trap that case.
  const creditsExhaustedReached =
    isRemainingHitsReady &&
    isRemainingHitsKnown &&
    typeof remainingHits === 'number' &&
    Number.isFinite(remainingHits) &&
    remainingHits <= 0 &&
    !isRazorpaySelfHealCandidate &&
    !isEnterpriseUser;
  const subscriptionInactiveReached =
    isRemainingHitsReady &&
    isPaidPlanLive &&
    !isSubscriptionActiveLive &&
    !isRazorpaySelfHealCandidate &&
    !isEnterpriseUser;
  const usageLimitReached = creditsExhaustedReached || subscriptionInactiveReached;
  const proactiveUsageLimitKind = (): 'free_trial' | 'plan_credits' | 'subscription_inactive' =>
    subscriptionInactiveReached
      ? 'subscription_inactive'
      : !isPaidPlanLive ? 'free_trial' : isSubscriptionActiveLive ? 'plan_credits' : 'subscription_inactive';
  const autoGateShownRef = useRef(false);
  const [upgradeBannerDismissed, setUpgradeBannerDismissed] = useState<boolean>(() => {
    try { return sessionStorage.getItem('upgrade_banner_dismissed') === '1'; } catch { return false; }
  });
  useEffect(() => {
    isFreePlanRef.current = isFreePlan;
  }, [isFreePlan]);
  // Open the upgrade modal proactively the moment we know the balance is
  // exhausted (no 403 flash), and auto-dismiss it if credits are topped up
  // while it's open. `autoGateShownRef` ensures we only auto-open once per
  // exhausted episode — if the user closes it manually it stays closed until
  // the balance recovers and runs out again.
  useEffect(() => {
    if (usageLimitReached) {
      if (!autoGateShownRef.current) {
        autoGateShownRef.current = true;
        setUsageLimitKind(proactiveUsageLimitKind());
        setIsRateLimitExceeded(true);
      }
    } else if (autoGateShownRef.current) {
      autoGateShownRef.current = false;
      setIsRateLimitExceeded(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usageLimitReached, isPaidPlanLive, isSubscriptionActiveLive]);
  const errorDetailText = (error: unknown): string => {
    if (typeof error === 'string') return error;
    if (!error) return '';
    const anyError = error as any;
    const detail =
      anyError?.detail ??
      anyError?.message ??
      anyError?.error ??
      anyError?.response?.data?.detail ??
      anyError?.response?.data?.message;
    if (typeof detail === 'string') return detail;
    if (detail && typeof detail === 'object') {
      const nested = detail.message ?? detail.error ?? detail.code;
      if (typeof nested === 'string') return nested;
      try { return JSON.stringify(detail); } catch {}
    }
    try { return JSON.stringify(error); } catch {}
    return String(error);
  };
  const headerValue = (headers: any, name: string): string => {
    if (!headers) return '';
    const lowerName = name.toLowerCase();
    const value =
      headers[name] ??
      headers[lowerName] ??
      headers.get?.(name) ??
      headers.get?.(lowerName);
    return typeof value === 'string' ? value : '';
  };
  const creditStatusFromError = (error: unknown): string => {
    if (!error || typeof error !== 'object') return '';
    const anyError = error as any;
    return String(
      anyError.creditStatus ||
      anyError.credit_status ||
      headerValue(anyError.headers, 'x-sarvalok-credit-status') ||
      headerValue(anyError.response?.headers, 'x-sarvalok-credit-status') ||
      ''
    ).toLowerCase();
  };
  const isUsageLimitError = (detail: unknown) => {
    if (creditStatusFromError(detail) === 'exhausted') return true;
    const normalized = errorDetailText(detail).toLowerCase();
    return normalized.includes('free trial exhausted') ||
      normalized.includes('plan credits exhausted') ||
      normalized.includes('subscription is inactive') ||
      normalized.includes('subscription has expired') ||
      normalized.includes('renew or sync your subscription') ||
      normalized.includes('insufficient hits') ||
      normalized.includes('credits_exhausted') ||
      normalized.includes('credit limit') ||
      normalized.includes('monthly credits') ||
      normalized.includes('out of credits') ||
      normalized.includes('payment required') ||
      normalized.includes('free trial is over') ||
      normalized.includes('free trial ran out') ||
      normalized.includes('rate limit reached');
  };
  const isSubscriptionInactiveError = (detail: unknown) => {
    const normalized = errorDetailText(detail).toLowerCase();
    return normalized.includes('subscription is inactive') ||
      normalized.includes('subscription has expired') ||
      normalized.includes('renew or sync your subscription');
  };
  const isFreeTrialExhaustedError = (detail: unknown) => {
    const normalized = errorDetailText(detail).toLowerCase();
    return normalized.includes('free trial exhausted') ||
      normalized.includes('free trial is over') ||
      normalized.includes('free trial ran out');
  };
  const getUsageLimitKind = (detail: unknown): 'free_trial' | 'plan_credits' | 'subscription_inactive' => {
    if (isSubscriptionInactiveError(detail)) return 'subscription_inactive';
    return isFreePlanRef.current || isFreeTrialExhaustedError(detail) ? 'free_trial' : 'plan_credits';
  };
  const getUsageLimitMessage = (detail: unknown) =>
    getUsageLimitKind(detail) === 'subscription_inactive'
      ? t('chat.subscription_inactive_message', 'Your subscription needs attention. Renew, top up, or choose a plan to continue.')
      : getUsageLimitKind(detail) === 'free_trial'
      ? t('chat.free_trial_over_message', 'Your free trial is over. Upgrade to continue.')
      : t('chat.token_limit_reached_message');
  const openUsageLimitModal = (detail: unknown = '') => {
    setUsageLimitKind(getUsageLimitKind(detail));
    setIsRateLimitExceeded(true);
  };
  const [ThreadId, setThreadId] = useState<any>();
  // Use a ref to track the current active thread ID for race condition checks
  const activeThreadIdRef = useRef(ThreadId);
  const astroNavTokenRef = useRef(0);
  const compatibilityNavTokenRef = useRef(0);
  const threadMessagesTokenRef = useRef(0);
  const sendMessageTokenRef = useRef(0);
  const exploreTopicsTokenRef = useRef(0);
  const pendingAstroInitialMessageRef = useRef(false);
  const newChatHandledAtRef = useRef(0);
  const sendMessageAbortControllerRef = useRef<AbortController | null>(null);
  const astroNudgeTimerRef = useRef<NodeJS.Timeout | null>(null);
  const astroNudgeAutoHideRef = useRef<NodeJS.Timeout | null>(null);
  const readingNudgeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const previousThreadIdRef = useRef<any>(undefined);
  const adLandingHandledRef = useRef(false);
  const astroTourButtonRef = useRef<HTMLButtonElement>(null);
  const compatTourButtonRef = useRef<HTMLButtonElement>(null);
  const conversationAudioToggleRef = useRef<HTMLButtonElement>(null);
  const astroTourTargetRefs = useMemo(() => [astroTourButtonRef, compatTourButtonRef], [
    astroTourButtonRef,
    compatTourButtonRef,
  ]);
  useEffect(() => {
    activeThreadIdRef.current = ThreadId;
  }, [ThreadId]);
  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    const clearPrintTarget = () => {
      document.body.classList.remove('dinacharya-print-mode');
      setPrintingDinacharyaIndex(null);
    };
    window.addEventListener('afterprint', clearPrintTarget);
    return () => {
      window.removeEventListener('afterprint', clearPrintTarget);
      document.body.classList.remove('dinacharya-print-mode');
    };
  }, []);

  useEffect(() => {
    return () => {
      if (bookmarkScrollIntervalRef.current != null) {
        window.clearInterval(bookmarkScrollIntervalRef.current);
        bookmarkScrollIntervalRef.current = null;
      }
    };
  }, []);

  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const chatStartedStorageKey = 'analytics_chat_started_v1';
  const chatEngagedStorageKey = 'analytics_chat_engaged_v1';
  const chatMessagesSentRef = useRef(0);
  const chatStartedTrackedRef = useRef(false);
  const chatEngagedTrackedRef = useRef(false);
  const homeShortcutMessagesSentRef = useRef(0);
  const homeShortcutAstroMessagesSentRef = useRef(0);
  const [homeShortcutMessagesSent, setHomeShortcutMessagesSent] = useState(0);
  const [homeShortcutAstroMessagesSent, setHomeShortcutAstroMessagesSent] = useState(0);
  const [homeShortcutChatVisitCount, setHomeShortcutChatVisitCount] = useState(0);
  const [homeShortcutAstroVisitCount, setHomeShortcutAstroVisitCount] = useState(0);
  const [homeShortcutPromptState, setHomeShortcutPromptState] = useState<HomeShortcutPromptState>({});
  const [showHomeShortcutPrompt, setShowHomeShortcutPrompt] = useState(false);
  const [showLanguageDiscoveryBanner, setShowLanguageDiscoveryBanner] = useState(false);

  const getDeviceType = useCallback(() => {
    if (typeof window === 'undefined') return 'desktop';
    return window.innerWidth < 640 ? 'mobile' : 'desktop';
  }, []);

  useEffect(() => {
    if (chatStartedTrackedRef.current) return;
    chatStartedTrackedRef.current = true;

    try {
      if (sessionStorage.getItem(chatStartedStorageKey) === '1') return;
      sessionStorage.setItem(chatStartedStorageKey, '1');
    } catch {}

    trackEvent('chat_started', {
      category: 'Chat',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      route: location.pathname,
    });
  }, [getDeviceType, i18n.language, location.pathname]);
  const [userId, setUserId] = useState<any>();
  const [userName, setUserName] = useState<any>();
  const [filterMapping, setFilterMapping] = useState<any>({});
  const [threads, setThreads] = useState<any[]>([]);
  const [memorySubjects, setMemorySubjects] = useState<Array<{ id: string; display_name?: string; relation?: string | null; kind?: string }>>([]);
  const [memorySubjectsLoaded, setMemorySubjectsLoaded] = useState(false);
  const [bookmarks, setBookmarks] = useState<BookmarkItem[]>([]);
  const [bookmarksLoaded, setBookmarksLoaded] = useState<boolean>(false);
  const [bookmarksLoading, setBookmarksLoading] = useState<boolean>(false);
  const [bookmarkPreview, setBookmarkPreview] = useState<BookmarkItem | null>(null);
  const [deletingBookmarkId, setDeletingBookmarkId] = useState<string | null>(null);
  const bookmarksLoadingRef = useRef(false);
  const bookmarkScrollIntervalRef = useRef<number | null>(null);
  const [isThreadMessagesLoading, setIsThreadMessagesLoading] = useState<boolean>(false);
  const [loadingThreadId, setLoadingThreadId] = useState<string | null>(null);
  const [journey,SetJourney] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false);
  const [pageloading, setPageLoading] = useState<boolean>(true);
  const [tokenlimitReached, setTokenLimitReached] = useState<boolean>(false);
  const [menuOpen, setMenuOpen] = useState<{ [key: string]: boolean }>({});
  const [questions, setQuestions] = useState<string[]>([]);
  const [authorityRange, setAuthorityRange] = useState<[number, number]>([0, 10]);
  const [isAuthorityPopupOpen, setIsAuthorityPopupOpen] = useState<boolean>(false);
  const [showInfoTipsPopup, setShowInfoTipsPopup] = useState<boolean>(false);
  const [isRenaming, setIsRenaming] = useState<string | null>(null);
  const [showTipNotification, setShowTipNotification] = useState<boolean>(() => shouldShowInitialChatTip());
  const [showAstroConversationTip, setShowAstroConversationTip] = useState<boolean>(false);
  const [showWelcomeAstroRibbon, setShowWelcomeAstroRibbon] = useState<boolean>(false);
  const [showAstroTour, setShowAstroTour] = useState<boolean>(false);
  const [showAstroFirstTimeDemo, setShowAstroFirstTimeDemo] = useState<boolean>(false);
  const [isDinacharyaGenerating, setIsDinacharyaGenerating] = useState<boolean>(false);
  const [printingDinacharyaIndex, setPrintingDinacharyaIndex] = useState<number | null>(null);
  const [pdfGeneratingDinacharyaIndex, setPdfGeneratingDinacharyaIndex] = useState<number | null>(null);
  const [personalModeEnabled, setPersonalModeEnabled] = useState(false);
  const [personalModeLoading, setPersonalModeLoading] = useState(true);
  const [showAstroNudge, setShowAstroNudge] = useState<boolean>(false);
  const [isAstroNudgeOnboarding, setIsAstroNudgeOnboarding] = useState<boolean>(false);
  const [showReadingNudge, setShowReadingNudge] = useState<boolean>(false);
  const [readingNudgeMessageIndex, setReadingNudgeMessageIndex] = useState<number | null>(null);
  const [isReadingNudgeEligible, setIsReadingNudgeEligible] = useState<boolean>(false);
  const [reportStatusLoaded, setReportStatusLoaded] = useState<boolean>(false);
  const [newThreadName, setNewThreadName] = useState('');
  const [topics, setTopics] = useState<string[]>([]);
  const [showExplore, setShowExplore] = useState(false);
  const [authorityError, setAuthorityError] = useState<string>('');
  const [welcomeBg, setWelcomeBg] = useState<string>(bgBird);
  const [showPersonalMode, setShowPersonalMode] = useState(false);
  const [personalModeSource, setPersonalModeSource] = useState<'welcome' | 'compatibility'>('welcome');
  const [showCompatibilityMode, setShowCompatibilityMode] = useState(false);
  const [compatibilityResult, setCompatibilityResult] = useState<any>(null);
  const [isCompatibilityLoading, setIsCompatibilityLoading] = useState(false);
  const [userReportStatus, setUserReportStatus] = useState<any>({ has_horoscope: false, has_gochara: false, has_compatibility: false, default_subject_id: 'self' });
  const [isPersonalHoroscopeChat, setIsPersonalHoroscopeChat] = useState(false);
  const [natalChartSvgs, setNatalChartSvgs] = useState<{ north_indian_data_uri?: string; south_indian_data_uri?: string } | null>(null);
  const natalChartHydrationTokenRef = useRef(0);
  const [astroBirthDetailsBySubject, setAstroBirthDetailsBySubject] = useState<Record<string, AstroBirthDetailsSnapshot>>({});
  const [isRefreshingTransits, setIsRefreshingTransits] = useState(false);
  const [astroDayTimeline, setAstroDayTimeline] = useState<DayTimelinePayload | null>(null);
  const [astroTimelineDate, setAstroTimelineDate] = useState<string>('');
  const [astroTimelineMode, setAstroTimelineMode] = useState<'basic' | 'advanced'>('basic');
  const [showDayTimeline, setShowDayTimeline] = useState<boolean>(true);
  const [timelineFetchFailed, setTimelineFetchFailed] = useState(false);
  const [astroTimelinePickError, setAstroTimelinePickError] = useState<string | null>(null);
  const astroTimelineCacheRef = useRef<Map<string, CachedAstroTimeline>>(new Map());
  const [clickedAstroQuestions, setClickedAstroQuestions] = useState<Set<string>>(() => new Set());
  const [shuffledAstroQuestions, setShuffledAstroQuestions] = useState<string[]>([]);
  const [isListeningMode, setIsListeningMode] = useState<boolean>(false);
  const [openShareMenuIndex, setOpenShareMenuIndex] = useState<number | null>(null);
  const [rememberingMessageIndex, setRememberingMessageIndex] = useState<number | null>(null);
  // Pending "Save for" choice: the message being saved, its text, and the
  // permitted destinations. Null when no question is outstanding.
  const [memoryPicker, setMemoryPicker] = useState<{
    index: number;
    text: string;
    targets: ReturnType<typeof memoryTargetsForThread>;
  } | null>(null);
  const pendingThreadSubjectRef = useRef<{
    active_subject_id: string;
    active_subject_mode?: 'single' | 'compat_pair';
    addressed_subject_id?: string | null;
    compat_subject_ids?: string[];
  } | null>(null);

  const getGeneralThreadStorageKey = useCallback(() => {
    const uid = auth.currentUser?.uid || userId;
    return uid ? `thread_id_general_${uid}` : 'thread_id_general';
  }, [userId]);

  const getAstroThreadStorageKey = useCallback(() => {
    const uid = auth.currentUser?.uid || userId;
    return uid ? `thread_id_astro_${uid}` : 'thread_id_astro';
  }, [userId]);

  const getAstroChartsStorageKey = useCallback((subjectId: string = 'self') => {
    const uid = auth.currentUser?.uid || userId;
    const safeSubjectId = String(subjectId || 'self').replace(/[^a-zA-Z0-9_-]/g, '_');
    return uid
      ? `natal_chart_svgs_astro_${uid}_${safeSubjectId}`
      : `natal_chart_svgs_astro_${safeSubjectId}`;
  }, [userId]);

  const getAstroBirthDetailsStorageKey = useCallback((subjectId?: string | null) => {
    const uid = auth.currentUser?.uid || userId || 'anon';
    const safeSubjectId = String(subjectId || 'self').replace(/[^a-zA-Z0-9_-]/g, '_');
    return `astro_birth_details_${uid}_${safeSubjectId}`;
  }, [userId]);

  const getThreadSubjectMeta = useCallback((threadId?: string | null) => {
    const fallbackSubjectId =
      pendingThreadSubjectRef.current?.active_subject_id ||
      (isPersonalHoroscopeChat ? (userReportStatus?.default_subject_id || 'self') : 'self');
    const found = threads.find((thread) => thread?.id === threadId);
    return {
      active_subject_id: found?.active_subject_id || fallbackSubjectId || 'self',
      active_subject_mode: found?.active_subject_mode || pendingThreadSubjectRef.current?.active_subject_mode || 'single',
      addressed_subject_id: found?.addressed_subject_id || pendingThreadSubjectRef.current?.addressed_subject_id || null,
      compat_subject_ids: Array.isArray(found?.compat_subject_ids)
        ? found.compat_subject_ids
        : (pendingThreadSubjectRef.current?.compat_subject_ids || []),
    };
  }, [isPersonalHoroscopeChat, threads, userReportStatus?.default_subject_id]);

  const getAstroTimelineCacheKey = useCallback((subjectId: string | undefined, date: string, mode: 'basic' | 'advanced') => {
    const safeSubjectId = String(subjectId || 'self').replace(/[^a-zA-Z0-9_-]/g, '_');
    return `${safeSubjectId}:${date}:${mode}`;
  }, []);

  const writeAstroTimelineCache = useCallback((subjectId: string | undefined, item: CachedAstroTimeline) => {
    if (!item?.timeline?.segments?.length) return;
    const cache = astroTimelineCacheRef.current;
    cache.set(getAstroTimelineCacheKey(subjectId, item.date, item.mode), item);
    while (cache.size > 24) {
      const oldestKey = cache.keys().next().value;
      if (!oldestKey) break;
      cache.delete(oldestKey);
    }
  }, [getAstroTimelineCacheKey]);

  // Assigned immediately after `enterAstroMode` is defined. The profile
  // picker is declared earlier, but switching profiles must use the canonical
  // Astro-thread creation path rather than the general "new chat" reset.
  const enterAstroModeRef = useRef<
    ((opts?: { forceNewThread?: boolean }) => Promise<void>) | null
  >(null);

  const availableSubjectsForPicker = useMemo(() => {
    const serverSubjects = Array.isArray(memorySubjects) ? [...memorySubjects] : [];
    const hasSelf = serverSubjects.some((subject) => subject?.id === 'self');
    if (!hasSelf) {
      serverSubjects.unshift({ id: 'self', kind: 'self', display_name: userName || 'You', relation: null });
    }
    const uniq: Array<{ id: string; display_name?: string; relation?: string | null; kind?: string }> = [];
    const seen = new Set<string>();
    for (const subject of serverSubjects) {
      const id = typeof subject?.id === 'string' ? subject.id : '';
      if (!id || seen.has(id)) continue;
      seen.add(id);
      uniq.push(subject);
    }
    return uniq;
  }, [memorySubjects, userName]);

  /**
   * Switching the profile starts a NEW chat; it never retargets this one.
   *
   * This used to call `updateThreadSubject` on the open thread, which rewrote
   * who the whole conversation was about — retroactively. Everything already
   * said about Person A stayed in the transcript but now belonged to Person B,
   * and any memory saved afterwards was filed against the new profile even
   * when it came from the earlier discussion. A thread's subject is part of
   * what its messages MEAN, so it has to be fixed at creation.
   *
   * The pending-subject ref is the existing mechanism for this: thread rows are
   * created lazily on first send, and creation already reads this ref. So we
   * record the choice, clear the board, and the next message opens a thread
   * that belonged to the chosen profile from its first word.
   */
  const handleActiveSubjectChange = useCallback(async (nextSubjectId: string) => {
    if (!nextSubjectId) return;
    const found = availableSubjectsForPicker.find((s) => s.id === nextSubjectId);
    const label = !found
      ? nextSubjectId
      : found.id === 'self'
        ? (found.display_name || t('chat.subject_picker.you'))
        : `${found.display_name || t('chat.subject_picker.person')}${
            found.relation
              ? ` (${t(`chat.astro_form.subject.relations.${found.relation}`, { defaultValue: found.relation })})`
              : ''
          }`;

    const previousPending = pendingThreadSubjectRef.current;
    pendingThreadSubjectRef.current = {
      active_subject_id: nextSubjectId,
      active_subject_mode: 'single',
      addressed_subject_id: null,
      compat_subject_ids: [],
    };
    astroNavTokenRef.current += 1;
    compatibilityNavTokenRef.current += 1;
    try {
      const enter = enterAstroModeRef.current;
      if (!enter) throw new Error('Astro navigation is not ready');
      await enter({ forceNewThread: true });
      toast.info(t('chat.subject_picker.started_new', { name: label }), { position: 'bottom-right' });
    } catch (error) {
      pendingThreadSubjectRef.current = previousPending;
      console.error('Could not start a subject-scoped Astro chat:', error);
      toast.error(t('chat.create_failed'), { position: 'bottom-right' });
    }
  }, [availableSubjectsForPicker, t]);

  const getScopedUserStorageKey = useCallback((base: string) => {
    const uid = auth.currentUser?.uid || userId || 'anon';
    return `${base}_${uid}`;
  }, [userId]);

  const getWelcomeRibbonSessionCountKey = useCallback(
    () => getScopedUserStorageKey('astro_welcome_ribbon_session_count'),
    [getScopedUserStorageKey],
  );

  const getWelcomeRibbonSessionSeenKey = useCallback(
    () => getScopedUserStorageKey('astro_welcome_ribbon_session_seen'),
    [getScopedUserStorageKey],
  );

  const getWelcomeRibbonDismissedSessionKey = useCallback(
    () => getScopedUserStorageKey('astro_welcome_ribbon_dismissed_session'),
    [getScopedUserStorageKey],
  );

  const dismissWelcomeAstroRibbon = useCallback(() => {
    setShowWelcomeAstroRibbon(false);
    try {
      sessionStorage.setItem(getWelcomeRibbonDismissedSessionKey(), '1');
    } catch {}
  }, [getWelcomeRibbonDismissedSessionKey]);

  const getReadingNudgeSessionCountKey = useCallback(
    () => getScopedUserStorageKey('reading_nudge_session_count'),
    [getScopedUserStorageKey],
  );

  const getReadingNudgeSessionSeenKey = useCallback(
    () => getScopedUserStorageKey('reading_nudge_session_seen'),
    [getScopedUserStorageKey],
  );

  const getReadingNudgeCompletedKey = useCallback(
    () => getScopedUserStorageKey('reading_nudge_completed'),
    [getScopedUserStorageKey],
  );

  const getAstroTourSeenKey = useCallback(
    () => getScopedUserStorageKey(ASTRO_TOUR_SEEN_STORAGE_BASE),
    [getScopedUserStorageKey],
  );

  const getAstroFirstTimeDemoSeenKey = useCallback(
    () => getScopedUserStorageKey(ASTRO_CHAT_INPUT_DEMO_SEEN_STORAGE_BASE),
    [getScopedUserStorageKey],
  );

  const getAstroDirectEntryUsedKey = useCallback(
    () => getScopedUserStorageKey(ASTRO_DIRECT_ENTRY_STORAGE_BASE),
    [getScopedUserStorageKey],
  );

  const getAstroNudgeShownCountKey = useCallback(
    () => getScopedUserStorageKey('astro_nudge_shown_count'),
    [getScopedUserStorageKey],
  );

  const getAstroNudgeShownThisSessionKey = useCallback(
    () => getScopedUserStorageKey('astro_nudge_shown_this_session'),
    [getScopedUserStorageKey],
  );

  const getAstroNudgeDismissedThreadKey = useCallback((threadId?: string | null) => {
    const scopedThreadId = threadId || 'unknown';
    return getScopedUserStorageKey(`astro_nudge_dismissed_${scopedThreadId}`);
  }, [getScopedUserStorageKey]);

  const getTimelineSeenKey = useCallback((dateStr: string) => {
    const uid = auth.currentUser?.uid || userId;
    const dateKey = dateStr || getClientLocalDateIso();
    return uid ? `astro_day_timeline_seen_${uid}_${dateKey}` : `astro_day_timeline_seen_anon_${dateKey}`;
  }, [userId]);

  const shouldShowAstroTour = useCallback(() => {
    try {
      return !localStorage.getItem(getAstroTourSeenKey());
    } catch {
      return true;
    }
  }, [getAstroTourSeenKey]);

  const hasUsedAstroDirectEntry = useCallback(() => {
    try {
      return localStorage.getItem(getAstroDirectEntryUsedKey()) === '1';
    } catch {
      return false;
    }
  }, [getAstroDirectEntryUsedKey]);

  const markAstroDirectEntryUsed = useCallback(() => {
    try {
      localStorage.setItem(getAstroDirectEntryUsedKey(), '1');
    } catch {}
  }, [getAstroDirectEntryUsedKey]);

  const handleAstroTourClose = useCallback(() => {
    setShowAstroTour(false);
    try {
      localStorage.setItem(getAstroTourSeenKey(), '1');
    } catch {}
  }, [getAstroTourSeenKey]);

  const hasSeenAstroFirstTimeDemo = useCallback(() => {
    try {
      return localStorage.getItem(getAstroFirstTimeDemoSeenKey()) === '1';
    } catch {
      return false;
    }
  }, [getAstroFirstTimeDemoSeenKey]);

  const markAstroFirstTimeDemoSeen = useCallback(() => {
    try {
      localStorage.setItem(getAstroFirstTimeDemoSeenKey(), '1');
    } catch {
      return;
    }
  }, [getAstroFirstTimeDemoSeenKey]);

  const handleAstroFirstTimeDemoClose = useCallback(() => {
    setShowAstroFirstTimeDemo(false);
    markAstroFirstTimeDemoSeen();
  }, [markAstroFirstTimeDemoSeen]);

  const handleTipNotificationClose = useCallback(() => {
    setShowTipNotification(false);
    try {
      localStorage.setItem(CHAT_TIP_DISMISSED_KEY, '1');
    } catch {}
  }, []);

  useEffect(() => {
    if (!showTipNotification) return;

    const timeoutId = window.setTimeout(() => {
      setShowTipNotification(false);
    }, CHAT_TIP_AUTO_HIDE_MS);

    return () => window.clearTimeout(timeoutId);
  }, [showTipNotification]);

  const languageDiscoveryEligible = useMemo(() => {
    if (!isIndianLocaleUser || !isEnglishLocale) return false;
    if (!/\/chat\/?$/.test(location.pathname)) return false;
    if (isChatOpen || showPersonalMode || showCompatibilityMode) return false;
    if (pageloading || loading || isThreadMessagesLoading || Boolean(loadingThreadId)) return false;
    return !isLanguageDiscoveryPermanentlySuppressed();
  }, [
    isChatOpen,
    isEnglishLocale,
    isIndianLocaleUser,
    isThreadMessagesLoading,
    loading,
    loadingThreadId,
    location.pathname,
    pageloading,
    showCompatibilityMode,
    showPersonalMode,
  ]);

  useEffect(() => {
    if (!languageDiscoveryEligible) {
      setShowLanguageDiscoveryBanner(false);
      return;
    }

    if (showLanguageDiscoveryBanner) return;

    try {
      if (sessionStorage.getItem(LANGUAGE_DISCOVERY_SESSION_SEEN_KEY) === '1') return;

      const seenCount = getLanguageDiscoverySeenCount();
      if (seenCount >= LANGUAGE_DISCOVERY_MAX_SESSIONS) return;

      localStorage.setItem(LANGUAGE_DISCOVERY_SEEN_COUNT_KEY, String(seenCount + 1));
      sessionStorage.setItem(LANGUAGE_DISCOVERY_SESSION_SEEN_KEY, '1');
    } catch {
      return;
    }

    setShowLanguageDiscoveryBanner(true);
    trackEvent('language_discovery_banner_shown', {
      category: 'Language',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      seen_count: getLanguageDiscoverySeenCount(),
    });
  }, [getDeviceType, i18n.language, languageDiscoveryEligible, showLanguageDiscoveryBanner]);

  useEffect(() => {
    if (!showLanguageDiscoveryBanner) return;

    const timeoutId = window.setTimeout(() => {
      setShowLanguageDiscoveryBanner(false);
      trackEvent('language_discovery_banner_auto_hidden', {
        category: 'Language',
        device_type: getDeviceType(),
        ui_language: i18n.language,
        seen_count: getLanguageDiscoverySeenCount(),
      });
    }, LANGUAGE_DISCOVERY_AUTO_HIDE_MS);

    return () => window.clearTimeout(timeoutId);
  }, [getDeviceType, i18n.language, showLanguageDiscoveryBanner]);

  const handleLanguageDiscoveryDismiss = useCallback(() => {
    try {
      localStorage.setItem(LANGUAGE_DISCOVERY_DISMISSED_KEY, '1');
    } catch {}

    setShowLanguageDiscoveryBanner(false);
    trackEvent('language_discovery_banner_dismissed', {
      category: 'Language',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      seen_count: getLanguageDiscoverySeenCount(),
    });
  }, [getDeviceType, i18n.language]);

  const handleLanguageDiscoverySelect = useCallback((newLang: IndianLanguageCode) => {
    const previousLanguage = i18n.language;

    try {
      localStorage.setItem(LANGUAGE_DISCOVERY_COMPLETED_KEY, '1');
    } catch {}

    storeLanguagePreference(newLang, true);
    i18n.changeLanguage(newLang);
    setShowLanguageDiscoveryBanner(false);

    const supportedCodes = SUPPORTED_LANGS.join('|');
    const langPrefixRegex = new RegExp(`^\\/(${supportedCodes})(?=\\/|$)`);
    const stripped = location.pathname.replace(langPrefixRegex, '');
    const currentPath = stripped ? (stripped.startsWith('/') ? stripped : `/${stripped}`) : '/';
    navigate(`/${newLang}${currentPath}${location.search}${location.hash}`);

    trackEvent('language_discovery_banner_language_selected', {
      category: 'Language',
      device_type: getDeviceType(),
      from_language: previousLanguage,
      selected_language: newLang,
      seen_count: getLanguageDiscoverySeenCount(),
    });
  }, [getDeviceType, i18n, location.hash, location.pathname, location.search, navigate]);

  useEffect(() => {
    if (!showAstroConversationTip) return;

    const timeoutId = window.setTimeout(() => {
      setShowAstroConversationTip(false);
    }, ASTRO_CONVERSATION_TIP_AUTO_HIDE_MS);

    return () => window.clearTimeout(timeoutId);
  }, [showAstroConversationTip]);

  const applyTimelineSeenGate = useCallback((dateStr: string) => {
    const key = getTimelineSeenKey(dateStr);
    try {
      setShowDayTimeline(true);
      sessionStorage.setItem(key, '1');
    } catch {
      setShowDayTimeline(true);
    }
  }, [getTimelineSeenKey]);

  const hasSeenTimelineToday = useCallback((dateStr?: string) => {
    const key = getTimelineSeenKey(dateStr || getClientLocalDateIso());
    try {
      return Boolean(sessionStorage.getItem(key));
    } catch {
      return false;
    }
  }, [getTimelineSeenKey]);

  const clearReadingNudgeTimer = useCallback(() => {
    if (readingNudgeTimerRef.current) {
      clearTimeout(readingNudgeTimerRef.current);
      readingNudgeTimerRef.current = null;
    }
  }, []);

  const completeReadingNudge = useCallback(() => {
    try {
      localStorage.setItem(getReadingNudgeCompletedKey(), '1');
    } catch {}
    setIsReadingNudgeEligible(false);
  }, [getReadingNudgeCompletedKey]);

  const hideReadingNudge = useCallback((persist = false) => {
    clearReadingNudgeTimer();
    setShowReadingNudge(false);
    setReadingNudgeMessageIndex(null);
    if (persist) {
      completeReadingNudge();
    }
  }, [clearReadingNudgeTimer, completeReadingNudge]);

  const scheduleReadingNudge = useCallback((messageIndex: number, threadId: string, sourceCount: number) => {
    if (!isReadingNudgeEligible) return;
    if (showReadingNudge) return;
    if (sourceCount <= 0) return;
    if (isPersonalHoroscopeChat || showCompatibilityMode || isListeningMode || isRateLimitExceeded) return;

    clearReadingNudgeTimer();
    readingNudgeTimerRef.current = setTimeout(() => {
      readingNudgeTimerRef.current = null;
      if (!isMountedRef.current) return;
      if (activeThreadIdRef.current !== threadId) return;

      setReadingNudgeMessageIndex(messageIndex);
      setShowReadingNudge(true);

      trackEvent('reading_nudge_shown', {
        category: 'Chat',
        device_type: getDeviceType(),
        ui_language: i18n.language,
        thread_id: threadId,
        message_index: messageIndex,
        source_count: sourceCount,
        onboarding: true,
      });
    }, 900);
  }, [
    clearReadingNudgeTimer,
    getDeviceType,
    i18n.language,
    isListeningMode,
    isPersonalHoroscopeChat,
    isRateLimitExceeded,
    isReadingNudgeEligible,
    showCompatibilityMode,
    showReadingNudge,
  ]);

  const clearAstroNudgeTimers = useCallback(() => {
    if (astroNudgeTimerRef.current) {
      clearTimeout(astroNudgeTimerRef.current);
      astroNudgeTimerRef.current = null;
    }
    if (astroNudgeAutoHideRef.current) {
      clearTimeout(astroNudgeAutoHideRef.current);
      astroNudgeAutoHideRef.current = null;
    }
  }, []);

  const hideAstroNudge = useCallback(() => {
    clearAstroNudgeTimers();
    setShowAstroNudge(false);
    setIsAstroNudgeOnboarding(false);
  }, [clearAstroNudgeTimers]);

  const dismissAstroNudgeForCurrentThread = useCallback(() => {
    try {
      const targetThreadId = activeThreadIdRef.current || ThreadId;
      if (targetThreadId) {
        sessionStorage.setItem(getAstroNudgeDismissedThreadKey(String(targetThreadId)), '1');
      }
    } catch {}
    hideAstroNudge();
    trackEvent('astro_nudge_dismissed', {
      category: 'Chat',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      thread_id: activeThreadIdRef.current || ThreadId || null,
      onboarding: isAstroNudgeOnboarding,
    });
  }, [ThreadId, getAstroNudgeDismissedThreadKey, getDeviceType, hideAstroNudge, i18n.language, isAstroNudgeOnboarding]);

  const scheduleAstroNudge = useCallback((userMsg: string, threadId: string, userMessageCount: number) => {
    if (isPersonalHoroscopeChat || showPersonalMode || showCompatibilityMode || isListeningMode) return;
    if (userMessageCount > 2) return;

    try {
      if (sessionStorage.getItem(getAstroNudgeDismissedThreadKey(threadId)) === '1') return;
    } catch {}

    let shouldShow = false;
    let onboarding = false;

    try {
      const shownCount = Number(localStorage.getItem(getAstroNudgeShownCountKey()) || '0');
      const shownThisSession = sessionStorage.getItem(getAstroNudgeShownThisSessionKey()) === '1';
      if (shownCount < 2 && !shownThisSession) {
        shouldShow = true;
        onboarding = true;
      } else if (getAstroNudgeScore(userMsg) >= 2) {
        shouldShow = true;
      }
    } catch {
      shouldShow = getAstroNudgeScore(userMsg) >= 2;
    }

    if (!shouldShow) return;

    clearAstroNudgeTimers();
    astroNudgeTimerRef.current = setTimeout(() => {
      if (!isMountedRef.current) return;
      if (activeThreadIdRef.current && activeThreadIdRef.current !== threadId) return;
      if (showPersonalMode || showCompatibilityMode || isPersonalHoroscopeChat || isListeningMode) return;

      setShowAstroNudge(true);
      setIsAstroNudgeOnboarding(onboarding);

      try {
        const shownCount = Number(localStorage.getItem(getAstroNudgeShownCountKey()) || '0');
        localStorage.setItem(getAstroNudgeShownCountKey(), String(shownCount + 1));
        if (onboarding) {
          sessionStorage.setItem(getAstroNudgeShownThisSessionKey(), '1');
        }
      } catch {}

      trackEvent('astro_nudge_shown', {
        category: 'Chat',
        device_type: getDeviceType(),
        ui_language: i18n.language,
        thread_id: threadId,
        onboarding,
      });

      if (onboarding) {
        astroNudgeAutoHideRef.current = setTimeout(() => {
          hideAstroNudge();
        }, 25000);
      }
    }, 3000);
  }, [
    clearAstroNudgeTimers,
    getAstroNudgeDismissedThreadKey,
    getAstroNudgeShownCountKey,
    getAstroNudgeShownThisSessionKey,
    getDeviceType,
    hideAstroNudge,
    i18n.language,
    isListeningMode,
    isPersonalHoroscopeChat,
    showCompatibilityMode,
    showPersonalMode,
  ]);

  useEffect(() => {
    const scopedUserId = auth.currentUser?.uid || userId;
    if (!scopedUserId) return;
    if (pageloading) return;

    if (isChatOpen || showPersonalMode || showCompatibilityMode) {
      setShowWelcomeAstroRibbon(false);
      return;
    }

    try {
      const countKey = getWelcomeRibbonSessionCountKey();
      const seenKey = getWelcomeRibbonSessionSeenKey();
      const dismissedKey = getWelcomeRibbonDismissedSessionKey();
      const dismissedThisSession = sessionStorage.getItem(dismissedKey) === '1';
      let sessionCount = Number(localStorage.getItem(countKey) || '0');

      if (sessionStorage.getItem(seenKey) !== '1') {
        sessionCount += 1;
        localStorage.setItem(countKey, String(sessionCount));
        sessionStorage.setItem(seenKey, '1');
      }

      setShowWelcomeAstroRibbon(!dismissedThisSession && sessionCount <= 3);
    } catch {
      setShowWelcomeAstroRibbon(true);
    }
	  }, [
	    getWelcomeRibbonDismissedSessionKey,
	    getWelcomeRibbonSessionCountKey,
	    getWelcomeRibbonSessionSeenKey,
	    isChatOpen,
    pageloading,
    showCompatibilityMode,
    showPersonalMode,
	    userId,
	  ]);

	  useEffect(() => {
	    if (
	      pageloading ||
	      personalModeLoading ||
	      !reportStatusLoaded ||
	      !userId ||
	      !isFreePlan ||
	      !personalModeEnabled ||
	      isChatOpen ||
	      showPersonalMode ||
	      showCompatibilityMode ||
	      isPersonalHoroscopeChat ||
	      showAstroTour ||
	      userReportStatus.has_horoscope ||
	      userReportStatus.has_compatibility
	    ) {
	      return;
	    }

	    const requestedMode = getAdModeFromUrl();
	    const pendingMode = readPendingAdMode();
	    const effectiveMode =
	      requestedMode && requestedMode !== 'global-risk'
	        ? requestedMode
	        : pendingMode && pendingMode !== 'global-risk'
	          ? pendingMode
	          : null;

	    // The first direct Astro landing visit keeps the high-intent birth-form flow.
	    // Subsequent Astro landings can use this welcome-screen tour as discovery.
	    if (effectiveMode === 'astro' && !hasUsedAstroDirectEntry()) return;
	    if (!shouldShowAstroTour()) return;

	    setShowAstroTour(true);
	  }, [
	    hasUsedAstroDirectEntry,
	    isChatOpen,
	    isFreePlan,
	    isPersonalHoroscopeChat,
	    pageloading,
	    personalModeEnabled,
	    personalModeLoading,
	    reportStatusLoaded,
	    shouldShowAstroTour,
	    showAstroTour,
	    showCompatibilityMode,
	    showPersonalMode,
	    userId,
	    userReportStatus.has_compatibility,
	    userReportStatus.has_horoscope,
	  ]);

	  useEffect(() => {
	    if (
	      !isPersonalHoroscopeChat ||
	      showAstroFirstTimeDemo ||
	      showAstroTour ||
	      showPersonalMode ||
	      showCompatibilityMode ||
	      isListeningMode ||
	      isRateLimitExceeded ||
	      isThreadMessagesLoading ||
	      loading
	    ) {
	      return;
	    }

	    const activeAstroThreadId = activeThreadIdRef.current || ThreadId;
	    if (!activeAstroThreadId) return;

	    const activeThread = threads.find((thread) => String(thread?.id) === String(activeAstroThreadId));
	    const metadataMessageCount = Number(activeThread?.message_count) || 0;
	    const hasUserHistory = chatHistory.some((item) => item?.isUser);

	    if (hasUserHistory || metadataMessageCount > 0) {
	      if (!hasSeenAstroFirstTimeDemo()) markAstroFirstTimeDemoSeen();
	      return;
	    }

	    if (message.trim().length > 0) {
	      if (!hasSeenAstroFirstTimeDemo()) markAstroFirstTimeDemoSeen();
	      return;
	    }

	    if (hasSeenAstroFirstTimeDemo()) return;

	    const timeoutId = window.setTimeout(() => {
	      if (!isMountedRef.current) return;
	      if (hasSeenAstroFirstTimeDemo()) return;
	      if (message.trim().length > 0 || chatHistory.some((item) => item?.isUser)) {
	        markAstroFirstTimeDemoSeen();
	        return;
	      }

	      markAstroFirstTimeDemoSeen();
	      setShowAstroFirstTimeDemo(true);
	    }, 2000);

	    return () => window.clearTimeout(timeoutId);
	  }, [
	    ThreadId,
	    chatHistory,
	    hasSeenAstroFirstTimeDemo,
	    isListeningMode,
	    isPersonalHoroscopeChat,
	    isRateLimitExceeded,
	    isThreadMessagesLoading,
	    loading,
	    markAstroFirstTimeDemoSeen,
	    message,
	    showAstroFirstTimeDemo,
	    showAstroTour,
	    showCompatibilityMode,
	    showPersonalMode,
	    threads,
	  ]);

	  useEffect(() => {
	    if (!showAstroFirstTimeDemo) return;
	    if (isPersonalHoroscopeChat && !showPersonalMode && !showCompatibilityMode) return;
	    handleAstroFirstTimeDemoClose();
	  }, [
	    handleAstroFirstTimeDemoClose,
	    isPersonalHoroscopeChat,
	    showAstroFirstTimeDemo,
	    showCompatibilityMode,
	    showPersonalMode,
	  ]);

		  useEffect(() => {
		    if (pageloading) return;

    try {
      const countKey = getReadingNudgeSessionCountKey();
      const seenKey = getReadingNudgeSessionSeenKey();
      const completedKey = getReadingNudgeCompletedKey();
      const completed = localStorage.getItem(completedKey) === '1';
      let sessionCount = Number(localStorage.getItem(countKey) || '0');

      if (sessionStorage.getItem(seenKey) !== '1') {
        sessionCount += 1;
        localStorage.setItem(countKey, String(sessionCount));
        sessionStorage.setItem(seenKey, '1');
      }

      setIsReadingNudgeEligible(!completed && sessionCount <= 1);
    } catch {
      setIsReadingNudgeEligible(true);
    }
  }, [
    getReadingNudgeCompletedKey,
    getReadingNudgeSessionCountKey,
    getReadingNudgeSessionSeenKey,
    pageloading,
    userId,
  ]);

  useEffect(() => {
    if (previousThreadIdRef.current && previousThreadIdRef.current !== ThreadId) {
      hideAstroNudge();
      hideReadingNudge(showReadingNudge);
    }
    previousThreadIdRef.current = ThreadId;
  }, [ThreadId, hideAstroNudge, hideReadingNudge, showReadingNudge]);

  useEffect(() => {
    if (showPersonalMode || showCompatibilityMode || isPersonalHoroscopeChat || isListeningMode) {
      hideAstroNudge();
      hideReadingNudge(showReadingNudge);
    }
  }, [hideAstroNudge, hideReadingNudge, isListeningMode, isPersonalHoroscopeChat, showCompatibilityMode, showPersonalMode, showReadingNudge]);

  useEffect(() => () => {
    clearAstroNudgeTimers();
    clearReadingNudgeTimer();
  }, [clearAstroNudgeTimers, clearReadingNudgeTimer]);

  const formatTimelineMin = useCallback((mins: number) => {
    const dayOffset = mins >= 1440 ? 1 : 0;
    const m = ((mins % 1440) + 1440) % 1440;
    const hh24 = Math.floor(m / 60);
    const mm = m % 60;
    const am = hh24 < 12;
    const hh12 = ((hh24 + 11) % 12) + 1;
    const base = `${hh12}:${String(mm).padStart(2, '0')} ${am ? 'AM' : 'PM'}`;
    return dayOffset ? `${base} (next day)` : base;
  }, []);

  const buildAstroTimelineSummary = useCallback(() => {
    if (!astroDayTimeline?.segments?.length) return '';

    const merged: Array<{ startMin: number; endMin: number; quality: string; label: string }> = [];
    for (const seg of astroDayTimeline.segments) {
      const startMin = typeof seg?.startMin === 'number' ? seg.startMin : NaN;
      const endMin = typeof seg?.endMin === 'number' ? seg.endMin : NaN;
      const quality = typeof seg?.quality === 'string' ? seg.quality : '';
      const label = typeof seg?.choghadiyaLabel === 'string' ? seg.choghadiyaLabel : '';
      if (!Number.isFinite(startMin) || !Number.isFinite(endMin) || !quality) continue;
      const prev = merged[merged.length - 1];
      if (prev && prev.endMin === startMin && prev.quality === quality && prev.label === label) {
        prev.endMin = endMin;
      } else {
        merged.push({ startMin, endMin, quality, label });
      }
    }

    const lines = merged.slice(0, 40).map(s => {
      const range = `${formatTimelineMin(s.startMin)}–${formatTimelineMin(s.endMin)}`;
      const q = s.quality.charAt(0).toUpperCase() + s.quality.slice(1);
      const labelPart = s.label ? ` (${s.label})` : '';
      return `${range} ${q}${labelPart}`;
    });

    const modeLabel = astroTimelineMode === 'advanced' ? 'advanced' : 'basic';
    const dateLine = astroTimelineDate ? [`Date: ${astroTimelineDate}`] : [];
    return [`Mode: ${modeLabel}`, ...dateLine, ...lines].join('\n');
  }, [astroDayTimeline, astroTimelineDate, astroTimelineMode, formatTimelineMin]);

  const buildAstroTimelineDetailedSummary = useCallback((
    timeline: DayTimelinePayload | null | undefined,
    timelineDate?: string | null,
    timelineMode?: 'basic' | 'advanced',
  ) => {
    if (!timeline?.segments?.length) return '';

    const formatFactorNotes = (factors: any) => {
      if (!factors || typeof factors !== 'object') return '';

      const supports: string[] = [];
      const watches: string[] = [];

      for (const [key, label] of Object.entries(ASTRO_TIMELINE_FACTOR_LABELS)) {
        const value = factors[key];
        if (value === true) {
          supports.push(label);
        } else if (value === false && ASTRO_TIMELINE_WATCH_FACTOR_KEYS.has(key)) {
          watches.push(label);
        }
      }

      const category = typeof factors.nakshatra_category_type === 'string'
        ? factors.nakshatra_category_type.trim()
        : '';
      const parts: string[] = [];
      if (category) parts.push(`nakshatra category: ${category}`);
      if (supports.length) parts.push(`supports: ${supports.slice(0, 8).join(', ')}`);
      if (watches.length) parts.push(`watch: ${watches.slice(0, 8).join(', ')}`);
      return parts.join(' | ');
    };

    const lines: string[] = [
      `Mode: ${timelineMode === 'advanced' ? 'advanced' : 'basic'}`,
    ];
    if (timelineDate) lines.push(`Date: ${timelineDate}`);
    if (timeline.sunrise) lines.push(`Sunrise: ${timeline.sunrise}`);
    if (timeline.sunset) lines.push(`Sunset: ${timeline.sunset}`);
    if (timeline.tridyusprik) {
      lines.push('Tridyusprik: active');
    }

    lines.push('Segments:');
    for (const seg of timeline.segments.slice(0, 40)) {
      const startMin = typeof seg?.startMin === 'number' ? seg.startMin : NaN;
      const endMin = typeof seg?.endMin === 'number' ? seg.endMin : NaN;
      if (!Number.isFinite(startMin) || !Number.isFinite(endMin)) continue;
      const range = `${formatTimelineMin(startMin)}–${formatTimelineMin(endMin)}`;
      const quality = titleCaseTimelineQuality(seg.quality);
      const label = typeof seg.choghadiyaLabel === 'string' && seg.choghadiyaLabel.trim()
        ? ` (${seg.choghadiyaLabel.trim()})`
        : '';
      const factorNotes = timelineMode === 'advanced' ? formatFactorNotes(seg.factors) : '';
      lines.push(`- ${range}: ${quality}${label}${factorNotes ? ` | ${factorNotes}` : ''}`);
    }

    const overlays = Array.isArray(timeline.overlays) ? timeline.overlays : [];
    const overlayLines = overlays
      .slice(0, 24)
      .map((overlay) => {
        const startMin = typeof overlay?.startMin === 'number' ? overlay.startMin : NaN;
        const endMin = typeof overlay?.endMin === 'number' ? overlay.endMin : NaN;
        const label = typeof overlay?.label === 'string' ? overlay.label.trim() : '';
        if (!Number.isFinite(startMin) || !Number.isFinite(endMin) || !label) return '';
        const range = `${formatTimelineMin(startMin)}–${formatTimelineMin(endMin)}`;
        const type = typeof overlay.type === 'string' && overlay.type.trim() ? ` (${overlay.type.trim()})` : '';
        return `- ${label}: ${range}${type}`;
      })
      .filter(Boolean);
    if (overlayLines.length) {
      lines.push('Special periods / overlays:');
      lines.push(...overlayLines);
    }

    const pins = Array.isArray(timeline.pins) ? timeline.pins : [];
    const pinLines = pins
      .slice(0, 16)
      .map((pin) => {
        const atMin = typeof pin?.atMin === 'number' ? pin.atMin : NaN;
        const label = typeof pin?.label === 'string' ? pin.label.trim() : '';
        if (!Number.isFinite(atMin) || !label) return '';
        return `- ${label}: ${formatTimelineMin(atMin)}`;
      })
      .filter(Boolean);
    if (pinLines.length) {
      lines.push('Anchor muhurtas / pins:');
      lines.push(...pinLines);
    }

    return lines.join('\n');
  }, [formatTimelineMin]);

  useEffect(() => {
    if (!userId || !isPersonalHoroscopeChat || !userReportStatus.has_horoscope) return;

    const subjectId =
      getThreadSubjectMeta(activeThreadIdRef.current || ThreadId || null).active_subject_id ||
      userReportStatus.default_subject_id ||
      'self';
    const requestToken = ++natalChartHydrationTokenRef.current;
    let cancelled = false;
    let hasCachedChart = false;

    // Paint a subject-scoped local copy immediately when available. The old
    // cache key was per account only, so switching profiles could show the
    // previous person's chart. Do not adopt that ambiguous key here; R2 is the
    // authority and will repopulate this subject-specific cache below.
    try {
      const raw = localStorage.getItem(getAstroChartsStorageKey(subjectId));
      const parsed = raw ? JSON.parse(raw) : null;
      const north =
        parsed && typeof parsed.north_indian_data_uri === 'string'
          ? parsed.north_indian_data_uri
          : undefined;
      const south =
        parsed && typeof parsed.south_indian_data_uri === 'string'
          ? parsed.south_indian_data_uri
          : undefined;
      if (north && south) {
        hasCachedChart = true;
        setNatalChartSvgs({ north_indian_data_uri: north, south_indian_data_uri: south });
      } else {
        setNatalChartSvgs(null);
      }
    } catch {
      setNatalChartSvgs(null);
    }

    void (async () => {
      try {
        const headers = (await getSecureHeaders()) as Record<string, string>;
        if (cancelled || requestToken !== natalChartHydrationTokenRef.current) return;
        const API_BASE_URL = import.meta.env.VITE_APP_SERVER;
        const response = await axios.get(`${API_BASE_URL}/api/astrology/report/natal`, {
          params: { subject_id: subjectId, t: Date.now() },
          headers,
        });
        if (cancelled || requestToken !== natalChartHydrationTokenRef.current) return;

        const report = response.data;
        const charts = report?.natal_chart_svgs;
        const north =
          typeof charts?.north_indian_data_uri === 'string'
            ? charts.north_indian_data_uri
            : undefined;
        const south =
          typeof charts?.south_indian_data_uri === 'string'
            ? charts.south_indian_data_uri
            : undefined;
        if (!north || !south) {
          throw new Error('Saved natal report has no chart images');
        }

        const normalizedCharts = {
          north_indian_data_uri: north,
          south_indian_data_uri: south,
        };
        setNatalChartSvgs(normalizedCharts);
        try {
          localStorage.setItem(
            getAstroChartsStorageKey(subjectId),
            JSON.stringify(normalizedCharts),
          );
        } catch {
          // The server response remains authoritative if browser storage is unavailable.
        }

        // Cross-device hydration should restore the small birth-details
        // snapshot too; Dinacharya export and profile labels consume it later.
        const birth = report?.metadata?.birth_details;
        const subject = report?.subject || report?.metadata?.subject || {};
        if (birth && typeof birth === 'object') {
          const rawTime = String(birth.time_of_birth || '');
          const timeParts = rawTime.split(':');
          const snapshot: AstroBirthDetailsSnapshot = {
            subjectId,
            displayName: subject.display_name || birth.name || undefined,
            relation: subject.relation ?? null,
            name: birth.name || subject.display_name || 'Unknown',
            birthDate: birth.date_of_birth || 'Unknown',
            birthTime:
              timeParts.length >= 2 ? `${timeParts[0]}:${timeParts[1]}` : rawTime || 'Unknown',
            location: birth.place_name || 'Unknown',
          };
          setAstroBirthDetailsBySubject((current) => ({ ...current, [subjectId]: snapshot }));
          try {
            localStorage.setItem(
              getAstroBirthDetailsStorageKey(subjectId),
              JSON.stringify(snapshot),
            );
          } catch {
            // Birth details are an optional local convenience cache.
          }
        }
      } catch (error) {
        if (!cancelled && requestToken === natalChartHydrationTokenRef.current) {
          if (!hasCachedChart) setNatalChartSvgs(null);
          console.error('Failed to hydrate saved natal chart', error);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    ThreadId,
    getAstroBirthDetailsStorageKey,
    getAstroChartsStorageKey,
    getThreadSubjectMeta,
    isPersonalHoroscopeChat,
    userId,
    userReportStatus.default_subject_id,
    userReportStatus.has_horoscope,
  ]);

  const [tooltipsEnabled, setTooltipsEnabled] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return true;
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

    const mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    const handleChange = (e: MediaQueryListEvent) => setTooltipsEnabled(e.matches);

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handleChange);
      return () => mq.removeEventListener('change', handleChange);
    }

    mq.addListener(handleChange);
    return () => mq.removeListener(handleChange);
  }, []);

  const {
    dismissReminder: dismissAudioModeReminder,
    recordAnswer: recordAudioModeAnswer,
    reminderStep: audioModeReminderStep,
    showReminder: showAudioModeReminder,
  } = useAudioModeReminder(isListeningMode);

  const canShowAudioModeReminder =
    isChatOpen &&
    tooltipsEnabled &&
    !showPersonalMode &&
    !showCompatibilityMode &&
    !showAstroTour &&
    !showAstroFirstTimeDemo &&
    !isRateLimitExceeded &&
    !tokenlimitReached;
  const canShowAudioModeReminderRef = useRef(canShowAudioModeReminder);

  useEffect(() => {
    canShowAudioModeReminderRef.current = canShowAudioModeReminder;
    if (!canShowAudioModeReminder) {
      dismissAudioModeReminder();
    }
  }, [canShowAudioModeReminder, dismissAudioModeReminder]);

  const closeShareMenu = useCallback(() => {
    setOpenShareMenuIndex(null);
  }, []);

  const recordSafeAnswerShare = useCallback((method: 'whatsapp' | 'x' | 'facebook' | 'telegram') => {
    trackEvent('share_click', {
      category: 'Sharing',
      method,
      source_surface: 'answer_menu',
      shared_object: 'generic_site_fallback',
      ui_language: i18n.language,
      device_type: getDeviceType(),
      success_state: 'attempted',
      utm_campaign: 'answer_menu_fallback',
    });
  }, [getDeviceType, i18n.language]);

  const toggleShareMenu = useCallback((index: number) => {
    setOpenShareMenuIndex((current) => (current === index ? null : index));
  }, []);

  useEffect(() => {
    if (openShareMenuIndex === null) return;

    const handlePointerDownOutside = (event: PointerEvent) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest('[data-share-menu-root="true"]')) return;
      setOpenShareMenuIndex(null);
    };

    document.addEventListener('pointerdown', handlePointerDownOutside);
    return () => document.removeEventListener('pointerdown', handlePointerDownOutside);
  }, [openShareMenuIndex]);

  useEffect(() => {
    if (openShareMenuIndex === null) return;

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpenShareMenuIndex(null);
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [openShareMenuIndex]);

  useEffect(() => {
    const mode =
      isChatOpen || isPersonalHoroscopeChat || showPersonalMode || showCompatibilityMode
        ? 'conversation'
        : 'main';
    window.dispatchEvent(new CustomEvent('sarvalok_chat_view_mode', { detail: { mode } }));
  }, [isChatOpen, isPersonalHoroscopeChat, showCompatibilityMode, showPersonalMode]);

  const persistModeThreadId = useCallback((threadId: string, personalMode: boolean) => {
    try {
      const key = personalMode ? getAstroThreadStorageKey() : getGeneralThreadStorageKey();
      localStorage.setItem(key, threadId);
    } catch {}
  }, [getAstroThreadStorageKey, getGeneralThreadStorageKey]);

  const getThreadPersonalMode = useCallback((threadId: string) => {
    const found = threads?.find((t: any) => String(t?.id) === String(threadId));
    const fromMeta = found?.personal_mode;
    if (typeof fromMeta === 'boolean') return fromMeta;
    const uid = auth.currentUser?.uid || userId;
    try {
      const keyAstro = uid ? `thread_id_astro_${uid}` : 'thread_id_astro';
      const storedAstro = localStorage.getItem(keyAstro);
      return !!storedAstro && String(storedAstro) === String(threadId);
    } catch {
      return false;
    }
  }, [threads, userId]);

  const getThreadMetaCacheKey = useCallback((uid: string) => `thread_meta_${uid}`, []);

  const readThreadMetaCache = useCallback((uid: string) => {
    try {
      const raw = localStorage.getItem(getThreadMetaCacheKey(uid));
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      const items = Array.isArray(parsed?.threads) ? parsed.threads : null;
      if (!items) return null;
      return { threads: items, fetchedAt: Number(parsed?.fetchedAt) || 0 };
    } catch {
      return null;
    }
  }, [getThreadMetaCacheKey]);

  const writeThreadMetaCache = useCallback((uid: string, items: any[]) => {
    try {
      localStorage.setItem(getThreadMetaCacheKey(uid), JSON.stringify({ threads: items, fetchedAt: Date.now() }));
    } catch {}
  }, [getThreadMetaCacheKey]);

  const clearThreadIdFromUrl = useCallback(() => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete('id');
    currentUrl.searchParams.delete('new');
    window.history.replaceState({}, document.title, currentUrl.toString());
  }, []);

  const returnToMainChat = useCallback((opts?: { clearCompatibility?: boolean }) => {
    astroNavTokenRef.current += 1;
    compatibilityNavTokenRef.current += 1;
    threadMessagesTokenRef.current += 1;
    sendMessageTokenRef.current += 1;
    exploreTopicsTokenRef.current += 1;
    sendMessageAbortControllerRef.current?.abort();
    sendMessageAbortControllerRef.current = null;
    const clearCompatibility = opts?.clearCompatibility ?? true;
    setShowPersonalMode(false);
    setShowCompatibilityMode(false);
    if (clearCompatibility) setCompatibilityResult(null);
    setIsCompatibilityLoading(false);
    setIsThreadMessagesLoading(false);
    setLoadingThreadId(null);
    setLoading(false);
    setIsStreaming(false);
    setIsDinacharyaGenerating(false);
    setIsPersonalHoroscopeChat(false);
	                              setAstroDayTimeline(null);
	                              setAstroTimelineDate('');
	                              setAstroTimelinePickError(null);
	                              setShowDayTimeline(true);
    setThreadId(undefined);
    activeThreadIdRef.current = undefined;
    setChatHistory([]);
    setIsChatOpen(false);
    clearThreadIdFromUrl();
  }, [clearThreadIdFromUrl]);

  useEffect(() => {
    const handler = () => {
      if (isPersonalHoroscopeChat || showPersonalMode || showCompatibilityMode) {
        returnToMainChat();
      }
    };
    window.addEventListener('sarvalok_consult_main_chat', handler);
    return () => window.removeEventListener('sarvalok_consult_main_chat', handler);
  }, [isPersonalHoroscopeChat, returnToMainChat, showCompatibilityMode, showPersonalMode]);

  const transformThreadMessages = useCallback((messages: any[], personalMode: boolean): any[] => {
    return messages?.flatMap((m: any) => {
      const turnIndex = typeof m.turnIndex === 'number' ? m.turnIndex : undefined;
      const messageId = typeof m.messageId === 'string' ? m.messageId : undefined;
      return [
      { text: m.question, isUser: true, isLoading: false, footnotes: {}, personalMode, turnIndex, messageId, bubbleKind: 'question' as const },
      {
        text: m.text,
        isUser: false,
        isLoading: false,
        footnotes: m.footnotes || {},
        personalMode,
        turnIndex,
        messageId,
        bubbleKind: 'answer' as const,
        isDinacharya: Boolean(m.is_dinacharya),
        dinacharyaGeneratedForDate: m.dinacharya_generated_for_date || null,
        staticDinacharyaLibraryVersion: m.static_dinacharya_library_version || null,
        dinacharyaSubjectDisplayName: m.dinacharya_subject_display_name || null,
        dinacharyaBirthDetails: m.dinacharya_birth_details || null,
        dinacharyaTimelinePayload: m.dinacharya_timeline_payload || null,
        dinacharyaTimelineMode: m.dinacharya_timeline_mode || null,
        dinacharyaTimelineDate: m.dinacharya_timeline_date || null,
      },
    ];
    }) || [];
  }, []);

  // Storage v2: a legacy (pre-v2) thread is no longer served. Drop the user to
  // a fresh blank chat with a gentle notice (no legacy fallback).
  const handleOldHistoryUnavailable = useCallback((detail?: string) => {
    toast.info(detail || 'Sarvalok chat history has moved to a new version.', { position: 'bottom-right' });
    const uid = auth.currentUser?.uid || userId;
    const staleId = String(activeThreadIdRef.current || '');
    setChatHistory([]);
    setHasMoreOlderMessages(false);
    setOldestTurnIndex(null);
    setThreadId('');
    activeThreadIdRef.current = '';
    try {
      localStorage.removeItem('thread_id');
      // Also drop the mode-specific keys when they point at the stale thread,
      // so the next app open doesn't auto-resume a dead (pre-v2) thread.
      const keyGeneral = uid ? `thread_id_general_${uid}` : 'thread_id_general';
      const keyAstro = uid ? `thread_id_astro_${uid}` : 'thread_id_astro';
      if (staleId && localStorage.getItem(keyGeneral) === staleId) localStorage.removeItem(keyGeneral);
      if (staleId && localStorage.getItem(keyAstro) === staleId) localStorage.removeItem(keyAstro);
    } catch { /* ignore */ }
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('id');
      window.history.replaceState({}, document.title, url.toString());
    } catch { /* ignore */ }
    setIsChatOpen(false);
  }, [userId]);

  const fetchAndSetThreadMessages = useCallback(async (threadId: string, uid: string, personalMode: boolean) => {
    const token = threadMessagesTokenRef.current + 1;
    threadMessagesTokenRef.current = token;
    setIsThreadMessagesLoading(true);
    setLoadingThreadId(threadId);
    setChatHistory([]);
    setHasMoreOlderMessages(false);
    setOldestTurnIndex(null);
    try {
      // Latest page only; older turns lazy-load on scroll-up.
      const res = await getThreadMessages(threadId, uid, { limit: THREAD_PAGE_SIZE });
      if (!isMountedRef.current) return;
      if (threadMessagesTokenRef.current !== token) return;
      if (activeThreadIdRef.current !== threadId) return;
      if (res?.old_history_unavailable) {
        handleOldHistoryUnavailable(res?.detail);
        return;
      }
      const messages = res?.messages || [];
      setChatHistory(transformThreadMessages(messages, personalMode));
      setHasMoreOlderMessages(Boolean(res?.has_more_older));
      setOldestTurnIndex(
        typeof res?.oldest_turn_index === 'number' ? res.oldest_turn_index : null,
      );
    } catch (error) {
      if (!isMountedRef.current) return;
      if (threadMessagesTokenRef.current !== token) return;
      if (activeThreadIdRef.current !== threadId) return;
      if (isUsageLimitError(error)) {
        openUsageLimitModal(error);
      }
      setChatHistory([]);
    } finally {
      if (
        isMountedRef.current &&
        threadMessagesTokenRef.current === token &&
        activeThreadIdRef.current === threadId
      ) {
        setIsThreadMessagesLoading(false);
        setLoadingThreadId(null);
      }
    }
  }, [transformThreadMessages, handleOldHistoryUnavailable]);

  const selectThread = useCallback(async (threadId: string, opts?: { personalMode?: boolean; persist?: boolean; updateUrl?: boolean }) => {
    const personalMode = opts?.personalMode ?? getThreadPersonalMode(threadId);
    const persist = opts?.persist ?? true;
    const updateUrl = opts?.updateUrl ?? true;
    const preservePendingAstroSummary = personalMode && pendingAstroInitialMessageRef.current;

    setThreadId(threadId);
    activeThreadIdRef.current = threadId;
    // Persist the selection only AFTER it's confirmed present in v2 metadata
    // (in the branches below), so a hidden/legacy/absent thread is never
    // remembered across reloads.

    if (updateUrl) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('id', threadId);
      currentUrl.searchParams.delete('new');
      window.history.pushState({}, document.title, currentUrl.toString());
    }

    const effectiveUserId = auth.currentUser?.uid || userId;
    const found = threads?.find((t: any) => t.id === threadId);
    if (found) {
      try { localStorage.setItem('thread_id', threadId); } catch { /* ignore */ }
      if (persist) persistModeThreadId(threadId, personalMode);
      const messageCount = Number(found?.message_count) || 0;
      setIsChatOpen(personalMode ? true : messageCount > 0);
      if (messageCount > 0 && effectiveUserId) {
        await fetchAndSetThreadMessages(threadId, effectiveUserId, personalMode);
      } else {
        if (!preservePendingAstroSummary) setChatHistory([]);
      }
      return;
    }

    try {
      if (!effectiveUserId) {
        if (!preservePendingAstroSummary) setChatHistory([]);
        setIsChatOpen(personalMode ? true : false);
        return;
      }

      const refreshed = await getUserThreadsMetadata(effectiveUserId);
      const refreshedThreads = refreshed?.threads || [];
      if (!isMountedRef.current) return;
      if (activeThreadIdRef.current !== threadId) return;
      setThreads(refreshedThreads);
      writeThreadMetaCache(effectiveUserId, refreshedThreads);
      const foundAfterRefresh = refreshedThreads.find((t: any) => t.id === threadId);
      if (foundAfterRefresh) {
        try { localStorage.setItem('thread_id', threadId); } catch { /* ignore */ }
        if (persist) persistModeThreadId(threadId, personalMode);
        const messageCount = Number(foundAfterRefresh?.message_count) || 0;
        setIsChatOpen(personalMode ? true : messageCount > 0);
        if (messageCount > 0) {
          await fetchAndSetThreadMessages(threadId, effectiveUserId, personalMode);
        } else {
          if (!preservePendingAstroSummary) setChatHistory([]);
        }
      } else {
        // Not in v2 metadata (hidden legacy / deleted) — don't keep it selected
        // or persisted; drop to a fresh chat so the next reload starts clean.
        setThreadId('');
        activeThreadIdRef.current = '';
        try {
          localStorage.removeItem('thread_id');
          const kg = `thread_id_general_${effectiveUserId}`;
          const ka = `thread_id_astro_${effectiveUserId}`;
          if (localStorage.getItem(kg) === threadId) localStorage.removeItem(kg);
          if (localStorage.getItem(ka) === threadId) localStorage.removeItem(ka);
        } catch { /* ignore */ }
        if (!preservePendingAstroSummary) setChatHistory([]);
        setIsChatOpen(personalMode ? true : false);
      }
    } catch (error) {
      if (!isMountedRef.current) return;
      if (activeThreadIdRef.current !== threadId) return;
      if (isUsageLimitError(error)) {
        openUsageLimitModal(error);
      }
      if (!preservePendingAstroSummary) setChatHistory([]);
      setIsChatOpen(personalMode ? true : false);
    }
  }, [fetchAndSetThreadMessages, getThreadPersonalMode, pendingAstroInitialMessageRef, persistModeThreadId, threads, userId, writeThreadMetaCache]);

  const tryScrollToMessageBlock = useCallback((messageIndex: number, behavior: ScrollBehavior = 'smooth') => {
    const anchor = document.getElementById(`message-block-${messageIndex}`);
    if (!anchor) return false;
    anchor.scrollIntoView({ behavior, block: 'start' });
    return true;
  }, []);

  // v2: scroll by stable turnIndex (survives pagination), used for bookmark jumps.
  const tryScrollToTurn = useCallback((turnIndex: number, behavior: ScrollBehavior = 'smooth') => {
    const anchor = document.querySelector(`[data-turn-index="${turnIndex}"]`);
    if (!anchor) return false;
    (anchor as HTMLElement).scrollIntoView({ behavior, block: 'start' });
    return true;
  }, []);

  const openBookmark = useCallback(async (bm: BookmarkItem) => {
    const threadId = String(bm.threadId || '');
    const turnIndex = Number(bm.turnIndex);
    if (!threadId || !Number.isFinite(turnIndex)) return;
    const personalMode = getThreadPersonalMode(threadId);
    const uid = auth.currentUser?.uid || userId;
    await selectThread(threadId, { personalMode, persist: true });
    setIsSidebarOpen(false);
    // The bookmarked turn may be older than the latest page — load a window
    // centred on it so the target is in memory before we scroll.
    if (uid) {
      try {
        const res = await getThreadMessages(threadId, uid, {
          around_turn_index: turnIndex,
          limit: THREAD_PAGE_SIZE,
        });
        if (res?.old_history_unavailable) {
          handleOldHistoryUnavailable(res?.detail);
          return;
        }
        if (isMountedRef.current && activeThreadIdRef.current === threadId) {
          setChatHistory(transformThreadMessages(res?.messages || [], personalMode));
          setHasMoreOlderMessages(Boolean(res?.has_more_older));
          setOldestTurnIndex(
            typeof res?.oldest_turn_index === 'number' ? res.oldest_turn_index : null,
          );
        }
      } catch {
        /* fall back to whatever selectThread loaded */
      }
    }
    let attempts = 0;
    const maxAttempts = 30;
    if (bookmarkScrollIntervalRef.current != null) {
      window.clearInterval(bookmarkScrollIntervalRef.current);
      bookmarkScrollIntervalRef.current = null;
    }
    const intervalId = window.setInterval(() => {
      attempts += 1;
      const scrolled = tryScrollToTurn(turnIndex, attempts === 1 ? 'auto' : 'smooth');
      if (scrolled || attempts >= maxAttempts) {
        window.clearInterval(intervalId);
        if (bookmarkScrollIntervalRef.current === intervalId) {
          bookmarkScrollIntervalRef.current = null;
        }
        if (!scrolled) {
          if (!isMountedRef.current) return;
          setBookmarkPreview(bm);
          toast.info('Showing saved answer preview', { position: 'bottom-right' });
        }
      }
    }, 100);
    bookmarkScrollIntervalRef.current = intervalId;
  }, [getThreadPersonalMode, selectThread, tryScrollToTurn, transformThreadMessages, handleOldHistoryUnavailable, userId]);

  // Lazy-load the previous page of turns when the user scrolls near the top,
  // preserving the viewport so it doesn't jump after older bubbles prepend.
  const loadOlderThreadMessages = useCallback(async () => {
    if (isOlderMessagesLoading || !hasMoreOlderMessages || oldestTurnIndex == null) return;
    const threadId = String(activeThreadIdRef.current || ThreadId || '');
    const uid = auth.currentUser?.uid || userId;
    if (!threadId || !uid) return;
    const scroller = scrollContainerRef.current;
    const prevScrollHeight = scroller?.scrollHeight ?? 0;
    const prevScrollTop = scroller?.scrollTop ?? 0;
    setIsOlderMessagesLoading(true);
    try {
      const personalMode = getThreadPersonalMode(threadId);
      const res = await getThreadMessages(threadId, uid, {
        before_turn_index: oldestTurnIndex,
        limit: THREAD_PAGE_SIZE,
      });
      if (res?.old_history_unavailable) {
        handleOldHistoryUnavailable(res?.detail);
        return;
      }
      if (!isMountedRef.current || activeThreadIdRef.current !== threadId) return;
      const older = transformThreadMessages(res?.messages || [], personalMode);
      if (older.length > 0) {
        setChatHistory(prev => [...older, ...prev]);
        setOldestTurnIndex(
          typeof res?.oldest_turn_index === 'number' ? res.oldest_turn_index : oldestTurnIndex,
        );
        setHasMoreOlderMessages(Boolean(res?.has_more_older));
        // Double rAF: wait for the prepended bubbles to lay out, then restore
        // the user's scroll anchor (newHeight - oldHeight + oldTop).
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const s = scrollContainerRef.current;
            if (s) s.scrollTop = s.scrollHeight - prevScrollHeight + prevScrollTop;
          });
        });
      } else {
        setHasMoreOlderMessages(false);
      }
    } catch {
      /* keep what we have */
    } finally {
      if (isMountedRef.current) setIsOlderMessagesLoading(false);
    }
  }, [isOlderMessagesLoading, hasMoreOlderMessages, oldestTurnIndex, ThreadId, userId, getThreadPersonalMode, transformThreadMessages, handleOldHistoryUnavailable]);

  const handleMessagesScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
    if (e.currentTarget.scrollTop < 120) {
      void loadOlderThreadMessages();
    }
  }, [loadOlderThreadMessages]);

  const createAndSelectThread = useCallback(async (opts: {
    personalMode: boolean;
    guard?: { token: number; ref: React.MutableRefObject<number> };
    subjectMeta?: {
      active_subject_id: string;
      active_subject_mode?: 'single' | 'compat_pair';
      addressed_subject_id?: string | null;
      compat_subject_ids?: string[];
    };
  }) => {
    const user = auth.currentUser;
    if (!user) throw new Error('No authenticated user');

    const resolvedSubjectMeta = opts.subjectMeta || (
      opts.personalMode
        ? (pendingThreadSubjectRef.current || {
            active_subject_id: userReportStatus?.default_subject_id || 'self',
            active_subject_mode: 'single',
            addressed_subject_id: null,
            compat_subject_ids: [],
          })
        : {
            active_subject_id: 'self',
            active_subject_mode: 'single',
            addressed_subject_id: null,
            compat_subject_ids: [],
          }
    );

    const threadPayload = {
      user_id: user.uid,
      user_name: (user.displayName?.trim() ? user.displayName : user.email) || "",
      personal_mode: opts.personalMode,
      active_subject_id: resolvedSubjectMeta.active_subject_id || 'self',
      active_subject_mode: resolvedSubjectMeta.active_subject_mode || 'single',
      addressed_subject_id: resolvedSubjectMeta.addressed_subject_id ?? null,
      compat_subject_ids: resolvedSubjectMeta.compat_subject_ids || [],
    };

    const threadResult = await createChatThread(threadPayload);
    if (threadResult.status !== 200) throw new Error('Failed to create a new chat thread.');

    if (opts.guard && opts.guard.token !== opts.guard.ref.current) {
      return threadResult.id as string;
    }

    persistModeThreadId(threadResult.id, opts.personalMode);
    await selectThread(threadResult.id, { personalMode: opts.personalMode, persist: true });

    try {
      const refreshed = await getUserThreadsMetadata(user.uid);
      const refreshedThreads = refreshed?.threads || [];
      setThreads(refreshedThreads);
      writeThreadMetaCache(user.uid, refreshedThreads);
    } catch {}

    if (opts.personalMode) {
      pendingThreadSubjectRef.current = null;
    }

    return threadResult.id as string;
  }, [persistModeThreadId, selectThread, userReportStatus?.default_subject_id, writeThreadMetaCache]);

  const startNewGeneralChatThread = useCallback(async () => {
    astroNavTokenRef.current += 1;
    compatibilityNavTokenRef.current += 1;
    threadMessagesTokenRef.current += 1;
    sendMessageTokenRef.current += 1;
    exploreTopicsTokenRef.current += 1;
    sendMessageAbortControllerRef.current?.abort();
    sendMessageAbortControllerRef.current = null;
    setIsPersonalHoroscopeChat(false);
    setAstroDayTimeline(null);
    setAstroTimelineDate('');
    setShowDayTimeline(true);
    setIsListOpen(false);
    setIsSidebarOpen(false);
    setTokenLimitReached(false);
    setShowPersonalMode(false);
    setShowCompatibilityMode(false);
    setCompatibilityResult(null);
    setIsCompatibilityLoading(false);
    setChatHistory([]);
    setThinkingPanelOpen({});
    setMessage('');
    setIsThreadMessagesLoading(false);
    setLoadingThreadId(null);
    setLoading(false);
    setIsStreaming(false);
    setIsDinacharyaGenerating(false);
    setThreadId(undefined);
    activeThreadIdRef.current = undefined;
    setIsChatOpen(false);
    setPageLoading(true);
    try {
      const newThreadId = await createAndSelectThread({ personalMode: false });
      const next = new URLSearchParams(window.location.search);
      next.set('id', String(newThreadId));
      next.delete('new');
      setSearchParams(next, { replace: true });
      setIsChatOpen(false);
    } catch (error) {
      console.error('Error creating new chat thread:', error);
      if (isUsageLimitError(error)) {
        openUsageLimitModal(error);
      } else {
        toast.error(t('chat.create_failed'), { position: 'bottom-right' });
      }
    } finally {
      setPageLoading(false);
    }
  }, [createAndSelectThread, setSearchParams, t]);

  useEffect(() => {
    if (!userId) return;
    const params = new URLSearchParams(location.search);
    if (params.get('new') !== '1') return;
    if (Date.now() - newChatHandledAtRef.current < 3000) {
      params.delete('new');
      setSearchParams(params, { replace: true });
      return;
    }
    newChatHandledAtRef.current = Date.now();
    void startNewGeneralChatThread();
  }, [location.search, setSearchParams, startNewGeneralChatThread, userId]);

  const enterAstroMode = useCallback(async (opts?: { forceNewThread?: boolean }) => {
    const token = astroNavTokenRef.current;
    sendMessageTokenRef.current += 1;
    exploreTopicsTokenRef.current += 1;
    sendMessageAbortControllerRef.current?.abort();
    sendMessageAbortControllerRef.current = null;
    setLoading(false);
    setIsStreaming(false);
    if (!pendingAstroInitialMessageRef.current) setShowAstroConversationTip(false);
    setShowCompatibilityMode(false);
    setShowPersonalMode(false);

    if (!isPersonalHoroscopeChat && ThreadId) {
      persistModeThreadId(String(ThreadId), false);
    }

    const keyAstro = getAstroThreadStorageKey();
    if (opts?.forceNewThread) {
      try { localStorage.removeItem(keyAstro); } catch {}
    }

    const stored = localStorage.getItem(keyAstro);
    if (token !== astroNavTokenRef.current) return;

    setIsPersonalHoroscopeChat(true);
    setIsChatOpen(true);
    if (!pendingAstroInitialMessageRef.current) setChatHistory([]);
    if (token !== astroNavTokenRef.current) return;

    if (stored) {
      await selectThread(stored, { personalMode: true, persist: true });
      if (token !== astroNavTokenRef.current) return;
      setIsChatOpen(true);
      return;
    }

    await createAndSelectThread({ personalMode: true, guard: { token, ref: astroNavTokenRef } });
    if (token !== astroNavTokenRef.current) return;
    setIsChatOpen(true);
  }, [ThreadId, createAndSelectThread, getAstroThreadStorageKey, isPersonalHoroscopeChat, persistModeThreadId, selectThread]);
  enterAstroModeRef.current = enterAstroMode;

  const refreshGocharaAndHydrateTimeline = useCallback(async (
    token: number,
    options?: {
      modeOverride?: 'basic' | 'advanced';
      targetDate?: string;
      suppressSuccessToast?: boolean;
    },
  ) => {
    if (token !== astroNavTokenRef.current) return;
    const selectedTargetDate = options?.targetDate || astroTimelineDate || getClientLocalDateIso();
    const requestedIsToday = selectedTargetDate === getClientLocalDateIso();
    const requestedMode = options?.modeOverride ?? astroTimelineMode;
    const subjectMeta = getThreadSubjectMeta(activeThreadIdRef.current || ThreadId || null);
    const subjectId = subjectMeta.active_subject_id || 'self';
    const cached = astroTimelineCacheRef.current.get(getAstroTimelineCacheKey(subjectId, selectedTargetDate, requestedMode));
    setTimelineFetchFailed(false);
    setAstroTimelinePickError(null);

    if (cached?.timeline?.segments?.length) {
      setAstroDayTimeline(cached.timeline);
      setAstroTimelineDate(cached.date || selectedTargetDate);
      if (cached.mode !== astroTimelineMode) {
        setAstroTimelineMode(cached.mode);
      }
      if (options?.modeOverride || !cached.isToday) {
        setShowDayTimeline(true);
      } else {
        applyTimelineSeenGate(cached.date || getClientLocalDateIso());
      }
      return;
    }

    setIsRefreshingTransits(true);
    try {
      const headers = await getSecureHeaders();
      if (token !== astroNavTokenRef.current) { setIsRefreshingTransits(false); return; }
	      const API_BASE_URL = import.meta.env.VITE_APP_SERVER;
	      const res = await fetch(`${API_BASE_URL}/api/astrology/refresh-gochara`, {
	        method: 'POST',
	        headers,
	        cache: 'no-store',
	        body: JSON.stringify({
	          ...getClientTimezone(),
	          timeline_mode: requestedMode,
	          target_date: selectedTargetDate,
	          is_today: requestedIsToday,
              subject_id: subjectId,
	        }),
	      });

      if (!res.ok) {
        let detail = `HTTP error! status: ${res.status}`;
        const raw = await res.text();
        if (raw) {
          try {
            const data = JSON.parse(raw);
            if (data?.detail) detail = String(data.detail);
          } catch {
            detail = raw;
          }
        }
        throw new Error(detail);
      }

      const parsed = await res.json().catch(() => ({} as any));
      const status = typeof parsed?.status === 'string' ? parsed.status : 'refreshed';
      const date = typeof parsed?.date === 'string' ? parsed.date : selectedTargetDate;
      const responseIsToday = typeof parsed?.is_today === 'boolean' ? parsed.is_today : requestedIsToday;
      const responseMode = parsed?.timeline_mode === 'advanced' || parsed?.timeline_mode === 'basic'
        ? parsed.timeline_mode as 'basic' | 'advanced'
        : requestedMode;

      if (parsed?.day_timeline && parsed.day_timeline?.segments?.length > 0) {
        const timelineResult: CachedAstroTimeline = {
          timeline: parsed.day_timeline as DayTimelinePayload,
          date: date || selectedTargetDate,
          mode: responseMode,
          isToday: responseIsToday,
        };
        writeAstroTimelineCache(subjectId, timelineResult);
        setAstroDayTimeline(timelineResult.timeline);
        setAstroTimelineDate(timelineResult.date);

        if (responseMode !== astroTimelineMode) {
          setAstroTimelineMode(responseMode);
        }

        if (options?.modeOverride || !responseIsToday) {
          setShowDayTimeline(true);
        } else {
          applyTimelineSeenGate(date || getClientLocalDateIso());
        }

        if (!options?.suppressSuccessToast) {
          if (status === 'fresh') {
            toast.info(date ? `Transits are current for ${date}.` : `Transits are current.`);
          } else {
            toast.success(date ? `Transits updated — refreshed to ${date}.` : `Transits updated.`);
          }
        }
      } else {
        // API succeeded but returned no timeline data — treat as failure so retry UI shows
        console.warn("refresh-gochara returned no day_timeline segments", parsed);
        setTimelineFetchFailed(true);
        setAstroTimelinePickError(t('chat.day_quality.update_failed', 'Could not update day quality. Continuing with saved report.'));
      }
    } catch (e: any) {
      console.error("Error refreshing gochara", e);
      const detail = errorDetailText(e);
      if (isUsageLimitError(detail)) {
        openUsageLimitModal(detail);
        setTimelineFetchFailed(true);
        setAstroTimelinePickError(detail);
        return;
      }
      setTimelineFetchFailed(true);
      const message = detail || t('chat.day_quality.update_failed', 'Could not update day quality. Continuing with saved report.');
      setAstroTimelinePickError(message);
      toast.error(t('chat.day_quality.update_failed', 'Could not update day quality. Continuing with saved report.'));
    } finally {
      if (token === astroNavTokenRef.current) {
        setIsRefreshingTransits(false);
      }
    }
	  }, [ThreadId, applyTimelineSeenGate, astroTimelineDate, astroTimelineMode, getAstroTimelineCacheKey, getThreadSubjectMeta, t, writeAstroTimelineCache]);

  const fetchAstroTimelineForPrompt = useCallback(async (
    options: {
      mode: 'basic' | 'advanced';
      targetDate?: string | null;
      threadId?: string | null;
    },
  ): Promise<{
    timeline: DayTimelinePayload;
    date: string;
    mode: 'basic' | 'advanced';
    isToday: boolean;
  } | null> => {
    const selectedTargetDate = options.targetDate || astroTimelineDate || getClientLocalDateIso();
    const requestedIsToday = selectedTargetDate === getClientLocalDateIso();
    const subjectMeta = getThreadSubjectMeta(options.threadId || activeThreadIdRef.current || ThreadId || null);
    const subjectId = subjectMeta.active_subject_id || 'self';
    const cached = astroTimelineCacheRef.current.get(getAstroTimelineCacheKey(subjectId, selectedTargetDate, options.mode));
    if (cached?.timeline?.segments?.length) {
      return cached;
    }

    const headers = await getSecureHeaders();
    const API_BASE_URL = import.meta.env.VITE_APP_SERVER;

    const res = await fetch(`${API_BASE_URL}/api/astrology/refresh-gochara`, {
      method: 'POST',
      headers,
      cache: 'no-store',
      body: JSON.stringify({
        ...getClientTimezone(),
        timeline_mode: options.mode,
        target_date: selectedTargetDate,
        is_today: requestedIsToday,
        prompt_only: true,
        subject_id: subjectId,
      }),
    });

    if (!res.ok) {
      let detail = `HTTP error! status: ${res.status}`;
      const raw = await res.text();
      if (raw) {
        try {
          const data = JSON.parse(raw);
          if (data?.detail) detail = String(data.detail);
        } catch {
          detail = raw;
        }
      }
      throw new Error(detail);
    }

    const parsed = await res.json().catch(() => ({} as any));
    if (!parsed?.day_timeline?.segments?.length) return null;

    const date = typeof parsed?.date === 'string' ? parsed.date : selectedTargetDate;
    const mode = parsed?.timeline_mode === 'basic' || parsed?.timeline_mode === 'advanced'
      ? parsed.timeline_mode as 'basic' | 'advanced'
      : options.mode;
    const isToday = typeof parsed?.is_today === 'boolean' ? parsed.is_today : requestedIsToday;

    const timelineResult: CachedAstroTimeline = {
      timeline: parsed.day_timeline as DayTimelinePayload,
      date,
      mode,
      isToday,
    };
    writeAstroTimelineCache(subjectId, timelineResult);
    return timelineResult;
  }, [ThreadId, astroTimelineDate, getAstroTimelineCacheKey, getThreadSubjectMeta, writeAstroTimelineCache]);

  const ensureTodayTimelineVisible = useCallback(async (token: number) => {
    const today = getClientLocalDateIso();
    const hasLoadedTodayTimeline = astroTimelineDate === today && Boolean(astroDayTimeline?.segments?.length);
    if (!hasSeenTimelineToday(today) || !hasLoadedTodayTimeline) {
      await refreshGocharaAndHydrateTimeline(token, { targetDate: today });
      return;
    }
    setShowDayTimeline(true);
  }, [astroDayTimeline, astroTimelineDate, hasSeenTimelineToday, refreshGocharaAndHydrateTimeline]);

  const handleWelcomeAstroRibbonActivate = useCallback(async () => {
    const token = astroNavTokenRef.current;
    dismissWelcomeAstroRibbon();
    if (userReportStatus.has_horoscope) {
      await enterAstroMode();
      if (token !== astroNavTokenRef.current) return;
      toast.info(t('chat.astro.resuming_horoscope'));
      await ensureTodayTimelineVisible(token);
      return;
    }

    setPersonalModeSource('welcome');
    setShowPersonalMode(true);
    setShowCompatibilityMode(false);
  }, [
    dismissWelcomeAstroRibbon,
    enterAstroMode,
    ensureTodayTimelineVisible,
    t,
    userReportStatus.has_horoscope,
  ]);

  const openAstroModeFromNudge = useCallback(async () => {
    const token = astroNavTokenRef.current;
    hideAstroNudge();
    sendMessageAbortControllerRef.current?.abort();
    sendMessageAbortControllerRef.current = null;
    setLoading(false);
    setIsStreaming(false);

    trackEvent('astro_nudge_cta_clicked', {
      category: 'Chat',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      has_horoscope: userReportStatus.has_horoscope,
      thread_id: activeThreadIdRef.current || ThreadId || null,
      onboarding: isAstroNudgeOnboarding,
    });

    if (userReportStatus.has_horoscope) {
      await enterAstroMode();
      if (token !== astroNavTokenRef.current) return;
      toast.info(t('chat.astro.resuming_horoscope'));
      await ensureTodayTimelineVisible(token);
      return;
    }

    setPersonalModeSource('welcome');
    setShowPersonalMode(true);
    setShowCompatibilityMode(false);
  }, [
    ThreadId,
    enterAstroMode,
    ensureTodayTimelineVisible,
    getDeviceType,
    hideAstroNudge,
    i18n.language,
    isAstroNudgeOnboarding,
    t,
    userReportStatus.has_horoscope,
  ]);

  useEffect(() => {
    if (adLandingHandledRef.current) return;
    const requestedMode = getAdModeFromUrl();
    const pendingMode = readPendingAdMode();
    const effectiveMode =
      requestedMode && requestedMode !== 'global-risk'
        ? requestedMode
        : pendingMode && pendingMode !== 'global-risk'
          ? pendingMode
          : null;

    // Persist any valid chat landing intent before auth redirects fire so the
    // login / verification round-trip keeps the campaign context.
    if (requestedMode && requestedMode !== 'global-risk' && !userId) {
      storePendingAdMode(requestedMode);
      return;
    }

    if (!effectiveMode || !userId || !reportStatusLoaded || pageloading) return;
    if (effectiveMode === 'astro' && !userReportStatus.has_horoscope && personalModeLoading) return;

    adLandingHandledRef.current = true;
    clearPendingAdMode();

    // Strip landing params from chat URLs once the authenticated destination is resolved.
    if (requestedMode) {
      try {
        const cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('mode');
        window.history.replaceState({}, document.title, cleanUrl.toString());
      } catch {}
    }

    if (effectiveMode !== 'astro') {
      return;
    }

    if (userReportStatus.has_horoscope) {
      void (async () => {
        const token = astroNavTokenRef.current;
        await enterAstroMode();
        if (token !== astroNavTokenRef.current) return;
        await ensureTodayTimelineVisible(token);
      })();
      return;
    }

    if (!hasUsedAstroDirectEntry()) {
      markAstroDirectEntryUsed();
      setPersonalModeSource('welcome');
      setShowCompatibilityMode(false);
      setShowAstroTour(false);
      setShowPersonalMode(true);
      return;
    }

    if (personalModeEnabled && shouldShowAstroTour()) {
      setPersonalModeSource('welcome');
      setShowCompatibilityMode(false);
      setShowPersonalMode(false);
      setIsChatOpen(false);
      setShowAstroTour(true);
      return;
    }

    setPersonalModeSource('welcome');
    setShowCompatibilityMode(false);
    setShowPersonalMode(true);
  }, [
    enterAstroMode,
    ensureTodayTimelineVisible,
    hasUsedAstroDirectEntry,
    markAstroDirectEntryUsed,
    pageloading,
    personalModeEnabled,
    personalModeLoading,
    reportStatusLoaded,
    shouldShowAstroTour,
    userId,
    userReportStatus.has_horoscope,
  ]);

  // Fetch user report status on load
  useEffect(() => {
    if (userId) {
        const fetchStatus = async () => {
            try {
                const API_BASE_URL = import.meta.env.VITE_APP_SERVER;
                // Send Firebase auth + App Check on this request. It is currently
                // the ONE astrology call the web made through bare `axios` with
                // no credentials. This web change must ship BEFORE the secured
                // backend route, while the old route safely ignores the headers.
                const headers = (await getSecureHeaders()) as Record<string, string>;
                const res = await axios.get(`${API_BASE_URL}/api/astrology/user-status/${userId}`, {
                  params: { t: Date.now() },
                  headers,
                });
                setUserReportStatus(res.data);
            } catch (e) {
                console.error("Error fetching user report status", e);
            } finally {
                setReportStatusLoaded(true);
            }
        };
        fetchStatus();
    }
  }, [userId, showPersonalMode, showCompatibilityMode]); // Re-fetch when modes close (implying potential updates)

  useEffect(() => {
    const uid = auth.currentUser?.uid || userId;
    if (!uid) return;
    if (memorySubjectsLoaded) return;
    let cancelled = false;
    (async () => {
      try {
        const result = await getMemory();
        const subjects = Array.isArray(result?.memory?.state?.subjects) ? result.memory.state.subjects : [];
        const health = result?.memory?.health;
        if (!cancelled) {
          setMemorySubjects(subjects);
          setMemorySubjectsLoaded(true);
        }
        if (health?.status === 'degraded') {
          const failureKey = String(health?.last_failure_at || 'unknown');
          const toastKey = `sarvalok_memory_health_notice_${uid}_${failureKey}`;
          let alreadyShown = false;
          try {
            alreadyShown = sessionStorage.getItem(toastKey) === '1';
          } catch {}
          if (!alreadyShown) {
            try {
              sessionStorage.setItem(toastKey, '1');
            } catch {}
            toast.info(health?.description || 'Personalization is temporarily limited. Chat still works normally.', { position: 'bottom-right' });
          }
        }
      } catch {
        if (!cancelled) {
          setMemorySubjects([]);
          setMemorySubjectsLoaded(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [memorySubjectsLoaded, userId]);

  const handleChartResult = async (data: any) => {
    setShowPersonalMode(false);
    const subject = data?.subject || data?.metadata?.subject || {};
    const nextSubjectId = subject?.id || 'self';
    const nextSubjectDisplayName = typeof subject?.display_name === 'string' ? subject.display_name : undefined;
    const nextSubjectRelation = typeof subject?.relation === 'string' ? subject.relation : null;
    setMemorySubjects((prev) => {
      const existing = Array.isArray(prev) ? prev : [];
      const existingIndex = existing.findIndex((s) => s?.id === nextSubjectId);
      const nextSubject = {
        id: nextSubjectId,
        kind: nextSubjectId === 'self' ? 'self' : 'other',
        display_name: nextSubjectDisplayName,
        relation: nextSubjectRelation,
      };

      if (existingIndex < 0) return [nextSubject, ...existing];

      const current = existing[existingIndex] || {};
      const updated = {
        ...current,
        display_name: nextSubjectDisplayName || current.display_name,
        relation: nextSubjectRelation ?? current.relation ?? null,
      };
      return [updated, ...existing.filter((_, index) => index !== existingIndex)];
    });
    pendingThreadSubjectRef.current = {
      active_subject_id: nextSubjectId,
      active_subject_mode: 'single',
      addressed_subject_id: null,
      compat_subject_ids: [],
    };
    setUserReportStatus((prev: any) => ({
      ...prev,
      has_horoscope: true,
      default_subject_id: nextSubjectId || prev?.default_subject_id || 'self',
    }));
    astroTimelineCacheRef.current.clear();
    setClickedAstroQuestions(new Set());
    setTimelineFetchFailed(false);
    setAstroTimelinePickError(null);
    const birth = data?.metadata?.birth_details || {};
    const name = birth?.name || data?.name || 'Unknown';
    const birthDate = birth?.date_of_birth || data?.birthDate || 'Unknown';
    const rawTime = birth?.time_of_birth || data?.birthTime || '';
    const timeDisplay = (() => {
      const parts = String(rawTime).split(':');
      if (parts.length >= 2) return `${parts[0]}:${parts[1]}`;
      return rawTime || 'Unknown';
    })();
    const locationName = birth?.place_name || data?.locationName || 'Unknown';
    const relationLabel = subject?.relation ? ` (${subject.relation})` : '';
    const birthDetailsSnapshot: AstroBirthDetailsSnapshot = {
      subjectId: nextSubjectId,
      displayName: nextSubjectDisplayName || name,
      relation: nextSubjectRelation,
      name,
      birthDate,
      birthTime: timeDisplay,
      location: locationName,
    };
    setAstroBirthDetailsBySubject((prev) => ({
      ...prev,
      [nextSubjectId || 'self']: birthDetailsSnapshot,
    }));
    try {
      localStorage.setItem(
        getAstroBirthDetailsStorageKey(nextSubjectId || 'self'),
        JSON.stringify(birthDetailsSnapshot)
      );
    } catch {}
    const charts = data?.natal_chart_svgs;
    setNatalChartSvgs(charts ?? null);
    try {
      if (charts) {
        localStorage.setItem(
          getAstroChartsStorageKey(nextSubjectId || 'self'),
          JSON.stringify(charts),
        );
      }
    } catch {}

    const gocharaReport = data?.gochara_report;
    const timelineDate = (gocharaReport?.date || getClientLocalDateIso()) as string;
    const dayTimeline = gocharaReport?.day_timeline;
    const hasServerTimeline = Boolean(dayTimeline?.segments?.length);
    if (hasServerTimeline) {
      const timelineMode = gocharaReport?.day_timeline_mode === 'advanced' ? 'advanced' : 'basic';
      const isTimelineToday = timelineDate === getClientLocalDateIso();
      const timelineResult: CachedAstroTimeline = {
        timeline: dayTimeline as DayTimelinePayload,
        date: timelineDate,
        mode: timelineMode,
        isToday: isTimelineToday,
      };
      writeAstroTimelineCache(nextSubjectId || 'self', timelineResult);
      setAstroDayTimeline(timelineResult.timeline);
      setAstroTimelineDate(timelineDate);
      setAstroTimelineMode(timelineMode);
      applyTimelineSeenGate(timelineDate);
    } else {
      setAstroDayTimeline(null);
      setAstroTimelineDate(timelineDate);
      setShowDayTimeline(true);
    }

    const summaryHeading = subject?.chart_for === 'other' ? `**${name}'s horoscope is ready.**` : `**Your horoscope is ready.**`;
    const summary = `${summaryHeading}  \n**Type a question below or choose a suggested question to begin.**  \nName: ${name}${relationLabel}\nBirth Date: ${birthDate}\nTime: ${timeDisplay}\nLocation: ${locationName}`;
    setChatHistory([{ text: summary, isUser: false, isLoading: false, footnotes: {} }]);
    setShowAstroConversationTip(true);
    pendingAstroInitialMessageRef.current = true;
    setIsPersonalHoroscopeChat(true);
    setIsChatOpen(true);
    const token = astroNavTokenRef.current;
    try {
      await enterAstroMode({ forceNewThread: true });
      if (!hasServerTimeline && token === astroNavTokenRef.current) {
        await refreshGocharaAndHydrateTimeline(token, { targetDate: getClientLocalDateIso() });
      }
    } finally {
      pendingAstroInitialMessageRef.current = false;
    }
  };

  const handleCompatibilityResult = (data: any) => {
    setCompatibilityResult(data);
    setUserReportStatus((prev: any) => ({ ...prev, has_compatibility: true }));
  };

  useEffect(() => {
    const arr = Array.isArray(personalAstroQuestions) ? [...personalAstroQuestions] : [];
    for (let i = arr.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    setShuffledAstroQuestions(arr);
  }, []);

  // ✅ ADD THESE TWO REFS FOR TEXTAREA RESIZING
  const welcomeTextareaRef = useRef<HTMLTextAreaElement>(null);
  const chatTextareaRef = useRef<HTMLTextAreaElement>(null);
  const chatInputRef = useRef<HTMLDivElement>(null);

  // New states for filters
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState<boolean>(false);
  const [availableFilters, setAvailableFilters] = useState<any>([]);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [isFastSearchGeneral, setIsFastSearchGeneral] = useState<boolean>(true);
  const [isFastSearchAstro, setIsFastSearchAstro] = useState<boolean>(true);
  const isFastSearch = isPersonalHoroscopeChat ? isFastSearchAstro : isFastSearchGeneral;

  const setIsFastSearch = useCallback((fast: boolean, opts?: { personalMode?: boolean }) => {
    const personalMode = opts?.personalMode ?? isPersonalHoroscopeChat;
    const key = personalMode ? 'isFastSearchAstro' : 'isFastSearchGeneral';
    if (personalMode) {
      setIsFastSearchAstro(fast);
    } else {
      setIsFastSearchGeneral(fast);
      localStorage.setItem('isFastSearch', JSON.stringify(fast));
    }
    localStorage.setItem(key, JSON.stringify(fast));
    if (fast) {
      setIsListeningMode(false);
      localStorage.setItem('isListeningMode', 'false');
    }
  }, [isPersonalHoroscopeChat]);

  const astroPlaceholders = useMemo(
    () => [
      "What should you know before starting your day? Ask the Grahas…",
      "Seek guidance on your Dharma, daily transits, or life decisions…",
      "Is this a good time for career changes?…",
      "Reflect on your day. Ask: 'Why was today challenging?'",
    ],
    [],
  );

  const astroFirstTimeDemoStrings = useMemo(
    () => ({
      userName: t('astro_first_demo.placeholder_name', 'Maya'),
      birthDate: t('astro_first_demo.placeholder_birth_date', '1986-05-11'),
      birthTime: t('astro_first_demo.placeholder_birth_time', '20:50'),
      tokensRemainingLabel: t('astro_first_demo.tokens_remaining', '6,000 tokens remaining'),
      hint: t('astro_first_demo.hint', 'Watch how to ask your chart'),
      callout: t('astro_first_demo.callout', 'Ask personalized questions'),
      placeholder: t('astro_first_demo.placeholder', 'Ask about your chart...'),
      answeringText: t('astro_first_demo.answering', 'Reading your Vedic chart...'),
      freePlanLabel: t('astro_first_demo.free_plan_label', 'Free Plan'),
      upgradeLabel: t('astro_first_demo.upgrade_label', t('astro_first_demo.upgrade', 'Upgrade')),
      guidanceLabel: t('astro_first_demo.guidance_label', t('astro_first_demo.guidance', 'Guidance')),
      horoscopeReadyTitle: t('astro_first_demo.horoscope_ready_title', 'Your horoscope is ready.'),
      horoscopeReadyLead: t('astro_first_demo.horoscope_ready_lead', 'Type a question below or choose a suggested question to begin.'),
      dayQualityTitle: t('astro_first_demo.day_quality_title', 'Personalized Day Quality'),
      dayQualitySubtitle: t('astro_first_demo.day_quality_subtitle', 'Your best hours to act today'),
      dayQualityMethod: t('astro_first_demo.day_quality_method', '8 factors - Personalised to your birth Nakshatra'),
      dayQualitySunriseSunset: t('astro_first_demo.day_quality_sunrise_sunset', 'Sunrise 05:55:07 - Sunset 18:32:10'),
      dateLabel: t('astro_first_demo.date_label', 'WEDNESDAY'),
      dateValue: t('astro_first_demo.date_value', '29 April 2026'),
      favorableLabel: t('astro_first_demo.favorable_label', 'FAVORABLE'),
      favorableWindow: t('astro_first_demo.favorable_window', '10:39 AM-12:13 PM'),
      nameLabel: t('astro_first_demo.name_label', 'Name'),
      birthDateLabel: t('astro_first_demo.birth_date_label', 'Birth Date'),
      birthTimeLabel: t('astro_first_demo.birth_time_label', 'Time'),
      closeDemoLabel: t('astro_first_demo.close_demo', 'Close demo'),
      demoLabel: t('astro_first_demo.demo_label', 'Demo · auto-closes in a few seconds · press Esc or click anywhere to skip'),
      demoLabelMobile: t('astro_first_demo.demo_label_mobile', 'Demo · tap anywhere to skip'),
      modeBasicLabel: t('astro_first_demo.mode_basic', 'Basic'),
      modeAdvancedLabel: t('astro_first_demo.mode_advanced', 'Advanced'),
      nowLabel: t('astro_first_demo.now_label', 'NOW'),
      abhijitMuhurtaLabel: t('astro_first_demo.abhijit_muhurta', 'Abhijit Muhurta'),
      godhuliMuhurtaLabel: t('astro_first_demo.godhuli_muhurta', 'Godhuli Muhurta'),
      brahmaMuhurtaLabel: t('astro_first_demo.brahma_muhurta', 'Brahma Muhurta'),
      nextDayLabel: t('astro_first_demo.next_day', 'next day'),
      favorableLegendLabel: t('day_quality.favorable', 'Favorable'),
      cautionLabel: t('day_quality.caution', 'Favorable with caution'),
      neutralLabel: t('day_quality.neutral', 'Neutral'),
      avoidLabel: t('day_quality.avoid', 'Avoid'),
      rahuKalaEtcLabel: t('astro_first_demo.rahu_kala_etc', 'Rahu Kala etc.'),
      mobileCoachTitle: t('astro_first_demo.mobile_coach_title', 'Ask your chart here'),
      mobileCoachText: t(
        'astro_first_demo.mobile_coach_text',
        'Career, love, timing, remedies, or your daily routine — type your question in the box below.',
      ),
      mobileCoachDismissLabel: t('astro_first_demo.mobile_coach_dismiss', 'Tap anywhere to continue'),
      heritageTabLabel: t('chat.mode_tabs.heritage', 'Heritage'),
      astroTabLabel: t('chat.mode_tabs.astro', 'Astro'),
      tabHighlightLabel: t(
        'astro_first_demo.tab_highlight_label',
        'Switch to Heritage for general text questions, then come back to your chart any time.',
      ),
      questions: [
        t('astro_first_demo.questions.0', 'What does my chart indicate about career growth this year?'),
        t('astro_first_demo.questions.1', 'When is the next strong period for marriage or relationship progress?'),
        t('astro_first_demo.questions.2', 'Which Mahadasha am I currently running?'),
      ],
    }),
    [t],
  );

  useWelcomeAudioOnce(); // Welcome audio hook - plays once per session

  // Select a per-session random background for logged-in users; persists until logout
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const key = `welcomeBg_${user.uid}`;
        const candidates = [bgBird, bgCow, bgKrishna];
        const stored = localStorage.getItem(key);
        if (stored && candidates.includes(stored)) {
          setWelcomeBg(stored);
        } else {
          const pick = candidates[Math.floor(Math.random() * candidates.length)];
          setWelcomeBg(pick);
          localStorage.setItem(key, pick);
        }
      } else {
        // On logout, clear any persisted selection so next login gets a fresh random
        Object.keys(localStorage)
          .filter(k => k.startsWith('welcomeBg_'))
          .forEach(k => localStorage.removeItem(k));
        setWelcomeBg(bgBird);
      }
    });
    return () => unsubscribe();
  }, []);

  // ✅ ADD THIS useEffect HOOK FOR DYNAMIC TEXTAREA RESIZING
  useEffect(() => {
    // This logic checks which textarea is currently on the screen
    const activeTextarea = welcomeTextareaRef.current || chatTextareaRef.current;

    if (activeTextarea) {
      // First, reset the height to 'auto'. This is crucial to get the correct scrollHeight.
      activeTextarea.style.height = 'auto';

      // Calculate the new height, but don't let it exceed 300px.
      const newHeight = Math.min(activeTextarea.scrollHeight, 300);

      // Apply the calculated height.
      activeTextarea.style.height = `${newHeight}px`;
    }
  }, [message]); // This logic re-runs every time the 'message' state changes

  // Track first load for loading tips
  const isFirstLoadRef = useRef(true);

  // HOOK 1: For desktop and initial measurement
  useLayoutEffect(() => {
    const inputElement = chatInputRef.current;
    if (!inputElement) return;

    const updateHeight = () => {
      if (chatInputRef.current) {
        const height = chatInputRef.current.offsetHeight;
        document.documentElement.style.setProperty('--chat-input-height', `${height}px`);
      }
    };

    updateHeight(); // Run once on mount to set the initial height

    const observer = new ResizeObserver(updateHeight);
    observer.observe(inputElement);

    return () => observer.disconnect();
  }, []);

  // HOOK 2: For mobile on-screen keyboard support
  useEffect(() => {
    const visualViewport = window.visualViewport;
    if (!visualViewport) return;

    const handleVisualViewportChange = () => {
      if (chatInputRef.current) {
        const height = chatInputRef.current.offsetHeight;
        document.documentElement.style.setProperty('--chat-input-height', `${height}px`);
      }
    };

    visualViewport.addEventListener('resize', handleVisualViewportChange);
    return () => visualViewport.removeEventListener('resize', handleVisualViewportChange);
  }, []);

  // Loading tips for enhanced waiting experience
  const { currentContent: currentTip, isFading } = useLoadingTips(loading, isFirstLoadRef.current);

  // Reset first load flag after first use
  useEffect(() => {
    if (loading && isFirstLoadRef.current) {
      isFirstLoadRef.current = false;
    }
  }, [loading]);

  const [isStreaming, setIsStreaming] = useState<boolean>(false);
  useEffect(() => {
    if (!chatHistory.length) return;
    const last = chatHistory[chatHistory.length - 1];
    if (last?.isUser) return;
    if (last?.isLoading) return;
    if (loading) setLoading(false);
    if (isStreaming) setIsStreaming(false);
    if (isDinacharyaGenerating) setIsDinacharyaGenerating(false);
    if (sendMessageAbortControllerRef.current) {
      sendMessageAbortControllerRef.current = null;
    }
  }, [chatHistory, isDinacharyaGenerating, isStreaming, loading]);

  // Retry functionality state
  const [lastUserMessage, setLastUserMessage] = useState<string>('');
  const [hasFailedMessage, setHasFailedMessage] = useState<boolean>(false);
  const [retryingMessage, setRetryingMessage] = useState<boolean>(false);
  const lastSendOptionsRef = useRef<{ dinacharyaMode?: boolean; dinacharyaGocharaDate?: string }>({});

  // Answer notification sound logic
  const { playExternal, currentlyPlaying } = useAudioPlayer();
  const wasLoadingRef = useRef(false);
  const welcomeAudioPlaying = currentlyPlaying === '__welcome__';
  const [atmosphereReady, setAtmosphereReady] = useState(false);

  // Play sound when LLM response finishes (loading changes from true to false)
  useEffect(() => {
    if (wasLoadingRef.current && !loading) {
      playExternal('/sounds/answerreceived.mp3', '__llm_notification__');
    }
    wasLoadingRef.current = loading;
  }, [loading, playExternal]);

  useEffect(() => {
    if (!isChatOpen || welcomeAudioPlaying) {
      setAtmosphereReady(false);
      return;
    }

    let cancelled = false;
    const load = () => {
      if (!cancelled) {
        setAtmosphereReady(true);
      }
    };

    if (typeof (window as any).requestIdleCallback === 'function') {
      const id = (window as any).requestIdleCallback(load, { timeout: 2500 });
      return () => {
        cancelled = true;
        (window as any).cancelIdleCallback?.(id);
      };
    }

    const timeoutId = window.setTimeout(load, 1000);
    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [isChatOpen, welcomeAudioPlaying]);


  // Translation feature state
  const [translationEnabled, setTranslationEnabled] = useState<boolean>(false);
  const [listeningModeEnabled, setListeningModeEnabled] = useState<boolean>(false);
  // Whole-answer translation state for Normal mode
  const [answerTranslations, setAnswerTranslations] = useState<Record<string, { originalText: string; translatedText: string; loading: boolean; translated: boolean; targetLang?: string; showingTranslated: boolean }>>({});
  const [supportedAnswerLanguages, setSupportedAnswerLanguages] = useState<Array<{ code: string; name: string }>>([]);
  const [answerLanguagesLoaded, setAnswerLanguagesLoaded] = useState<boolean>(false);
  const [answerLanguagesLoading, setAnswerLanguagesLoading] = useState<boolean>(false);
  // Initialize mode from localStorage or default to 'normal'
  const [mode, setMode] = useState<'citation' | 'normal'>(() => {
    const storedMode = localStorage.getItem('citationMode');
    return (storedMode === 'citation' || storedMode === 'normal') ? storedMode as 'citation' | 'normal' : 'normal';
  });
  type AstroPromptMode = 'astro_standard_mode' | 'astro_advanced_mode';
  const [astroPromptMode, setAstroPromptMode] = useState<AstroPromptMode>(() => {
    try {
      const stored = localStorage.getItem('astroPromptMode');
      return stored === 'astro_advanced_mode' ? 'astro_advanced_mode' : 'astro_standard_mode';
    } catch {
      return 'astro_standard_mode';
    }
  });
  const effectiveUiMode: 'citation' | 'normal' = isPersonalHoroscopeChat ? 'normal' : mode;
  const effectiveRequestMode: 'citation' | 'normal' = isPersonalHoroscopeChat ? 'normal' : (isListeningMode ? 'citation' : mode);
  const citationToggleDisabled = isPersonalHoroscopeChat;
  const normalChatPlaceholder = typeof window !== 'undefined' && window.innerWidth < 640
    ? 'Ask your question...'
    : t('chat.placeholder_normal');

	  const messagesEndRef = useRef<HTMLDivElement>(null);
	  const lastAutoScrollThreadIdRef = useRef<string | null>(null);
	  const chatRef = useRef<HTMLDivElement>(null);
	  const sidebarRef = useRef<HTMLDivElement>(null); // ✅ To track the sidebar element
	  // ✅ FIX: Create a ref for the actual scrolling container
	  const scrollContainerRef = useRef<HTMLDivElement>(null);
	  const chatJumpMessageRefs = useRef<Record<string, HTMLDivElement | null>>({});
	  const chatJumpHighlightTimeoutRef = useRef<ReturnType<typeof window.setTimeout> | null>(null);
	  const [visibleChatJumpMessageIds, setVisibleChatJumpMessageIds] = useState<Set<string>>(() => new Set());
	  const [highlightedChatJumpMessageId, setHighlightedChatJumpMessageId] = useState<string | null>(null);
	  const [isListOpen, setIsListOpen] = useState(false);
  const listRef = useRef<HTMLDivElement>(null);
  const [selectedCategory, setSelectedCategory] = useState<any>('');
  const [isPranayamaModalOpen, setIsPranayamaModalOpen] = useState<boolean>(false);
  const [isTodoModalOpen, setIsTodoModalOpen] = useState<boolean>(false);
  const [isReadingModalOpen, setIsReadingModalOpen] = useState<boolean>(false);
  const [readingModalProps, setReadingModalProps] = useState<{ token: string; label: string; ci: number } | null>(null);
  // Close reading modal when thread changes to prevent stale modal
  useEffect(() => {
    setIsReadingModalOpen(false);
    setReadingModalProps(null);
  }, [ThreadId]);
  const [isQuizModalOpen, setIsQuizModalOpen] = useState<boolean>(false);
  const [showQuiz, setShowQuiz] = useState<boolean>(false);
  const [isQuizPreparing, setIsQuizPreparing] = useState<boolean>(false);
  const [localUserId, setLocalUserId] = useState<string>('');
  const [firebaseToken, setFirebaseToken] = useState<string>('');
  const [appCheckToken, setAppCheckToken] = useState<string>('');
  const [quizCooldown, setQuizCooldown] = useState<number>(0);
  const canStartQuiz = !quizCooldown || Date.now() > quizCooldown;
  const handleOpenQuizRef = useRef<(() => Promise<void>) | null>(null);
  const questionData: any = questionsData;
  const categoryIconsMui = {
    arthashastra: ArthashashtraIcon,
    silpashastra: SilpashashtraIcon,
    yogashastra: YogashashtraIcon,
    rasayana: RasayanaIcon,
    ganitashastra: GanitashashtraIcon,
    jyotishashastra: JyotishashashtraIcon,
    dharmashastra: DharmashashtraIcon,
    tantra: TantraIcon,
    vedanta: VedantaIcon,
    ayurveda: AyurvedaIcon,
  };

  const categoryLabels = {
    arthashastra: { main: t('chat.categories.arthashastra'), sanskrit: "Arthaśāstra" },
    silpashastra: { main: t('chat.categories.silpashastra'), sanskrit: "Śilpaśāstra" },
    yogashastra: { main: t('chat.categories.yogashastra'), sanskrit: "Yogaśāstra" },
    rasayana: { main: t('chat.categories.rasayana'), sanskrit: "Rasāyana & Rasavidyā" },
    dharmashastra: { main: t('chat.categories.dharmashastra'), sanskrit: "Dharmashāstra" },
    ganitashastra: { main: t('chat.categories.ganitashastra'), sanskrit: "Gaṇitaśāstra" },
    jyotishashastra: { main: t('chat.categories.jyotishashastra'), sanskrit: "Jyotiṣaśāstra" },
    ayurveda: { main: t('chat.categories.ayurveda'), sanskrit: "Āyurveda" },
    tantra: { main: t('chat.categories.tantra'), sanskrit: "Tantra & Mantraśāstra" },
    vedanta: { main: t('chat.categories.vedanta'), sanskrit: "Vedānta" },
  };

  // ✅ FIX: Define a stable function for the STT component using useCallback.
  const handleTranscriptChange = useCallback((text: string) => {
    setMessage((prev) => (prev ? prev.trimEnd() + ' ' + text : text));
  }, []); // Empty dependency array means this function is created only once.

  // Handle outside click for list
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const listEl = listRef.current;
      if (!listEl) return;

      const targetNode = event.target as Node | null;
      if (targetNode && listEl.contains(targetNode)) return;

      const docEl = document.documentElement;
      const clickedVerticalScrollbar = event.clientX >= docEl.clientWidth;
      const clickedHorizontalScrollbar = event.clientY >= docEl.clientHeight;
      if (clickedVerticalScrollbar || clickedHorizontalScrollbar) return;

      setIsListOpen(false);
    };
    if (isListOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isListOpen]);

  // ✅ START: NEW - Hook to close sidebar on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // If the sidebar ref exists and the click was not inside the sidebar, close it
      if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
        setIsSidebarOpen(false);
      }
    };

    // Add event listener only when sidebar is open
    if (isSidebarOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSidebarOpen]); // Re-run this effect when isSidebarOpen changes
  // ✅ END: NEW - Hook to close sidebar on outside click

  // Transform messages
  function transformMessages(messagesparams: any): any {
    return messagesparams?.flatMap((message: any) => [
      { text: message.question, isUser: true, isLoading: false, footnotes: {} },
      { text: message.text, isUser: false, isLoading: false, footnotes: message.footnotes || {} },
    ]);
  }

  // --- Whole-answer translation helpers ---
  const fetchSupportedAnswerLanguages = async () => {
    if (answerLanguagesLoading) return;
    setAnswerLanguagesLoading(true);
    try {
      const API_BASE_URL = import.meta.env.VITE_APP_SERVER;
      const response = await fetch(`${API_BASE_URL}/api/translate/languages`);
      if (response.ok) {
        const data = await response.json();
        const languages = data.languages || [];
        const sortedLanguages = languages.sort((a: any, b: any) => {
          if (a.name === 'English') return -1;
          if (b.name === 'English') return 1;
          return a.name.localeCompare(b.name);
        });
        setSupportedAnswerLanguages(sortedLanguages);
        setAnswerLanguagesLoaded(true);
      }
    } catch (error) {
      console.error('Error fetching supported languages:', error);
    } finally {
      setAnswerLanguagesLoading(false);
    }
  };

  useEffect(() => {
    if (translationEnabled && !answerLanguagesLoaded && !answerLanguagesLoading) {
      fetchSupportedAnswerLanguages();
    }
  }, [translationEnabled, answerLanguagesLoaded, answerLanguagesLoading]);

  useEffect(() => {
    setAnswerTranslations({});
  }, [ThreadId]);

  const getAnswerTranslationKey = useCallback((index: number) => {
    const threadKey = String(ThreadId ?? 'no-thread');
    return `${threadKey}:${index}`;
  }, [ThreadId]);

  const stripRelatedAudioAndMedia = (raw: string): string => {
    let text = raw || '';
    const relatedMediaMatch = text.match(/^\s*(?:#{1,6}\s*)?(?:\*\*|__)?Related\s+(?:audio|video)\b.*$/im);
    if (relatedMediaMatch?.index !== undefined) {
      text = text.slice(0, relatedMediaMatch.index).trimEnd();
    }
    text = text.replace(/^.*\[MEDIA:\d+:(audio|video)\].*$/gim, '');
    text = text.replace(/\n{3,}/g, '\n\n');
    return text.trim();
  };

  const cleanSourceFooterTitle = (raw: string): string => {
    let title = raw.trim();
    while (/^sources?\s*:/i.test(title)) {
      title = title.replace(/^sources?\s*:\s*/i, '').trim();
    }
    return title;
  };

  const cleanSourceFooterLine = (line: string): string => {
    const match = line.match(/^(\s*(?:\*\*)?Sources?\s*:\s*(?:\*\*)?)(.*)$/i);
    if (!match) return line;

    const [, prefix, rest] = match;
    let changed = false;
    let cleanedRest = rest.replace(/\[([^\]\n]+)\]/g, (_full, inner) => {
      const cleanedInner = cleanSourceFooterTitle(inner);
      if (cleanedInner !== inner.trim()) changed = true;
      return `[${cleanedInner}]`;
    });
    cleanedRest = cleanedRest.replace(/(\[\s*)(?:sources?\s*:\s*)+/gi, (full, open) => {
      changed = true;
      return open || full;
    });

    const leadingCleaned = cleanSourceFooterTitle(cleanedRest);
    if (leadingCleaned !== cleanedRest.trim()) {
      changed = true;
      cleanedRest = leadingCleaned;
    }

    return changed ? `${prefix}${cleanedRest}` : line;
  };

  const cleanAnswerSourceFooters = (raw: string): string => {
    if (!raw || !/^\s*(?:\*\*)?Sources?\s*:/im.test(raw)) return raw;
    return raw
      .split('\n')
      .map((line) => cleanSourceFooterLine(line))
      .join('\n');
  };

  const markdownToPlainText = (raw: string): string => {
    let text = raw || '';
    text = text.replace(/\r\n/g, '\n');
    text = text.replace(/^#{1,6}\s+/gm, '');
    text = text.replace(/^\s*[-*+]\s+/gm, '- ');
    text = text.replace(/\*\*([^*]+)\*\*/g, '$1');
    text = text.replace(/__([^_]+)__/g, '$1');
    text = text.replace(/(^|[^*])\*([^*\n]+)\*([^*]|$)/g, '$1$2$3');
    text = text.replace(/(^|[^_])_([^_\n]+)_([^_]|$)/g, '$1$2$3');
    text = text.replace(/`{1,3}([^`]+)`{1,3}/g, '$1');
    text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
    text = text.replace(/\n{3,}/g, '\n\n');
    return text.trim();
  };

  const getPlainAnswerText = (msg: any): string => {
    const base = msg.text.split('**questions**')[0]?.trim() || msg.text.split('**Questions**')[0]?.trim() || msg.text || '';
    const withoutAudio = stripRelatedAudioAndMedia(cleanAnswerSourceFooters(base));
    return withoutAudio.replace(/<[^>]*>/g, '');
  };

  const getDisplayedAnswerText = (index: number, msg: any): string => {
    const tr = answerTranslations[getAnswerTranslationKey(index)];
    if (tr?.translated && tr.showingTranslated) {
      return cleanAnswerSourceFooters(tr.translatedText);
    }
    return cleanAnswerSourceFooters(msg.text);
  };

  const getCopyableAnswerText = (index: number, msg: any): string => {
    const displayed = getDisplayedAnswerText(index, msg) || msg.text || '';
    const base = displayed.split('**questions**')[0]?.trim() || displayed.split('**Questions**')[0]?.trim() || displayed || '';
    const withoutHtml = base.replace(/<[^>]*>/g, '');
    const withoutAudio = stripRelatedAudioAndMedia(withoutHtml);
    return markdownToPlainText(withoutAudio);
  };

  const readStoredAstroBirthDetails = (subjectId: string): AstroBirthDetailsSnapshot | null => {
    try {
      const raw = localStorage.getItem(getAstroBirthDetailsStorageKey(subjectId));
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
      return null;
    }
  };

  const getDinacharyaSubjectSnapshot = (msg?: any): { displayName: string; birthDetails: DinacharyaBirthDetails | null } => {
    const messageDisplayName = typeof msg?.dinacharyaSubjectDisplayName === 'string'
      ? msg.dinacharyaSubjectDisplayName.trim()
      : '';
    const messageBirthDetails = msg?.dinacharyaBirthDetails && typeof msg.dinacharyaBirthDetails === 'object'
      ? msg.dinacharyaBirthDetails as DinacharyaBirthDetails
      : null;

    if (messageDisplayName) {
      return { displayName: messageDisplayName, birthDetails: messageBirthDetails };
    }

    const threadId = activeThreadIdRef.current || ThreadId || null;
    const subjectMeta = getThreadSubjectMeta(threadId);
    const subjectId = subjectMeta.active_subject_id || 'self';
    const subject = availableSubjectsForPicker.find((item) => item.id === subjectId);
    const storedBirthDetails = astroBirthDetailsBySubject[subjectId] || readStoredAstroBirthDetails(subjectId);
    const fallbackDisplayName = subjectId === 'self'
      ? (subject?.display_name || userName)
      : subject?.display_name;
    const displayName =
      storedBirthDetails?.displayName ||
      storedBirthDetails?.name ||
      fallbackDisplayName ||
      t('chat.dinacharya.pdf.default_user', 'Seeker');
    const birthDetails = storedBirthDetails
      ? {
        name: storedBirthDetails.name || displayName,
        birthDate: storedBirthDetails.birthDate,
        birthTime: storedBirthDetails.birthTime,
        location: storedBirthDetails.location,
      }
      : messageBirthDetails;
    return { displayName, birthDetails };
  };

  const sanitizeDinacharyaFilename = (value: string) => {
    return value
      .trim()
      .replace(/[\\/:*?"<>|]+/g, '-')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  };

  const cleanDinacharyaPdfName = (value?: string | null): string | null => {
    const cleaned = (value || '').replace(/\s+/g, ' ').trim();
    if (!cleaned || cleaned.includes('@')) return null;
    const withoutContext = cleaned
      .replace(/\s*\([^)]*\)\s*/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (!withoutContext || withoutContext.includes('@')) return null;
    const candidate = withoutContext.length <= 20 ? withoutContext : withoutContext.split(' ')[0] || '';
    if (!candidate || candidate.length > 20) return null;
    return candidate;
  };

  const dinacharyaPdfTitle = (value?: string | null): string => {
    const name = cleanDinacharyaPdfName(value);
    return name ? `${name}'s Dinacharya` : t('chat.dinacharya.pdf.your_title', 'Your Dinacharya');
  };

  const handlePrintDinacharya = (index: number) => {
    setPrintingDinacharyaIndex(index);
    document.body.classList.add('dinacharya-print-mode');
    window.setTimeout(() => {
      try {
        window.print();
      } catch {
        document.body.classList.remove('dinacharya-print-mode');
        setPrintingDinacharyaIndex(null);
      }
    }, 50);
  };

  const handleDownloadDinacharyaPdf = async (index: number, msg: any) => {
    if (pdfGeneratingDinacharyaIndex !== null) return;
    const dinacharyaText = stripRelatedAudioAndMedia(getDisplayedAnswerText(index, msg) || msg.text || '').trim();
    if (!dinacharyaText) return;

    setPdfGeneratingDinacharyaIndex(index);
    try {
      const [{ pdf }, { default: DinacharyaPDFDocument }] = await Promise.all([
        import('@react-pdf/renderer'),
        import('./astrology/DinacharyaPDFDocument'),
      ]);
      const generatedDate = msg.dinacharyaGeneratedForDate || selectedAstroTimelineDate || astroTimelineDate || null;
      const subjectSnapshot = getDinacharyaSubjectSnapshot(msg);
      const subjectName = subjectSnapshot.displayName;
      const pdfSubjectName = cleanDinacharyaPdfName(subjectName);
      const pdfDisplayName = pdfSubjectName || t('chat.dinacharya.pdf.default_user', 'Seeker');
      const reportTitle = dinacharyaPdfTitle(subjectName);
      let pdfTimelinePayload = msg.dinacharyaTimelinePayload || null;
      let pdfTimelineMode = msg.dinacharyaTimelineMode || null;
      let pdfTimelineDate = msg.dinacharyaTimelineDate || generatedDate || null;

      if (!pdfTimelinePayload && isPersonalHoroscopeChat) {
        try {
          const fetchedTimeline = await fetchAstroTimelineForPrompt({
            mode: 'advanced',
            targetDate: generatedDate || undefined,
            threadId: activeThreadIdRef.current || ThreadId || null,
          });
          if (fetchedTimeline?.timeline?.segments?.length) {
            pdfTimelinePayload = fetchedTimeline.timeline;
            pdfTimelineMode = fetchedTimeline.mode;
            pdfTimelineDate = fetchedTimeline.date || pdfTimelineDate;
            setChatHistory(prev => {
              const updated = [...prev];
              const target = updated[index];
              if (target && target.isUser === false) {
                updated[index] = {
                  ...target,
                  dinacharyaTimelinePayload: pdfTimelinePayload,
                  dinacharyaTimelineMode: pdfTimelineMode,
                  dinacharyaTimelineDate: pdfTimelineDate,
                };
              }
              return updated;
            });
          }
        } catch (timelineError) {
          console.warn('Could not fetch Dinacharya PDF day-quality timeline; rendering PDF without DayArc.', timelineError);
        }
      }

      const blob = await pdf(
        <DinacharyaPDFDocument
          userName={pdfDisplayName}
          generatedDate={generatedDate}
          birthDetails={subjectSnapshot.birthDetails}
          dinacharyaText={dinacharyaText}
          timeline={pdfTimelinePayload}
          timelineMode={pdfTimelineMode}
          timelineDate={pdfTimelineDate}
          locale={i18n.language}
          reportTitle={reportTitle}
          metadataLabels={{
            preparedFor: t('chat.dinacharya.pdf.prepared_for', 'Prepared for'),
            routineDate: t('chat.dinacharya.pdf.routine_date', 'Routine date'),
            birthDate: t('chat.dinacharya.pdf.birth_date', 'Birth date'),
            birthTime: t('chat.dinacharya.pdf.birth_time', 'Birth time'),
            birthLocation: t('chat.dinacharya.pdf.birth_location', 'Birth location'),
            reportDetails: t('chat.dinacharya.pdf.report_details', 'Report details'),
            sourceNote: t('chat.dinacharya.pdf.source_note', 'Generated from the Dinacharya answer in this Sarvalok chat. Review any health-sensitive guidance with qualified care.'),
            dayQualityMap: t('chat.day_quality.title', 'Personalized Day Quality'),
            dayQualitySubtitle: t('chat.dinacharya.pdf.day_quality_subtitle', "Advanced muhurta map used to shape the selected day's timetable."),
            favorable: t('chat.day_quality.favorable', 'Favorable'),
            neutral: t('chat.day_quality.neutral', 'Neutral'),
            avoid: t('chat.day_quality.avoid', 'Avoid'),
            anchorMuhurtas: t('chat.dinacharya.pdf.anchor_muhurtas', 'Anchor Muhurtas'),
            specialPeriods: t('chat.dinacharya.pdf.special_periods', 'Special Periods'),
            sunrise: t('chat.dinacharya.pdf.sunrise', 'Sunrise'),
            sunset: t('chat.dinacharya.pdf.sunset', 'Sunset'),
            midnight: t('chat.dinacharya.pdf.midnight', 'Midnight'),
            nextSunrise: t('chat.dinacharya.pdf.next_sunrise', 'Next sunrise'),
          }}
          subtitle={t(
            'chat.dinacharya.pdf.subtitle_v2',
            "Your daily Vedic routine - personalized timing, food, work, prayer, rest, and remedies, based on your birth chart and the selected day's Panchanga (planetary timing)."
          )}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      const prefix = sanitizeDinacharyaFilename(t('chat.dinacharya.pdf.filename_prefix', 'dinacharya')) || 'dinacharya';
      const namePart = sanitizeDinacharyaFilename(pdfSubjectName || pdfDisplayName) || 'seeker';
      const datePart = sanitizeDinacharyaFilename(generatedDate || new Date().toISOString().slice(0, 10));
      anchor.href = url;
      anchor.download = `${prefix}-${namePart}-${datePart}.pdf`;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1500);
      toast.success(t('chat.dinacharya.pdf.download_started', 'Dinacharya PDF download started.'), { position: 'bottom-right' });
    } catch (error) {
      console.error('Failed to generate Dinacharya PDF', error);
      toast.error(t('chat.dinacharya.pdf.error', 'Could not create the PDF. Please try Print for now.'), { position: 'bottom-right' });
    } finally {
      setPdfGeneratingDinacharyaIndex(null);
    }
  };

  // Actually write the memory. `confirmed` is true ONLY when the user chose a
  // row in the picker and pressed Save — it becomes `target_selection_version`,
  // which tells the server a human agreed to the destination. Never set it for
  // a merely-rendered default.
  const doSaveMemory = useCallback(async (
    index: number,
    text: string,
    subjectId: string,
    confirmed: boolean,
  ) => {
    const threadId = activeThreadIdRef.current || ThreadId || null;
    try {
      setRememberingMessageIndex(index);
      await createMemory({
        text: text.slice(0, 280),
        item_type: 'fact',
        category: 'other',
        subject_id: subjectId,
        thread_id: threadId,
        ...(confirmed ? { target_selection_version: 1 } : {}),
        metadata: {
          source: 'chat_quick_add',
        },
      });
      setMemoryPicker(null);
      const firstToastKey = 'sarvalok_memory_first_toast_shown_v1';
      const alreadyShown = (() => {
        try {
          return localStorage.getItem(firstToastKey) === '1';
        } catch {
          return true;
        }
      })();
      if (!alreadyShown) {
        try {
          localStorage.setItem(firstToastKey, '1');
        } catch {}
        toast.info("I'll remember this. Review or delete it in Settings → Memory.", { position: 'bottom-right' });
      } else {
        const subject = availableSubjectsForPicker.find((s) => s.id === subjectId);
        toast.success(
          subjectId === 'self'
            ? t('memory_target.saved_you', { defaultValue: 'Saved for you' })
            : t('memory_target.saved_for', {
                name: subject?.display_name || t('memory_target.other', { defaultValue: 'Other chart' }),
                defaultValue: `Saved for ${subject?.display_name || 'this profile'}`,
              }),
          { position: 'bottom-right' },
        );
      }
    } catch (error: any) {
      const code = memoryTargetErrorCode(error);
      if (code === 'memory_target_required' || code === 'memory_target_confirmation_required') {
        // Our thread contract was stale, or this client auto-sent a target the
        // user never confirmed. Ask, rather than retrying against context the
        // server has already rejected.
        const currentThreadId = activeThreadIdRef.current || ThreadId || null;
        let meta = getThreadSubjectMeta(currentThreadId);
        const uid = auth.currentUser?.uid || userId;
        if (uid && currentThreadId) {
          try {
            const refreshed = await getUserThreadsMetadata(uid);
            const refreshedThreads = refreshed?.threads || [];
            setThreads(refreshedThreads);
            writeThreadMetaCache(uid, refreshedThreads);
            const found = refreshedThreads.find((thread: any) => thread?.id === currentThreadId);
            if (found) {
              meta = {
                active_subject_id: found.active_subject_id || 'self',
                active_subject_mode: found.active_subject_mode || 'single',
                addressed_subject_id: found.addressed_subject_id || null,
                compat_subject_ids: Array.isArray(found.compat_subject_ids)
                  ? found.compat_subject_ids
                  : [],
              };
            }
          } catch {
            // Keep the last known contract visible; the next confirmed save is
            // still enforced by the backend and cannot write to a forged target.
          }
        }
        const targets = memoryTargetsForThread(meta);
        setMemoryPicker({ index, text, targets });
        return;
      }
      console.error('Failed to remember message', error);
      toast.error('Could not save this to Memory.', { position: 'bottom-right' });
    } finally {
      setRememberingMessageIndex((current) => (current === index ? null : current));
    }
  }, [
    ThreadId,
    availableSubjectsForPicker,
    getThreadSubjectMeta,
    t,
    userId,
    writeThreadMetaCache,
  ]);

  const handleRememberMessage = useCallback(async (index: number, msg: any) => {
    const candidateText = typeof msg?.text === 'string' ? msg.text.trim() : '';
    if (!candidateText) return;
    if (rememberingMessageIndex === index) return;
    const threadId = activeThreadIdRef.current || ThreadId || null;
    const targets = memoryTargetsForThread(getThreadSubjectMeta(threadId));
    // Ambiguous thread (about someone else, or a compatibility pair): ask.
    // This client previously auto-sent the thread's active subject without
    // asking, which silently attributed self-referential notes to that person.
    if (targets.needsChoice) {
      setMemoryPicker({ index, text: candidateText, targets });
      return;
    }
    await doSaveMemory(index, candidateText, targets.targets[0] || 'self', false);
  }, [ThreadId, doSaveMemory, getThreadSubjectMeta, rememberingMessageIndex]);

  const getBookmarkId = useCallback((threadId: string, turnIndex: number) => {
    return `bookmark:${threadId}:turn:${turnIndex}`;
  }, []);

  // Set of bookmarked turnIndexes on the active thread (stable across pagination).
  const bookmarkedTurnsForActiveThread = useMemo(() => {
    const threadKey = String(ThreadId ?? '');
    const s = new Set<number>();
    for (const bm of bookmarks) {
      if (String(bm.threadId) === threadKey && typeof bm.turnIndex === 'number') {
        s.add(bm.turnIndex);
      }
    }
    return s;
  }, [ThreadId, bookmarks]);

  const ensureBookmarksLoaded = useCallback(async () => {
    const uid = auth.currentUser?.uid || userId;
    if (!uid) return;
    if (bookmarksLoadingRef.current) return;
    if (bookmarksLoaded) return;
    bookmarksLoadingRef.current = true;
    setBookmarksLoading(true);
    try {
      const res = await getUserBookmarks(uid, 200);
      const raw = Array.isArray(res?.bookmarks) ? res.bookmarks : [];
      const mapped: BookmarkItem[] = raw
        .map((b: any) => ({
          id: String(b?.id || ''),
          threadId: String(b?.threadId || ''),
          turnIndex: Number(b?.turnIndex ?? 0),
          messageId: typeof b?.messageId === 'string' ? b.messageId : undefined,
          question: typeof b?.question === 'string' ? b.question : '',
          answerSnippet: typeof b?.answerSnippet === 'string' ? b.answerSnippet : '',
          answerText: typeof b?.answerText === 'string' ? b.answerText : '',
          createdAt: typeof b?.createdAt === 'string' ? b.createdAt : undefined,
          updatedAt: typeof b?.updatedAt === 'string' ? b.updatedAt : undefined,
          _ts: typeof b?._ts === 'number' ? b._ts : undefined,
        }))
        // Backend only returns v2 (turnIndex) bookmarks; guard anyway.
        .filter((b: BookmarkItem) => b.id && b.threadId && Number.isFinite(b.turnIndex) && b.turnIndex > 0);
      setBookmarks(mapped);
      setBookmarksLoaded(true);
    } catch (error) {
      console.error('Error fetching bookmarks:', error);
      toast.error('Failed to load bookmarks', { position: 'bottom-right' });
    } finally {
      bookmarksLoadingRef.current = false;
      setBookmarksLoading(false);
    }
  }, [bookmarksLoaded, userId]);

  const toggleBookmarkForAnswer = async (index: number, msg: any) => {
    const uid = auth.currentUser?.uid || userId;
    const threadId = String(ThreadId || '');
    if (!uid || !threadId) return;

    // v2: bookmark by the bubble's stable turnIndex, never the array index.
    const turnIndex = typeof msg?.turnIndex === 'number' ? msg.turnIndex : null;
    if (turnIndex == null) {
      toast.info('This message is still saving — try bookmarking again in a moment.', { position: 'bottom-right' });
      return;
    }
    const messageId = typeof msg?.messageId === 'string' ? msg.messageId : undefined;
    const bookmarkId = getBookmarkId(threadId, turnIndex);
    const exists = bookmarks.some(b => String(b.id) === bookmarkId);

    if (exists) {
      try {
        await deleteBookmark(bookmarkId, uid);
        setBookmarks(prev => prev.filter(b => String(b.id) !== bookmarkId));
        toast.success('Bookmark removed', { position: 'bottom-right' });
      } catch (error) {
        console.error('Error deleting bookmark:', error);
        toast.error('Failed to remove bookmark', { position: 'bottom-right' });
      }
      return;
    }

    const question = typeof chatHistory[index - 1]?.text === 'string' ? chatHistory[index - 1].text : '';
    const answerText = getCopyableAnswerText(index, msg);
    const answerSnippet = answerText.slice(0, 240);

    try {
      const res = await createBookmark({
        user_id: uid,
        thread_id: threadId,
        turn_index: turnIndex,
        message_id: messageId,
        question,
        answer_text: answerText,
        answer_snippet: answerSnippet,
      });
      const created = res?.bookmark;
      const mapped: BookmarkItem = {
        id: String(created?.id || bookmarkId),
        threadId: String(created?.threadId || threadId),
        turnIndex: Number(created?.turnIndex ?? turnIndex),
        messageId: typeof created?.messageId === 'string' ? created.messageId : messageId,
        question: typeof created?.question === 'string' ? created.question : question,
        answerSnippet: typeof created?.answerSnippet === 'string' ? created.answerSnippet : answerSnippet,
        answerText: typeof created?.answerText === 'string' ? created.answerText : answerText,
        createdAt: typeof created?.createdAt === 'string' ? created.createdAt : undefined,
        updatedAt: typeof created?.updatedAt === 'string' ? created.updatedAt : undefined,
        _ts: typeof created?._ts === 'number' ? created._ts : undefined,
      };
      setBookmarks(prev => [mapped, ...prev.filter(b => String(b.id) !== mapped.id)]);
      setBookmarksLoaded(true);
      toast.success('Bookmarked', { position: 'bottom-right' });
    } catch (error) {
      console.error('Error creating bookmark:', error);
      toast.error('Failed to bookmark', { position: 'bottom-right' });
    }
  };

  const handleAnswerTranslateSelection = async (index: number, targetLang: string) => {
    const threadKeyAtStart = String(ThreadId ?? 'no-thread');
    const key = getAnswerTranslationKey(index);
    const tr = answerTranslations[key];
    if (tr?.translated) {
      setAnswerTranslations(prev => ({
        ...prev,
        [key]: { ...tr, showingTranslated: !tr.showingTranslated }
      }));
      return;
    }

    const msg = chatHistory[index];
    const textToTranslate = getPlainAnswerText(msg);

    setAnswerTranslations(prev => ({
      ...prev,
      [key]: { originalText: msg.text, translatedText: '', loading: true, translated: false, targetLang, showingTranslated: false }
    }));

    try {
      const API_BASE_URL = import.meta.env.VITE_APP_SERVER;
      const response = await fetch(`${API_BASE_URL}/api/translate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: textToTranslate, target_lang: targetLang })
      });
      if (!response.ok) throw new Error('Translation failed');
      const data = await response.json();
      if (String(activeThreadIdRef.current ?? 'no-thread') !== threadKeyAtStart) return;
      setAnswerTranslations(prev => ({
        ...prev,
        [key]: { originalText: msg.text, translatedText: data.translated_text, loading: false, translated: true, targetLang, showingTranslated: true }
      }));
    } catch (error) {
      console.error('Answer translation error:', error);
      if (String(activeThreadIdRef.current ?? 'no-thread') !== threadKeyAtStart) return;
      setAnswerTranslations(prev => ({
        ...prev,
        [key]: { originalText: msg.text, translatedText: 'Error translating.', loading: false, translated: true, targetLang, showingTranslated: true }
      }));
    }
  };

  // Update questions based on AI response
  useEffect(() => {
    const lastAIResponse = chatHistory.filter(msg => !msg.isUser && !msg.isLoading).pop();
    let newQuestions = [];
    if (lastAIResponse && lastAIResponse.text && typeof lastAIResponse.text === 'string' && lastAIResponse.text.toLowerCase().includes('**questions**') && !loading) {
      const [, questionsPart] = lastAIResponse.text.toLowerCase().split('**questions**');
      try {
        newQuestions = JSON.parse(questionsPart.trim().replace(/```json|```/g, ""));
      } catch (error) {
        console.error('Error parsing questions JSON:', error);
        newQuestions = [];
      }
    }
    setQuestions(newQuestions);
  }, [chatHistory, loading]);

  // Stagger animation for buttons on load
  useEffect(() => {
    const buttons = document.querySelectorAll('.topic-suggestion');
    buttons.forEach((button, index) => {
        // Ensure the element exists before trying to access its style
        if (button) {
            (button as HTMLElement).style.opacity = '0';
            (button as HTMLElement).style.animation = 'none'; // Reset animation
            // Trigger reflow
            void (button as HTMLElement).offsetWidth;
            // Set animation with delay
            (button as HTMLElement).style.animation = `fadeInUp 0.4s ease forwards ${0.1 + index * 0.05}s`;
        }
    });
  }, [topics]);



  useEffect(() => {
    if (chatHistory?.length > 0) {
      setIsChatOpen(true);
    }
  }, [chatHistory]);

  // Load authority range from localStorage
  useEffect(() => {
    const storedRange = localStorage.getItem('authorityRange');
    if (storedRange) {
      setAuthorityRange(JSON.parse(storedRange));
    }
  }, []);

  // ✅ LOAD LISTENING MODE STATE FROM LOCALSTORAGE
  useEffect(() => {
    const storedListeningMode = localStorage.getItem('isListeningMode');
    if (storedListeningMode) {
      setIsListeningMode(JSON.parse(storedListeningMode));
    }
  }, []);

  // ✅ LOAD FAST SEARCH MODE STATE FROM LOCALSTORAGE
  useEffect(() => {
    const storedGeneral = localStorage.getItem('isFastSearchGeneral');
    const storedAstro = localStorage.getItem('isFastSearchAstro');
    const legacy = localStorage.getItem('isFastSearch');

    if (storedGeneral !== null) {
      setIsFastSearchGeneral(JSON.parse(storedGeneral));
    } else if (legacy !== null) {
      setIsFastSearchGeneral(JSON.parse(legacy));
    }

    if (storedAstro !== null) {
      setIsFastSearchAstro(JSON.parse(storedAstro));
    }
    // If no stored preference, defaults remain true
  }, []);

  // Fetch feature flags from backend
  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        // ✅ FIX: Get base URL from environment
      const API_BASE_URL = import.meta.env.VITE_APP_SERVER;
      const response = await fetch(`${API_BASE_URL}/api/features`); // ✅ Use dynamic URL
        if (response.ok) {
          const features = await response.json();
          setTranslationEnabled(features.translation || false);
          setListeningModeEnabled(features.listening_mode || false);
          setPersonalModeEnabled(features.personal_mode || false);
        }
      } catch (error) {
        console.error('Error fetching features:', error);
        setTranslationEnabled(false);
        setListeningModeEnabled(false);
        setPersonalModeEnabled(false);
      } finally {
        setPersonalModeLoading(false);
      }
    };

    fetchFeatures();
  }, []);

  // Fetch filters from Firestore only after user is authenticated (retained your existing logic)
  useEffect(() => {
    if (!userId) return;

    const fetchFilters = async () => {
      try {
        if (import.meta.env.DEV) console.log("Attempting to fetch filters directly from Firestore...");
        const filterDocRef = doc(db, 'filters', 'filters');
        const filterDoc = await getDoc(filterDocRef);

        if (filterDoc.exists()) {
          const data = filterDoc.data();
          setAvailableFilters(Object.keys(data));
          setFilterMapping(data);
          if (import.meta.env.DEV) console.log("✅ Filters successfully loaded.");
        } else {
          console.error('No filters document found in Firestore');
          setAvailableFilters([]);
        }
      } catch (error) {
        console.error('Error fetching filters from Firestore:', error);
        toast.error(t('chat.filters_failed'), { position: 'bottom-right' });
      }
    };

    fetchFilters();

    const storedFilters = localStorage.getItem('selectedFilters');
    if (storedFilters) {
      setSelectedFilters(JSON.parse(storedFilters));
    }
  }, [userId]);

  // Check quiz cooldown from localStorage
  useEffect(() => {
    const cooldownEndTime = localStorage.getItem('quizCooldown');
    if (cooldownEndTime) {
      setQuizCooldown(parseInt(cooldownEndTime, 10));
    }
  }, []);

  // Handle authentication and thread setup
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      try {
        if (!currentUser || !currentUser.emailVerified) {
          const requestedMode = getAdModeFromUrl();
          const isChatLandingMode = Boolean(requestedMode && requestedMode !== 'global-risk');
          if (isChatLandingMode) {
            storePendingAdMode(requestedMode);
            const redirectParams = buildAdIntentSearchParams(window.location.search);
            const redirectSearch = redirectParams.toString();
            window.location.href = redirectSearch
              ? `${localizedPath('/sign-up')}?${redirectSearch}`
              : localizedPath('/sign-up');
          } else {
            window.location.href = "/login";
          }
          return;
        }

        const userDocRef = doc(db, "users", currentUser.uid);
        let userDocSnap = await getDoc(userDocRef);
        let repairedUserData: Record<string, any> | null = userDocSnap.exists() ? (userDocSnap.data() || {}) : null;
        if (!userDocSnap.exists() || needsUserDocRepair(repairedUserData)) {
          try {
            repairedUserData = await ensureAuthUserDoc(currentUser, {
              provider: providerIdForUser(currentUser),
              source: userDocSnap.exists() ? 'chat_entry_partial_doc' : 'chat_entry_missing_doc',
              includeDeviceInfo: false,
            });
            cacheAuthUser(currentUser);
            userDocSnap = await getDoc(userDocRef);
            repairedUserData = userDocSnap.exists() ? (userDocSnap.data() || repairedUserData) : repairedUserData;
          } catch (repairError) {
            console.error("Failed to repair user document before opening chat:", repairError);
            if (isEnsureUserBlockedError(repairError)) {
              clearCachedAuthUser();
              try {
                await signOut(auth);
              } catch {}
              toast.error(ensureUserErrorMessage(repairError));
              window.location.href = "/login";
              return;
            }
          }
        }
        if (!userDocSnap.exists()) {
          const requestedMode = getAdModeFromUrl();
          const isChatLandingMode = Boolean(requestedMode && requestedMode !== 'global-risk');
          if (isChatLandingMode) {
            storePendingAdMode(requestedMode);
            const redirectParams = buildAdIntentSearchParams(window.location.search);
            const redirectSearch = redirectParams.toString();
            window.location.href = redirectSearch
              ? `${localizedPath('/sign-up')}?${redirectSearch}`
              : localizedPath('/sign-up');
          } else {
            window.location.href = "/login";
          }
          return;
        }

        const _userData = repairedUserData || userDocSnap.data() || {};
        setUserName(_userData.firstName || _userData.email);
        setUserId(currentUser.uid);

        // Populate subscription info for upgrade banner
        const subName = _userData.subscription_name || 'free_plan';
        const nextIsFreePlan = subName === 'free_plan';
        isFreePlanRef.current = nextIsFreePlan;
        setIsFreePlan(nextIsFreePlan);

        const cachedMeta = readThreadMetaCache(currentUser.uid);
        if (cachedMeta?.threads?.length) {
          setThreads(cachedMeta.threads);
        }

        const threadsPromise = getUserThreadsMetadata(currentUser.uid);

        const threadsResponse = await threadsPromise;
        let threads = threadsResponse?.threads || [];
        writeThreadMetaCache(currentUser.uid, threads);

        const urlParams = new URLSearchParams(location.search);
        const urlNewChat = urlParams.get('new') === '1';
        const urlThreadId = urlParams.get('id');

        const sessionKey = `chat_session_${currentUser.uid}`;
        let forceNewSession = false;
        try {
          forceNewSession = sessionStorage.getItem('chat_force_new_session') === '1';
          if (forceNewSession) sessionStorage.removeItem('chat_force_new_session');
        } catch {}

        let hasSession = false;
        try {
          hasSession = sessionStorage.getItem(sessionKey) === '1';
          if (!hasSession) sessionStorage.setItem(sessionKey, '1');
        } catch {}

        if (urlNewChat) {
          if (Date.now() - newChatHandledAtRef.current < 3000) {
            const next = new URLSearchParams(window.location.search);
            next.delete('new');
            setSearchParams(next, { replace: true });
            setPageLoading(false);
            return;
          }
          newChatHandledAtRef.current = Date.now();
          setIsPersonalHoroscopeChat(false);

          const isEmptyThread = (t: any) => Number(t?.message_count) === 0;
          let leadingEmptyCount = 0;
          for (const th of threads) {
            if (!isEmptyThread(th)) break;
            leadingEmptyCount += 1;
          }

          if (leadingEmptyCount >= 1 && threads.length > 0 && isEmptyThread(threads[0])) {
            const targetId = threads[0].id;
            setThreads(threads);
            writeThreadMetaCache(currentUser.uid, threads);
            setThreadId(targetId);
            setChatHistory([]);
            setIsChatOpen(false);
            localStorage.setItem('thread_id', targetId);

            try {
              const keyGeneral = `thread_id_general_${currentUser.uid}`;
              localStorage.setItem(keyGeneral, targetId);
            } catch {}

            const next = new URLSearchParams(window.location.search);
            next.set('id', targetId);
            next.delete('new');
            setSearchParams(next, { replace: true });

            setPageLoading(false);
            return;
          }

          const threadPayload = {
            user_id: currentUser.uid,
            user_name: (currentUser.displayName?.trim() ? currentUser.displayName : currentUser.email) || "",
            personal_mode: false,
          };
	          const threadResult = await createChatThread(threadPayload);
	          if (threadResult.status !== 200) throw new Error("Failed to create a new chat thread.");
	          const newThread = {
                id: threadResult.id,
                chat_title: t('chat.new_chat'),
                _ts: Math.floor(Date.now() / 1000),
                message_count: 0,
                personal_mode: false,
                active_subject_id: threadResult.active_subject_id || 'self',
                active_subject_mode: threadResult.active_subject_mode || 'single',
                addressed_subject_id: threadResult.addressed_subject_id || null,
                compat_subject_ids: threadResult.compat_subject_ids || [],
              };
          threads = [newThread, ...threads];

          setThreads(threads);
          writeThreadMetaCache(currentUser.uid, threads);
          setThreadId(threadResult.id);
          setChatHistory([]);
          setIsChatOpen(false);
          localStorage.setItem('thread_id', threadResult.id);

          try {
            const keyGeneral = `thread_id_general_${currentUser.uid}`;
            localStorage.setItem(keyGeneral, threadResult.id);
          } catch {}

          const next = new URLSearchParams(window.location.search);
          next.set('id', threadResult.id);
          next.delete('new');
          setSearchParams(next, { replace: true });

          setPageLoading(false);
          return;
        }

        if (!urlThreadId && (forceNewSession || !hasSession)) {
          setIsPersonalHoroscopeChat(false);
          setThreads(threads);
          setThreadId(undefined);
          setChatHistory([]);
          setIsChatOpen(false);
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('id');
          currentUrl.searchParams.delete('new');
          window.history.replaceState({}, document.title, currentUrl.toString());
          setPageLoading(false);
          return;
        }

        const keyGeneral = auth.currentUser?.uid ? `thread_id_general_${auth.currentUser.uid}` : 'thread_id_general';
        const keyAstro = auth.currentUser?.uid ? `thread_id_astro_${auth.currentUser.uid}` : 'thread_id_astro';
        let activeThreadId =
          urlThreadId ||
          localStorage.getItem(keyGeneral) ||
          localStorage.getItem('thread_id');
        let personalMode = false;
        let activeThread = activeThreadId ? threads.find(t => t.id === activeThreadId) : undefined;

        if (!activeThread) {
          if (threads.length > 0) {
            activeThread = threads[0];
          } else {
            const threadPayload = {
              user_id: currentUser.uid,
              user_name: (currentUser.displayName?.trim() ? currentUser.displayName : currentUser.email) || "",
              personal_mode: false,
            };
	            const threadResult = await createChatThread(threadPayload);
	            if (threadResult.status === 200) {
	              const newThread = {
                    id: threadResult.id,
                    chat_title: t('chat.new_chat'),
                    _ts: Math.floor(Date.now() / 1000),
                    message_count: 0,
                    personal_mode: false,
                    active_subject_id: threadResult.active_subject_id || 'self',
                    active_subject_mode: threadResult.active_subject_mode || 'single',
                    addressed_subject_id: threadResult.addressed_subject_id || null,
                    compat_subject_ids: threadResult.compat_subject_ids || [],
                  };
	              threads = [newThread, ...threads];
	              activeThread = newThread;
            } else {
              throw new Error("Failed to create a new chat thread.");
            }
          }
        }

        activeThreadId = activeThread.id;
        const metaMode = (activeThread as any)?.personal_mode;
        if (typeof metaMode === 'boolean') {
          personalMode = metaMode;
        } else {
          try {
            const storedAstro = localStorage.getItem(keyAstro);
            personalMode = !!storedAstro && String(storedAstro) === String(activeThreadId);
          } catch {}
        }
        setThreads(threads);
        writeThreadMetaCache(currentUser.uid, threads);
        setIsPersonalHoroscopeChat(personalMode);
        setThreadId(activeThreadId);
        setChatHistory([]);
        const effectiveUserId = currentUser.uid;
        const messageCount = Number(activeThread?.message_count) || 0;
        setIsChatOpen(personalMode ? true : messageCount > 0);
        if (messageCount > 0) {
          await fetchAndSetThreadMessages(activeThreadId, effectiveUserId, personalMode);
        }

        localStorage.setItem('thread_id', activeThreadId);
        try {
          if (!personalMode && !localStorage.getItem(keyGeneral)) {
            localStorage.setItem(keyGeneral, activeThreadId);
          }
        } catch {}
        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.get('id') !== activeThreadId) {
          currentUrl.searchParams.set('id', activeThreadId);
          window.history.replaceState({}, document.title, currentUrl.toString());
        }

      } catch (error) {
        console.error('Error in auth state change:', error);
        if (isUsageLimitError(error)) {
          openUsageLimitModal(error);
        } else {
          toast.error(t('chat.setup_error_refresh'), { position: 'bottom-right' });
        }
      } finally {
        setPageLoading(false);
      }
    });

    return () => unsubscribe();
  }, [fetchAndSetThreadMessages, location.search, readThreadMetaCache, setSearchParams, writeThreadMetaCache]);

  // Header offset state ensures scroll-padding is set before first anchor scroll
  // Reads from --app-header-h CSS variable (set by App.tsx sliding header logic)
  const [headerOffsetPx, setHeaderOffsetPx] = useState<number>(85);
  useEffect(() => {
    const setOffset = () => {
      const cssVal = getComputedStyle(document.documentElement).getPropertyValue('--app-header-h').trim();
      const parsed = parseInt(cssVal, 10);
      const h = (parsed && parsed > 0) ? parsed + 8 : 85; // +8 breathing room, fallback 85
      setHeaderOffsetPx(h);
      document.documentElement.style.setProperty('--header-offset', `${h}px`);
    };
    setOffset();
    window.addEventListener('resize', setOffset);
    return () => window.removeEventListener('resize', setOffset);
  }, [isChatOpen]);

  useEffect(() => {
    const el = scrollContainerRef.current;
    if (!el) return;
    const emit = () => {
      const scrolled = el.scrollTop > 4;
      window.dispatchEvent(new CustomEvent('sarvalok_chat_scroll', { detail: { scrolled } }));
    };
    emit();
    el.addEventListener('scroll', emit, { passive: true });
    return () => el.removeEventListener('scroll', emit as any);
  }, [ThreadId]);
  
  // ✅ REVISED: This is the hook that controls the scrolling behavior.
  useEffect(() => {
    // Find the last message in the history.
    const lastMessage = chatHistory[chatHistory.length - 1];

    // This condition is true only at the exact moment the user sends a message.
    // The `isLoading` flag is set, but the text from the AI hasn't arrived yet.
    const isUserMessageJustSent = lastMessage && lastMessage.isLoading && lastMessage.text === '';

    if (isUserMessageJustSent) {
      // The user's actual question is the one right before the loading indicator.
      const userMessageIndex = chatHistory.length - 2;
      if (userMessageIndex < 0) return; // Safety check for the first message

      // We use requestAnimationFrame to ensure the DOM has updated before we try to find the element.
      requestAnimationFrame(() => {
        const anchor = document.getElementById(`message-block-${userMessageIndex}`);
        if (anchor) {
          // This command scrolls the top of the 'anchor' element to the top of the visible area.
          // 'behavior: smooth' creates the animation.
          // 'block: start' specifies the alignment.
          // The `scroll-padding-top` CSS property on the container creates the offset for your header.
          anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }, [chatHistory]); // This effect runs every time the chat history changes.

  useEffect(() => {
    if (!isThreadMessagesLoading) return;
    if (!loadingThreadId) return;
    lastAutoScrollThreadIdRef.current = null;
  }, [isThreadMessagesLoading, loadingThreadId]);

	  useEffect(() => {
	    if (isThreadMessagesLoading) return;
	    if (!ThreadId) return;
	    if (!chatHistory.length) return;

    const currentThreadId = String(ThreadId);
    if (lastAutoScrollThreadIdRef.current === currentThreadId) return;
    lastAutoScrollThreadIdRef.current = currentThreadId;

    const lastMessageIndex = chatHistory.length - 1;
    requestAnimationFrame(() => {
	      const anchor = document.getElementById(`message-block-${lastMessageIndex}`);
	      if (anchor) anchor.scrollIntoView({ behavior: 'auto', block: 'end' });
	    });
	  }, [ThreadId, chatHistory.length, isThreadMessagesLoading]);

	  const getChatJumpMessageId = useCallback((index: number, msg?: any) => {
	    return `chat-jump-${msg?.isUser ? 'user' : 'assistant'}-${index}`;
	  }, []);

	  const findPreviousUserMessageId = useCallback((fromIndex: number) => {
	    for (let i = fromIndex - 1; i >= 0; i -= 1) {
	      const candidate = chatHistory[i];
	      if (candidate?.isUser && !candidate?.isSystemNote) {
	        return getChatJumpMessageId(i, candidate);
	      }
	    }
	    return null;
	  }, [chatHistory, getChatJumpMessageId]);

	  const scrollToChatJumpMessage = useCallback((messageId: string | null) => {
	    if (!messageId) return;
	    const target = chatJumpMessageRefs.current[messageId];
	    const scroller = scrollContainerRef.current;
	    if (!target || !scroller) return;

	    const targetRect = target.getBoundingClientRect();
	    const scrollerRect = scroller.getBoundingClientRect();
	    const targetTop = scroller.scrollTop + (targetRect.top - scrollerRect.top) - 16;

	    scroller.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
	    setHighlightedChatJumpMessageId(messageId);

	    if (chatJumpHighlightTimeoutRef.current) {
	      window.clearTimeout(chatJumpHighlightTimeoutRef.current);
	    }
	    chatJumpHighlightTimeoutRef.current = window.setTimeout(() => {
	      setHighlightedChatJumpMessageId((current) => current === messageId ? null : current);
	      chatJumpHighlightTimeoutRef.current = null;
	    }, 1400);
	  }, []);

	  useEffect(() => {
	    return () => {
	      if (chatJumpHighlightTimeoutRef.current) {
	        window.clearTimeout(chatJumpHighlightTimeoutRef.current);
	      }
	    };
	  }, []);

	  useEffect(() => {
	    setVisibleChatJumpMessageIds(new Set());
	    setHighlightedChatJumpMessageId(null);
	  }, [ThreadId]);

	  useEffect(() => {
	    const scroller = scrollContainerRef.current;
	    if (!scroller || !isChatOpen || typeof IntersectionObserver === 'undefined') {
	      return;
	    }

	    const observer = new IntersectionObserver(
	      (entries) => {
	        setVisibleChatJumpMessageIds((previous) => {
	          let changed = false;
	          const next = new Set(previous);

	          entries.forEach((entry) => {
	            const id = entry.target.getAttribute('data-chat-jump-id');
	            if (!id) return;

	            if (entry.isIntersecting) {
	              if (!next.has(id)) {
	                next.add(id);
	                changed = true;
	              }
	            } else if (next.delete(id)) {
	              changed = true;
	            }
	          });

	          return changed ? next : previous;
	        });
	      },
	      {
	        root: scroller,
	        threshold: 0,
	        rootMargin: '-8px 0px -8px 0px',
	      }
	    );

	    Object.values(chatJumpMessageRefs.current).forEach((el) => {
	      if (el) observer.observe(el);
	    });

	    return () => observer.disconnect();
	  }, [ThreadId, chatHistory.length, isChatOpen]);

	  useEffect(() => {
	    if (!isPersonalHoroscopeChat) return;
    exploreTopicsTokenRef.current += 1;
    setShowExplore(false);
    setTopics([]);
  }, [isPersonalHoroscopeChat]);

  // Trigger explore topics after every completed assistant stream
  useEffect(() => {
    if (
      !isPersonalHoroscopeChat &&
      !loading &&
      chatHistory.length &&
      !chatHistory[chatHistory.length - 1].isUser
    ) {
      fetchExploreTopics(isListeningMode);   // listeningMode flag selects audio vs text pool
    }
  }, [isPersonalHoroscopeChat, loading, chatHistory, isListeningMode]);

  const handleNewChat = () => {
    astroNavTokenRef.current += 1;
    compatibilityNavTokenRef.current += 1;
    threadMessagesTokenRef.current += 1;
    sendMessageTokenRef.current += 1;
    exploreTopicsTokenRef.current += 1;
    sendMessageAbortControllerRef.current?.abort();
    sendMessageAbortControllerRef.current = null;
    setIsPersonalHoroscopeChat(false);
    setAstroDayTimeline(null);
    setAstroTimelineDate('');
    setShowDayTimeline(true);
    setIsListOpen(false);
    setIsSidebarOpen(false);
    setTokenLimitReached(false);
    setShowPersonalMode(false);
    setShowCompatibilityMode(false);
    setCompatibilityResult(null);
    setChatHistory([]);
    setThinkingPanelOpen({});
    setMessage('');
    setIsThreadMessagesLoading(false);
    setLoadingThreadId(null);
    setLoading(false);
    setIsStreaming(false);
    setThreadId(undefined);
    activeThreadIdRef.current = undefined;
    clearThreadIdFromUrl();
    setIsChatOpen(false);
    setPageLoading(false);
  };

  const handleSelectChat = (threadId: string) => {
    threadMessagesTokenRef.current += 1;
    sendMessageTokenRef.current += 1;
    exploreTopicsTokenRef.current += 1;
    sendMessageAbortControllerRef.current?.abort();
    sendMessageAbortControllerRef.current = null;
    setLoading(false);
    setIsStreaming(false);
    setIsDinacharyaGenerating(false);
    const personalMode = getThreadPersonalMode(threadId);
    setIsPersonalHoroscopeChat(personalMode);
    selectThread(threadId, { personalMode, persist: true });
    setIsSidebarOpen(false);
  };

  useEffect(() => {
    const onPopState = () => {
      const params = new URLSearchParams(window.location.search);
      const urlThreadId = params.get('id');

      if (!urlThreadId) {
        setIsPersonalHoroscopeChat(false);
        setThreadId(undefined);
        setChatHistory([]);
        setIsChatOpen(false);
        return;
      }

      if (String(urlThreadId) === String(ThreadId)) return;

      const personalMode = getThreadPersonalMode(String(urlThreadId));
      setIsPersonalHoroscopeChat(personalMode);
      void selectThread(String(urlThreadId), { personalMode, persist: true, updateUrl: false });
    };

    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [ThreadId, getThreadPersonalMode, selectThread]);

  const handleSendMessage = async (
    msg: string = '',
    opts?: { dinacharyaMode?: boolean; dinacharyaGocharaDate?: string }
  ) => {
    if (loading || isStreaming) return;
    const isDinacharyaRequest = Boolean(opts?.dinacharyaMode && isPersonalHoroscopeChat);
    const requestUsedListeningMode = !isDinacharyaRequest && isListeningMode;
    const dinacharyaGeneratedForDate = isDinacharyaRequest
      ? (opts?.dinacharyaGocharaDate || astroTimelineDate || getClientLocalDateIso())
      : null;
    const dinacharyaSubjectSnapshot = isDinacharyaRequest ? getDinacharyaSubjectSnapshot() : null;
    const rawUserMsg = msg || message;
    const userMsg = rawUserMsg.trim();
    if (!userMsg) return;

    // Proactive credit gate — covers Enter, the send button, and suggested
    // questions. When the balance is known-exhausted, surface the upgrade
    // modal instantly without firing a doomed request (the backend would 403
    // anyway). Closing the modal and retrying re-triggers this immediately.
    if (usageLimitReached) {
      setUsageLimitKind(proactiveUsageLimitKind());
      setIsRateLimitExceeded(true);
      return;
    }

    let messageFailed = false;
    hideAstroNudge();
    hideReadingNudge(showReadingNudge);
    setShowExplore(false); // Clear topics on new message
    setQuestions([]);
    setLoading(true);
    if (isDinacharyaRequest) {
      setIsDinacharyaGenerating(true);
    }

    try {
      if (sessionStorage.getItem(chatStartedStorageKey) !== '1') {
        sessionStorage.setItem(chatStartedStorageKey, '1');
        trackEvent('chat_started', {
          category: 'Chat',
          device_type: getDeviceType(),
          ui_language: i18n.language,
          route: location.pathname,
        });
      }
    } catch {}

    const trimmedLength = userMsg.length;
    chatMessagesSentRef.current += 1;
    homeShortcutMessagesSentRef.current += 1;
    setHomeShortcutMessagesSent(homeShortcutMessagesSentRef.current);
    if (isPersonalHoroscopeChat) {
      homeShortcutAstroMessagesSentRef.current += 1;
      setHomeShortcutAstroMessagesSent(homeShortcutAstroMessagesSentRef.current);
    }
    trackEvent('message_sent', {
      category: 'Chat',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      message_length: trimmedLength,
      personal_mode: isPersonalHoroscopeChat,
      dinacharya_mode: isDinacharyaRequest,
    });

    if (!chatEngagedTrackedRef.current && chatMessagesSentRef.current >= 3) {
      let alreadyTracked = false;
      try {
        alreadyTracked = sessionStorage.getItem(chatEngagedStorageKey) === '1';
      } catch {}

      if (!alreadyTracked) {
        try {
          sessionStorage.setItem(chatEngagedStorageKey, '1');
        } catch {}

        trackEvent('engaged_chat_user', {
          category: 'Chat',
          device_type: getDeviceType(),
          ui_language: i18n.language,
          messages_sent: chatMessagesSentRef.current,
          personal_mode: isPersonalHoroscopeChat,
        });
      }

      chatEngagedTrackedRef.current = true;
    }
    if (isPersonalHoroscopeChat && showAstroConversationTip) {
      setShowAstroConversationTip(false);
    }

    const sendToken = sendMessageTokenRef.current + 1;
    sendMessageTokenRef.current = sendToken;
    exploreTopicsTokenRef.current += 1;
    const prevAbortController = sendMessageAbortControllerRef.current;
    if (prevAbortController) {
      setChatHistory(prev => {
        const updatedHistory = [...prev];
        for (let i = updatedHistory.length - 1; i >= 0; i -= 1) {
          const m = updatedHistory[i];
          if (m && m.isUser === false) {
            if (m.isLoading) {
              updatedHistory[i] = { ...m, isLoading: false };
            }
            break;
          }
        }
        return updatedHistory;
      });
      try { prevAbortController.abort(); } catch {}
    }
    const abortController = new AbortController();
    sendMessageAbortControllerRef.current = abortController;

    let currentThreadId = ThreadId;
    if (!currentThreadId) {
      try {
        currentThreadId = await createAndSelectThread({ personalMode: isPersonalHoroscopeChat, guard: { token: sendToken, ref: sendMessageTokenRef } });
      } catch (error) {
        if (isMountedRef.current && sendMessageTokenRef.current === sendToken) {
          setLoading(false);
          setIsStreaming(false);
          if (isDinacharyaRequest) setIsDinacharyaGenerating(false);
        }
        console.error('Error creating new chat thread:', error);
        if (isUsageLimitError(error)) {
          openUsageLimitModal(error);
        } else {
          toast.error(t('chat.create_failed'), { position: 'bottom-right' });
        }
        return;
      }
    }

    if (!isMountedRef.current) return;
    if (sendMessageTokenRef.current !== sendToken) return;
    activeThreadIdRef.current = currentThreadId;

    // Track the last user message for retry functionality
    setLastUserMessage(userMsg);
    lastSendOptionsRef.current = isDinacharyaRequest
      ? { dinacharyaMode: true, dinacharyaGocharaDate: dinacharyaGeneratedForDate || undefined }
      : {};
    setHasFailedMessage(false);
    setRetryingMessage(false);

    let dinacharyaTimelinePayloadForPdf: DayTimelinePayload | null = null;
    let dinacharyaTimelineModeForPdf: 'basic' | 'advanced' | null = null;
    let dinacharyaTimelineDateForPdf: string | null = null;

    const newUserMessage = { text: userMsg, isUser: true, footnotes: {}, personalMode: isPersonalHoroscopeChat };
    const aiMessageIndex = chatHistory.length + 1;
    const userMessageCount = chatHistory.filter(item => item?.isUser).length + 1;
    setChatHistory(prev => [
      ...prev,
      newUserMessage,
      {
        text: '',
        isUser: false,
        isLoading: true,
        footnotes: {},
        thoughtText: '',
        isDinacharya: isDinacharyaRequest,
        dinacharyaGeneratedForDate,
        staticDinacharyaLibraryVersion: isDinacharyaRequest ? '2026-04-29.v1' : null,
        dinacharyaSubjectDisplayName: dinacharyaSubjectSnapshot?.displayName || null,
        dinacharyaBirthDetails: dinacharyaSubjectSnapshot?.birthDetails || null,
        dinacharyaTimelinePayload: null,
        dinacharyaTimelineMode: null,
        dinacharyaTimelineDate: null,
      },
    ]);
    setThinkingPanelOpen(prev => ({ ...prev, [aiMessageIndex]: true }));
    setMessage('');
    setIsChatOpen(true);
    setIsStreaming(true);
    if (!isPersonalHoroscopeChat && currentThreadId) {
      scheduleAstroNudge(userMsg, String(currentThreadId), userMessageCount);
    }

    const finalizeThisAssistantMessage = () => {
      setChatHistory(prev => {
        if (activeThreadIdRef.current !== currentThreadId) return prev;
        if (aiMessageIndex < 0 || aiMessageIndex >= prev.length) return prev;
        const updatedHistory = [...prev];
        const target = updatedHistory[aiMessageIndex];
        if (target && target.isUser === false && target.isLoading) {
          const expansionFields = doneCanExpand ? {
            expansionToken: doneExpansionToken,
            remainingCount: doneRemainingCount,
            canExpand: true,
          } : {};
          const readingFields = doneCanRead ? {
            canRead: true,
            readSources: doneReadSources,
          } : {};
          const dinacharyaTimelineFields = isDinacharyaRequest ? {
            dinacharyaTimelinePayload: dinacharyaTimelinePayloadForPdf,
            dinacharyaTimelineMode: dinacharyaTimelineModeForPdf,
            dinacharyaTimelineDate: dinacharyaTimelineDateForPdf,
          } : {};
          updatedHistory[aiMessageIndex] = { ...target, isLoading: false, thoughtText: '', ...dinacharyaTimelineFields, ...expansionFields, ...readingFields };
        }
        return updatedHistory;
      });
      if (doneCanRead && doneReadSources.length > 0 && currentThreadId) {
        scheduleReadingNudge(aiMessageIndex, String(currentThreadId), doneReadSources.length);
      }
      setThinkingPanelOpen(prev => ({ ...prev, [aiMessageIndex]: false }));
    };

    const filterArrays = selectedFilters.flatMap(filter => {
      const value = filterMapping[filter];
      if (Array.isArray(value)) return value;
      if (typeof value === 'string') return [value];
      return [];
    });

    let finalAnswerText = '';
    let finalFootnotes: any = {};
    let finalAnswerForDb = '';
    let thoughtText = '';
    let answerStarted = false;
    let doneExpansionToken = '';
    let doneRemainingCount = 0;
    let doneCanExpand = false;
    let doneCanRead = false;
    let doneReadSources: Array<{key: string; label: string; ci: number; token: string}> = [];

    try {
      const sanitizeHistoryText = (value: any) => {
        const text = typeof value === 'string' ? value : '';
        const withoutDataImages = text
          .replace(/<svg\b[\s\S]*?<\/svg>/gi, '')
          .replace(/data:image\/svg\+xml[^"'\s)<>]*/gi, '')
          .replace(/data:image\/png[^"'\s)<>]*/gi, '')
          .replace(/data:image\/jpeg[^"'\s)<>]*/gi, '')
          .replace(/data:image\/webp[^"'\s)<>]*/gi, '');
        if (!isPersonalHoroscopeChat) return withoutDataImages;
        return withoutDataImages.replace(/<img\b[^>]*>/gi, '');
      };

      const sanitizedHistory = chatHistory.slice(-10).map((m: any) => ({
        ...m,
        text: sanitizeHistoryText(m?.text),
      }));

      let promptTimelineMode: 'basic' | 'advanced' = astroTimelineMode;
      let promptTimelineDate = dinacharyaGeneratedForDate || astroTimelineDate || getClientLocalDateIso();
      let promptTimelineIsToday = promptTimelineDate === getClientLocalDateIso();
      let promptTimelineSummary = buildAstroTimelineSummary();

      if (isPersonalHoroscopeChat && isDinacharyaRequest) {
        try {
          const advancedTimeline = await fetchAstroTimelineForPrompt({
            mode: 'advanced',
            targetDate: promptTimelineDate,
            threadId: currentThreadId,
          });

          if (!isMountedRef.current) return;
          if (sendMessageTokenRef.current !== sendToken) return;

          if (advancedTimeline) {
            promptTimelineMode = advancedTimeline.mode;
            promptTimelineDate = advancedTimeline.date || promptTimelineDate;
            promptTimelineIsToday = advancedTimeline.isToday;
            dinacharyaTimelinePayloadForPdf = advancedTimeline.timeline;
            dinacharyaTimelineModeForPdf = advancedTimeline.mode;
            dinacharyaTimelineDateForPdf = advancedTimeline.date || promptTimelineDate;
            promptTimelineSummary = buildAstroTimelineDetailedSummary(
              advancedTimeline.timeline,
              promptTimelineDate,
              promptTimelineMode,
            ) || promptTimelineSummary;
            setChatHistory(prev => {
              if (sendMessageTokenRef.current !== sendToken) return prev;
              if (activeThreadIdRef.current !== currentThreadId) return prev;
              if (aiMessageIndex < 0 || aiMessageIndex >= prev.length) return prev;
              const updatedHistory = [...prev];
              const target = updatedHistory[aiMessageIndex];
              if (target && target.isUser === false) {
                updatedHistory[aiMessageIndex] = {
                  ...target,
                  dinacharyaTimelinePayload: dinacharyaTimelinePayloadForPdf,
                  dinacharyaTimelineMode: dinacharyaTimelineModeForPdf,
                  dinacharyaTimelineDate: dinacharyaTimelineDateForPdf,
                };
              }
              return updatedHistory;
            });
          }
        } catch (timelineError) {
          console.warn('Could not fetch advanced Dinacharya day-quality timeline; using current timeline summary.', timelineError);
        }

        if (!promptTimelineSummary) {
          promptTimelineSummary = buildAstroTimelineDetailedSummary(
            astroDayTimeline,
            promptTimelineDate,
            promptTimelineMode,
          );
        }
      }

	      const payload = {
	        user_prompt: userMsg,
	        history: sanitizedHistory,
	        authority: authorityRange,
        doc_types: filterArrays,
        is_fast_search: isDinacharyaRequest ? false : isFastSearch,
        mode: effectiveRequestMode,
        listening_mode: requestUsedListeningMode,
        locale: i18n.language,
        personal_mode: isPersonalHoroscopeChat,
        astro_prompt_mode: isPersonalHoroscopeChat ? (isDinacharyaRequest ? 'astro_advanced_mode' : astroPromptMode) : undefined,
        astro_day_timeline_mode: isPersonalHoroscopeChat ? promptTimelineMode : undefined,
        astro_day_timeline_date: isPersonalHoroscopeChat ? promptTimelineDate : undefined,
	        astro_day_timeline_is_today: isPersonalHoroscopeChat ? promptTimelineIsToday : undefined,
	        astro_day_timeline_summary: isPersonalHoroscopeChat ? promptTimelineSummary : undefined,
            dinacharya_mode: isDinacharyaRequest,
            dinacharya_gochara_date: dinacharyaGeneratedForDate || undefined,
            thread_id: currentThreadId,
	        ...getClientTimezone(),
	      };

      const response = await chatfn(payload, false, { signal: abortController.signal });
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let rawStream = '';
      let sseBuffer = '';
      let treatAsSse = false;

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        if (!isMountedRef.current) return;
        if (sendMessageTokenRef.current !== sendToken) {
          try { await reader.cancel(); } catch {}
          finalizeThisAssistantMessage();
          return;
        }

        const chunk = decoder.decode(value, { stream: true });
        rawStream += chunk;

        if (!treatAsSse && rawStream.trimStart().startsWith('data:')) {
          treatAsSse = true;
        }

        if (!treatAsSse) {
          finalAnswerText += chunk;
          if (!answerStarted && finalAnswerText.trim().length > 0) {
            answerStarted = true;
            setThinkingPanelOpen(prev => ({ ...prev, [aiMessageIndex]: false }));
          }
          setChatHistory(prev => {
            if (sendMessageTokenRef.current !== sendToken) return prev;
            if (activeThreadIdRef.current !== currentThreadId) return prev;
            const updatedHistory = [...prev];
            const lastIndex = updatedHistory.length - 1;
            updatedHistory[lastIndex] = {
              ...updatedHistory[lastIndex],
              text: finalAnswerText,
              thoughtText: '',
              isLoading: true,
              footnotes: {},
            };
            return updatedHistory;
          });
          continue;
        }

        sseBuffer += chunk;
        while (true) {
          const boundaryIndex = sseBuffer.indexOf('\n\n');
          if (boundaryIndex === -1) break;

          const frame = sseBuffer.slice(0, boundaryIndex);
          sseBuffer = sseBuffer.slice(boundaryIndex + 2);

          const dataLines = frame
            .split('\n')
            .map(l => l.trimEnd())
            .filter(l => l.startsWith('data:'));

          if (dataLines.length === 0) continue;

          const dataStr = dataLines.map(l => l.slice(5).trimStart()).join('\n').trim();
          if (!dataStr) continue;

          try {
            const payloadObj = JSON.parse(dataStr);
            if (payloadObj?.type === 'thought_delta' && typeof payloadObj.text === 'string') {
              if (!answerStarted) {
                thoughtText += payloadObj.text;
              }
            } else if (payloadObj?.type === 'answer_delta' && typeof payloadObj.text === 'string') {
              finalAnswerText += payloadObj.text;
              if (!answerStarted && finalAnswerText.trim().length > 0) {
                answerStarted = true;
                setThinkingPanelOpen(prev => ({ ...prev, [aiMessageIndex]: false }));
                thoughtText = '';
              }
            } else if (payloadObj?.type === 'error') {
              // Handle backend error frames with user-friendly messages
              const status = payloadObj.status;
              const rawDetail = String(payloadObj.detail || '');
              const detail = rawDetail.toLowerCase();
              let userMessage: string;
              if (status === 429 || detail.includes('rate-limit') || detail.includes('resource_exhausted')) {
                userMessage = t('chat.high_traffic', 'High traffic right now. Please try again in a moment.');
              } else if (status === 403 || detail.includes('inactive') || detail.includes('expired') || isUsageLimitError(rawDetail)) {
                const usageLimited = isUsageLimitError(rawDetail);
                userMessage = usageLimited
                  ? getUsageLimitMessage(rawDetail)
                  : t('chat.plan_inactive', 'Your plan is inactive or out of tokens. Please check your subscription.');
                if (usageLimited) {
                  openUsageLimitModal(rawDetail);
                }
              } else {
                userMessage = t('chat.something_went_wrong', 'Something went wrong. Please try again.');
              }
              console.warn('[SSE error frame]', payloadObj.status, payloadObj.detail);
              finalAnswerText = userMessage;
              if (!answerStarted) {
                answerStarted = true;
                setThinkingPanelOpen(prev => ({ ...prev, [aiMessageIndex]: false }));
                thoughtText = '';
              }
              setHasFailedMessage(true);
              messageFailed = true;
            } else if (payloadObj?.type === 'done') {
              // Capture expansion metadata from done SSE (backward compatible)
              if (payloadObj.expansion_token) {
                doneExpansionToken = payloadObj.expansion_token;
                doneRemainingCount = payloadObj.remaining_count || 0;
                doneCanExpand = payloadObj.can_expand || false;
              }
              // Capture reading mode metadata from done SSE
              if (payloadObj.can_read && Array.isArray(payloadObj.read_sources)) {
                doneCanRead = true;
                doneReadSources = payloadObj.read_sources;
              }
            } else if (typeof payloadObj?.answer === 'string') {
              finalAnswerText = payloadObj.answer;
              if (payloadObj?.footnotes) {
                finalFootnotes = payloadObj.footnotes;
              }
              if (!answerStarted && finalAnswerText.trim().length > 0) {
                answerStarted = true;
                setThinkingPanelOpen(prev => ({ ...prev, [aiMessageIndex]: false }));
                thoughtText = '';
              }
            }
        } catch (_e) {
          finalAnswerText += dataStr;
        }

        setChatHistory(prev => {
          if (sendMessageTokenRef.current !== sendToken) return prev;
          if (activeThreadIdRef.current !== currentThreadId) return prev;
          const updatedHistory = [...prev];
          const lastIndex = updatedHistory.length - 1;
          updatedHistory[lastIndex] = {
              ...updatedHistory[lastIndex],
              text: finalAnswerText,
              thoughtText: answerStarted ? '' : thoughtText,
              isLoading: true,
              footnotes: finalFootnotes || {},
            };
            return updatedHistory;
          });
        }
      }

      // Final processing after stream ends
      finalAnswerForDb = cleanAnswerSourceFooters(finalAnswerText);
      if (!finalAnswerForDb && rawStream && rawStream.trimStart().startsWith('data:')) {
        const lastEvent = rawStream.trim().split('\n\n').filter(Boolean).pop() || '';
        const lastDataLine = lastEvent.split('\n').map(l => l.trimEnd()).find(l => l.startsWith('data:')) || '';
        const lastDataStr = lastDataLine.replace(/^data:\s*/, '').trim();
        try {
          const parsed = JSON.parse(lastDataStr);
          if (typeof parsed?.answer === 'string') {
            finalAnswerForDb = cleanAnswerSourceFooters(parsed.answer);
            if (parsed?.footnotes) {
              finalFootnotes = parsed.footnotes;
            }
          }
        } catch (_e) {
        }
      }
      if (!finalAnswerForDb) {
        finalAnswerForDb = t('chat.something_went_wrong');
        toast.error(t('chat.server_invalid_response'), { position: 'bottom-right' });
        setHasFailedMessage(true);
        messageFailed = true;
      }

      // Update the final chat history with complete response and footnotes
      setChatHistory(prev => {
        if (sendMessageTokenRef.current !== sendToken) return prev;
        if (activeThreadIdRef.current !== currentThreadId) return prev;
        const updatedHistory = [...prev];
        const lastIndex = updatedHistory.length - 1;
        const expansionFields = doneCanExpand ? {
          expansionToken: doneExpansionToken,
          remainingCount: doneRemainingCount,
          canExpand: true,
        } : {};
        const readingFields = doneCanRead ? {
          canRead: true,
          readSources: doneReadSources,
        } : {};
        updatedHistory[lastIndex] = {
          ...updatedHistory[lastIndex],
          text: finalAnswerForDb, // Use the final, complete answer
          footnotes: finalFootnotes,
          thoughtText: '',
          isLoading: false,
          ...expansionFields,
          ...readingFields,
        };
        return updatedHistory;
      });
      if (doneCanRead && doneReadSources.length > 0 && currentThreadId) {
        scheduleReadingNudge(aiMessageIndex, String(currentThreadId), doneReadSources.length);
      }
      setThinkingPanelOpen(prev => ({ ...prev, [aiMessageIndex]: false }));
      if (!messageFailed && finalAnswerForDb) {
        recordAudioModeAnswer(requestUsedListeningMode, canShowAudioModeReminderRef.current);
      }

    } catch (error: any) {
      if (!isMountedRef.current) return;
      if (sendMessageTokenRef.current !== sendToken) return;
      if (abortController.signal.aborted || error?.name === 'AbortError') {
        finalizeThisAssistantMessage();
        return;
      }
      console.error('Error in chatfn stream:', error);
      
      // Check if this is a token exhaustion error (403 status with specific messages)
      const errorMessage = errorDetailText(error);
      const isTokenExhausted = isUsageLimitError(errorMessage);
      
      if (isTokenExhausted) {
        // Show the rate limit exceeded modal instead of generic error
        openUsageLimitModal(errorMessage);
        
        // Update chat history with a specific token exhaustion message
        setChatHistory(prev => {
          if (activeThreadIdRef.current !== currentThreadId) return prev;
          const updatedHistory = [...prev];
          const lastIndex = updatedHistory.length - 1;
          updatedHistory[lastIndex] = {
            ...updatedHistory[lastIndex],
            text: getUsageLimitMessage(errorMessage), 
            isUser: false, 
            isLoading: false, 
            footnotes: {} 
          };
          return updatedHistory;
        });
      } else {
        // Handle other errors with the generic error message
        toast.error(t('chat.unexpected_error'), { position: 'bottom-right' });
        
        // Mark message as failed for retry functionality
        setHasFailedMessage(true);
        messageFailed = true;
        
        setChatHistory(prev => {
          if (activeThreadIdRef.current !== currentThreadId) return prev;
          const updatedHistory = [...prev];
          const lastIndex = updatedHistory.length - 1;
          updatedHistory[lastIndex] = { ...updatedHistory[lastIndex], text: t('chat.something_went_wrong'), isUser: false, isLoading: false, footnotes: {} };
          return updatedHistory;
        });
      }
    } finally {
      const ownsAbortController = sendMessageAbortControllerRef.current === abortController;
      const shouldFinalize =
        isMountedRef.current && (sendMessageTokenRef.current === sendToken || ownsAbortController);
      if (shouldFinalize) {
        if (ownsAbortController) {
          sendMessageAbortControllerRef.current = null;
        }
        setLoading(false);
        setIsStreaming(false);
        if (isDinacharyaRequest) {
          setIsDinacharyaGenerating(false);
        }
        try {
          if (currentThreadId && finalAnswerForDb) {
            const currentThread = threads.find(t => t.id === currentThreadId);
            const existingTitle =
              currentThread?.chat_title ||
              currentThread?.messages?.[0]?.title ||
              currentThread?.name;
            const isDefaultTitle =
              !existingTitle ||
              existingTitle === 'New Chat' ||
              existingTitle === t('chat.new_chat') ||
              existingTitle === 'Untitled Chat' ||
              existingTitle.trim() === '';
            const titleToSave = isDefaultTitle ? userMsg : existingTitle;

            const messagePayload = {
              text: finalAnswerForDb,
              user_id: userId,
              question: userMsg,
              title: titleToSave,
              footnotes: finalFootnotes,
              personal_mode: isPersonalHoroscopeChat,
              is_dinacharya: isDinacharyaRequest,
              dinacharya_generated_for_date: isDinacharyaRequest ? dinacharyaGeneratedForDate : null,
              static_dinacharya_library_version: isDinacharyaRequest ? '2026-04-29.v1' : null,
              dinacharya_subject_display_name: isDinacharyaRequest ? (dinacharyaSubjectSnapshot?.displayName || null) : null,
              dinacharya_birth_details: isDinacharyaRequest ? (dinacharyaSubjectSnapshot?.birthDetails || null) : null,
              dinacharya_timeline_payload: isDinacharyaRequest ? dinacharyaTimelinePayloadForPdf : null,
              dinacharya_timeline_mode: isDinacharyaRequest ? dinacharyaTimelineModeForPdf : null,
              dinacharya_timeline_date: isDinacharyaRequest ? dinacharyaTimelineDateForPdf : null,
            };

            if (!messageFailed) {
              const saveRes = await addMessageToThread(currentThreadId, messagePayload);
              if (saveRes?.old_history_unavailable) {
                // The active thread was a pre-v2 legacy thread — reset to a fresh chat.
                handleOldHistoryUnavailable(saveRes?.detail);
              } else {
                // Stamp the saved turn's stable identity onto its two bubbles
                // (the last answer + its preceding question) so they can be
                // bookmarked immediately, before any reload.
                const savedTurn = saveRes?.message?.turnIndex;
                const savedMsgId = saveRes?.message?.messageId;
                if (typeof savedTurn === 'number') {
                  setChatHistory(prev => {
                    const next = [...prev];
                    for (let i = next.length - 1; i >= 0 && i >= next.length - 2; i--) {
                      next[i] = { ...next[i], turnIndex: savedTurn, messageId: savedMsgId };
                    }
                    return next;
                  });
                }
                const updatedThreads = await getUserThreadsMetadata(userId);
                const nextThreads = updatedThreads?.threads || [];
                setThreads(nextThreads);
                writeThreadMetaCache(userId, nextThreads);
              }
            }
          }
        } catch (dbError) {
          console.error('Error saving message to thread:', dbError);
          if (isUsageLimitError(dbError)) {
            openUsageLimitModal(dbError);
          } else {
            toast.error(t('chat.save_message_failed'), { position: 'bottom-right' });
          }
        }
      }
    }
  };

  const fetchExploreTopics = async (isListening: boolean) => {
    const token = exploreTopicsTokenRef.current + 1;
    exploreTopicsTokenRef.current = token;
    const threadKeyAtStart = String(activeThreadIdRef.current ?? 'no-thread');
    try {
      const user = auth.currentUser;
      if (!user) return;

      const idToken = await user.getIdToken();
      const appCheckToken = await getToken(appCheck, false);

      const res = await fetch(
        `${import.meta.env.VITE_APP_SERVER}/api/explore-topics`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Firebase-AppCheck': appCheckToken.token,
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify({ listening_mode: isListening }),
        }
      );
      const data = await res.json();
      if (!isMountedRef.current) return;
      if (exploreTopicsTokenRef.current !== token) return;
      if (String(activeThreadIdRef.current ?? 'no-thread') !== threadKeyAtStart) return;
      setTopics(data.topics ?? []);
      setShowExplore(true);
    } catch (e) {
      console.error('Explore-topics fetch failed', e);
      if (!isMountedRef.current) return;
      if (exploreTopicsTokenRef.current !== token) return;
      if (String(activeThreadIdRef.current ?? 'no-thread') !== threadKeyAtStart) return;
      setShowExplore(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value.slice(0, CHAT_INPUT_MAX_CHARS));
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (loading || isStreaming) return;
      if (!message.trim()) return;
      void handleSendMessage();
    }
  };

  const handleStopGenerating = useCallback(() => {
    try {
      sendMessageAbortControllerRef.current?.abort();
    } catch {}
    sendMessageAbortControllerRef.current = null;
    setLoading(false);
    setIsStreaming(false);
    setIsDinacharyaGenerating(false);
    setThinkingPanelOpen({});
    setChatHistory(prev => {
      const updatedHistory = [...prev];
      for (let i = updatedHistory.length - 1; i >= 0; i -= 1) {
        const m = updatedHistory[i];
        if (m && m.isUser === false) {
          if (m.isLoading) {
            updatedHistory[i] = { ...m, isLoading: false, thoughtText: '' };
          }
          break;
        }
      }
      return updatedHistory;
    });
  }, []);

  const handleRetryMessage = async () => {
    if (!lastUserMessage.trim() || retryingMessage) {
      return;
    }
    
    setRetryingMessage(true);
    setHasFailedMessage(false);
    
    // Remove the failed message from chat history
    setChatHistory(prev => {
      const updatedHistory = [...prev];
      if (updatedHistory.length > 0 && !updatedHistory[updatedHistory.length - 1].isUser) {
        updatedHistory.pop(); // Remove the failed AI response
      }
      return updatedHistory;
    });
    
    // Resend the last user message
    await handleSendMessage(lastUserMessage, lastSendOptionsRef.current);
  };

  // --- Progressive Context Expansion handler ---
  const handleExpand = async (messageIndex: number) => {
    const msg = chatHistory[messageIndex];
    if (!msg || !msg.expansionToken || msg.isExpanding || msg.expansionText) return;

    // Mark as expanding
    setChatHistory(prev => {
      const updated = [...prev];
      updated[messageIndex] = { ...updated[messageIndex], isExpanding: true };
      return updated;
    });

    try {
      const response = await expandAnswer({
        expansion_token: msg.expansionToken,
        previous_answer: (msg.text || '').slice(0, 2000),
      });

      const reader = response.body?.getReader();
      if (!reader) throw new Error('No response body');
      const decoder = new TextDecoder();
      let expansionText = '';
      let sseBuffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        sseBuffer += chunk;

        while (true) {
          const boundaryIndex = sseBuffer.indexOf('\n\n');
          if (boundaryIndex === -1) break;
          const frame = sseBuffer.slice(0, boundaryIndex);
          sseBuffer = sseBuffer.slice(boundaryIndex + 2);

          const dataLines = frame.split('\n').map(l => l.trimEnd()).filter(l => l.startsWith('data:'));
          if (dataLines.length === 0) continue;
          const dataStr = dataLines.map(l => l.slice(5).trimStart()).join('\n').trim();
          if (!dataStr) continue;

          try {
            const payloadObj = JSON.parse(dataStr);
            if (payloadObj?.type === 'answer_delta' && typeof payloadObj.text === 'string') {
              expansionText += payloadObj.text;
            } else if (payloadObj?.type === 'error') {
              expansionText += payloadObj.detail || t('chat.expansion_error', 'Expansion failed.');
            }
          } catch { /* ignore parse errors */ }

          // Update expansion text progressively
          setChatHistory(prev => {
            const updated = [...prev];
            if (messageIndex < updated.length) {
              updated[messageIndex] = { ...updated[messageIndex], expansionText, isExpanding: true };
            }
            return updated;
          });
        }
      }

      // Finalize expansion
      setChatHistory(prev => {
        const updated = [...prev];
        if (messageIndex < updated.length) {
          updated[messageIndex] = {
            ...updated[messageIndex],
            expansionText: expansionText || t('chat.no_additional_details', 'No additional details found.'),
            isExpanding: false,
            canExpand: false,
          };
        }
        return updated;
      });
    } catch (error: any) {
      const errorMsg = errorDetailText(error);
      const isTokenExhausted = isUsageLimitError(errorMsg);
      if (isTokenExhausted) {
        openUsageLimitModal(errorMsg);
        setChatHistory(prev => {
          const updated = [...prev];
          if (messageIndex < updated.length) {
            updated[messageIndex] = { ...updated[messageIndex], isExpanding: false, canExpand: false };
          }
          return updated;
        });
        return;
      }
      const isExpired = errorMsg.includes('410') || errorMsg.includes('expired');
      setChatHistory(prev => {
        const updated = [...prev];
        if (messageIndex < updated.length) {
          updated[messageIndex] = {
            ...updated[messageIndex],
            expansionText: isExpired
              ? t('chat.expansion_expired', 'This expansion has expired. Please ask the question again.')
              : t('chat.expansion_error', 'Expansion failed. Please try again.'),
            isExpanding: false,
            canExpand: false,
          };
        }
        return updated;
      });
    }
  };

  const handleAuthorityChange = (min: number, max: number) => {
    if (min > max) {
      setAuthorityError(t('chat.authority.error_min_exceeds_max'));
    } else if (max < min) {
      setAuthorityError(t('chat.authority.error_max_less_min'));
    } else {
      setAuthorityError('');
      const newRange: [number, number] = [min, max];
      setAuthorityRange(newRange);
      localStorage.setItem('authorityRange', JSON.stringify(newRange));
    }
  };

  const handleFilterChange = (filter: string) => {
    // If any regular filter is selected, deselect listening mode
    if (!selectedFilters.includes(filter)) {
      setIsListeningMode(false);
      localStorage.setItem('isListeningMode', 'false');
      setIsFastSearch(false);
      // Don't force mode change when filters change - preserve user's toggle preference
    }

    setSelectedFilters(prev => {
      const newFilters = prev.includes(filter)
        ? prev.filter(f => f !== filter)
        : [...prev, filter];
      localStorage.setItem('selectedFilters', JSON.stringify(newFilters));
      return newFilters;
    });
  };

  // Handle mode changes and persist to localStorage
  const handleModeChange = (newMode: 'citation' | 'normal') => {
    setMode(newMode);
    localStorage.setItem('citationMode', newMode);
  };

  const handleAstroPromptModeChange = (newMode: 'astro_standard_mode' | 'astro_advanced_mode') => {
    setAstroPromptMode(newMode);
    try {
      localStorage.setItem('astroPromptMode', newMode);
    } catch {}
  };

  const handleListeningModeChange = () => {
    setIsListeningMode(prev => {
      const newValue = !prev;
      if (newValue) {
        // When listening mode is enabled, clear all other filters and modes
        setSelectedFilters([]);
        localStorage.removeItem('selectedFilters');
        setIsFastSearch(false);
        // Don't set mode when listening mode is enabled - let backend handle it
      } else {
        // When listening mode is disabled, restore the previously saved mode from localStorage
        const storedMode = localStorage.getItem('citationMode');
        if (storedMode === 'citation' || storedMode === 'normal') {
          setMode(storedMode as 'citation' | 'normal');
        }
      }
      // ✅ PERSIST LISTENING MODE STATE TO LOCALSTORAGE
      localStorage.setItem('isListeningMode', JSON.stringify(newValue));
      return newValue;
    });
  };

  const turnOffListeningMode = useCallback(() => {
    setIsListeningMode(false);
    localStorage.setItem('isListeningMode', 'false');
    const storedMode = localStorage.getItem('citationMode');
    if (storedMode === 'citation' || storedMode === 'normal') {
      setMode(storedMode as 'citation' | 'normal');
    }
  }, []);

  const enableListeningMode = useCallback(() => {
    setSelectedFilters([]);
    localStorage.removeItem('selectedFilters');
    setIsFastSearch(false, { personalMode: false });
    setIsListeningMode(true);
    localStorage.setItem('isListeningMode', 'true');
  }, [setIsFastSearch]);

  const modeDraftByKindRef = useRef<Record<'heritage' | 'astro', string>>({ heritage: '', astro: '' });
  const modeScrollByKindRef = useRef<Record<'heritage' | 'astro', number>>({ heritage: 0, astro: 0 });

  const currentModeKind = isPersonalHoroscopeChat || showPersonalMode || showCompatibilityMode ? 'astro' : 'heritage';

  const rememberCurrentModeUiState = useCallback(() => {
    const modeKind = isPersonalHoroscopeChat || showPersonalMode || showCompatibilityMode ? 'astro' : 'heritage';
    modeDraftByKindRef.current[modeKind] = message;
    modeScrollByKindRef.current[modeKind] = scrollContainerRef.current?.scrollTop || 0;
  }, [isPersonalHoroscopeChat, message, showCompatibilityMode, showPersonalMode]);

  const restoreModeUiState = useCallback((modeKind: 'heritage' | 'astro') => {
    setMessage(modeDraftByKindRef.current[modeKind] || '');
    requestAnimationFrame(() => {
      const scroller = scrollContainerRef.current;
      if (scroller) scroller.scrollTop = modeScrollByKindRef.current[modeKind] || 0;
      chatTextareaRef.current?.focus();
    });
  }, []);

  const enterHeritageMode = useCallback(async () => {
    rememberCurrentModeUiState();
    const token = astroNavTokenRef.current + 1;
    astroNavTokenRef.current = token;
    compatibilityNavTokenRef.current += 1;
    threadMessagesTokenRef.current += 1;
    sendMessageTokenRef.current += 1;
    exploreTopicsTokenRef.current += 1;
    sendMessageAbortControllerRef.current?.abort();
    sendMessageAbortControllerRef.current = null;

    if (isPersonalHoroscopeChat && ThreadId) {
      persistModeThreadId(String(ThreadId), true);
    }

    setShowPersonalMode(false);
    setShowCompatibilityMode(false);
    setCompatibilityResult(null);
    setIsCompatibilityLoading(false);
    setIsPersonalHoroscopeChat(false);
    setAstroDayTimeline(null);
    setAstroTimelineDate('');
    setAstroTimelinePickError(null);
    setShowDayTimeline(true);
    setLoading(false);
    setIsStreaming(false);
    setIsDinacharyaGenerating(false);
    setIsThreadMessagesLoading(false);
    setLoadingThreadId(null);
    setChatHistory([]);

    try {
      const storedGeneral = localStorage.getItem(getGeneralThreadStorageKey());
      if (token !== astroNavTokenRef.current) return;
      if (storedGeneral) {
        await selectThread(storedGeneral, { personalMode: false, persist: true });
        if (token !== astroNavTokenRef.current) return;
        restoreModeUiState('heritage');
        return;
      }

      try {
        localStorage.removeItem('thread_id');
      } catch {}
      setThreadId(undefined);
      activeThreadIdRef.current = undefined;
      clearThreadIdFromUrl();
      setIsChatOpen(false);
      if (token !== astroNavTokenRef.current) return;
      restoreModeUiState('heritage');
    } catch (error) {
      console.error('Error entering Heritage mode:', error);
      toast.error(t('chat.create_failed'), { position: 'bottom-right' });
    }
  }, [
    ThreadId,
    clearThreadIdFromUrl,
    getGeneralThreadStorageKey,
    isPersonalHoroscopeChat,
    persistModeThreadId,
    rememberCurrentModeUiState,
    restoreModeUiState,
    selectThread,
    t,
  ]);

  const openAstroModeFromSharedControl = useCallback(async () => {
    rememberCurrentModeUiState();
    const token = astroNavTokenRef.current;
    if (userReportStatus.has_horoscope) {
      await enterAstroMode();
      if (token !== astroNavTokenRef.current) return;
      await ensureTodayTimelineVisible(token);
      restoreModeUiState('astro');
      return;
    }

    if (personalModeLoading) return;
    if (!personalModeEnabled) {
      toast.info(t('chat.mode_tabs.chart_required', 'Create your chart to use Astro Mode.'));
      return;
    }
    setPersonalModeSource('welcome');
    setShowCompatibilityMode(false);
    setShowPersonalMode(true);
    setIsChatOpen(false);
    restoreModeUiState('astro');
  }, [
    enterAstroMode,
    ensureTodayTimelineVisible,
    personalModeEnabled,
    personalModeLoading,
    rememberCurrentModeUiState,
    restoreModeUiState,
    t,
    userReportStatus.has_horoscope,
  ]);

  const modeSwitchDisabled =
    loading ||
    isStreaming ||
    isThreadMessagesLoading ||
    Boolean(loadingThreadId) ||
    isRefreshingTransits ||
    isReadingModalOpen ||
    showAstroFirstTimeDemo ||
    showAstroTour;

  const handleModeTabClick = useCallback(async (targetMode: 'heritage' | 'astro') => {
    if (modeSwitchDisabled) {
      toast.info(t('chat.mode_tabs.streaming_blocked', 'Finish the current answer before switching chats.'));
      return;
    }
    if (targetMode === currentModeKind) return;
    if (targetMode === 'astro') {
      await openAstroModeFromSharedControl();
      return;
    }
    await enterHeritageMode();
  }, [currentModeKind, enterHeritageMode, modeSwitchDisabled, openAstroModeFromSharedControl, t]);

  useEffect(() => {
    if (!userId) return;

    homeShortcutMessagesSentRef.current = 0;
    homeShortcutAstroMessagesSentRef.current = 0;
    setHomeShortcutMessagesSent(0);
    setHomeShortcutAstroMessagesSent(0);
    setShowHomeShortcutPrompt(false);
    setHomeShortcutPromptState(readHomeShortcutState(userId));
    setHomeShortcutAstroVisitCount(readHomeShortcutCount(HOME_SHORTCUT_ASTRO_VISIT_COUNT_BASE, userId));

    const visitKey = getHomeShortcutKey(HOME_SHORTCUT_CHAT_VISIT_COUNT_BASE, userId);
    const sessionKey = getHomeShortcutKey(HOME_SHORTCUT_CHAT_VISIT_SESSION_BASE, userId);

    try {
      const currentCount = readHomeShortcutCount(HOME_SHORTCUT_CHAT_VISIT_COUNT_BASE, userId);
      if (sessionStorage.getItem(sessionKey) === '1') {
        setHomeShortcutChatVisitCount(currentCount);
        return;
      }

      const nextCount = currentCount + 1;
      localStorage.setItem(visitKey, String(nextCount));
      sessionStorage.setItem(sessionKey, '1');
      setHomeShortcutChatVisitCount(nextCount);
    } catch {
      setHomeShortcutChatVisitCount(readHomeShortcutCount(HOME_SHORTCUT_CHAT_VISIT_COUNT_BASE, userId));
    }
  }, [userId]);

  useEffect(() => {
    if (!userId || currentModeKind !== 'astro') return;

    const visitKey = getHomeShortcutKey(HOME_SHORTCUT_ASTRO_VISIT_COUNT_BASE, userId);
    const sessionKey = getHomeShortcutKey(HOME_SHORTCUT_ASTRO_VISIT_SESSION_BASE, userId);

    try {
      const currentCount = readHomeShortcutCount(HOME_SHORTCUT_ASTRO_VISIT_COUNT_BASE, userId);
      if (sessionStorage.getItem(sessionKey) === '1') {
        setHomeShortcutAstroVisitCount(currentCount);
        return;
      }

      const nextCount = currentCount + 1;
      localStorage.setItem(visitKey, String(nextCount));
      sessionStorage.setItem(sessionKey, '1');
      setHomeShortcutAstroVisitCount(nextCount);
    } catch {
      setHomeShortcutAstroVisitCount(readHomeShortcutCount(HOME_SHORTCUT_ASTRO_VISIT_COUNT_BASE, userId));
    }
  }, [currentModeKind, userId]);

  const homeShortcutSuppressed = useMemo(() => {
    if (isRunningFromHomeShortcut()) return true;
    if (homeShortcutPromptState.completedAt || homeShortcutPromptState.dismissedForever) return true;
    return typeof homeShortcutPromptState.snoozedUntil === 'number' && homeShortcutPromptState.snoozedUntil > Date.now();
  }, [homeShortcutPromptState]);

  const homeShortcutPromptMode = currentModeKind === 'astro' ? 'astro' : 'general';
  const homeShortcutPromptEligible = useMemo(() => {
    if (!userId || !reportStatusLoaded || homeShortcutSuppressed) return false;
    if (
      pageloading ||
      loading ||
      isStreaming ||
      isThreadMessagesLoading ||
      Boolean(loadingThreadId) ||
      isReadingModalOpen ||
      showAstroFirstTimeDemo ||
      showAstroTour ||
      showPersonalMode ||
      showCompatibilityMode
    ) {
      return false;
    }

    const currentSessionTrigger = homeShortcutMessagesSent >= 5;
    const returningUserTrigger = homeShortcutChatVisitCount >= 2 && homeShortcutMessagesSent >= 3;
    const returningAstroTrigger =
      currentModeKind === 'astro' &&
      homeShortcutAstroVisitCount >= 2 &&
      homeShortcutAstroMessagesSent >= 3;

    return currentSessionTrigger || returningUserTrigger || returningAstroTrigger;
  }, [
    currentModeKind,
    homeShortcutAstroMessagesSent,
    homeShortcutAstroVisitCount,
    homeShortcutChatVisitCount,
    homeShortcutMessagesSent,
    homeShortcutSuppressed,
    isReadingModalOpen,
    isStreaming,
    isThreadMessagesLoading,
    loading,
    loadingThreadId,
    pageloading,
    reportStatusLoaded,
    showAstroFirstTimeDemo,
    showAstroTour,
    showCompatibilityMode,
    showPersonalMode,
    userId,
  ]);

  useEffect(() => {
    if (!userId || showHomeShortcutPrompt || !homeShortcutPromptEligible) return;
    const sessionKey = getHomeShortcutKey(HOME_SHORTCUT_PROMPT_SESSION_BASE, userId);
    try {
      if (sessionStorage.getItem(sessionKey) === '1') return;
      sessionStorage.setItem(sessionKey, '1');
    } catch {}

    setShowHomeShortcutPrompt(true);
    trackEvent('home_shortcut_prompt_shown', {
      category: 'Shortcut',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      mode: homeShortcutPromptMode,
      messages_sent: homeShortcutMessagesSent,
      chat_visit_count: homeShortcutChatVisitCount,
      astro_visit_count: homeShortcutAstroVisitCount,
    });
  }, [
    getDeviceType,
    homeShortcutAstroVisitCount,
    homeShortcutChatVisitCount,
    homeShortcutMessagesSent,
    homeShortcutPromptEligible,
    homeShortcutPromptMode,
    i18n.language,
    showHomeShortcutPrompt,
    userId,
  ]);

  const snoozeHomeShortcutPrompt = useCallback(() => {
    if (!userId) return;
    const nextState = {
      ...homeShortcutPromptState,
      snoozedUntil: Date.now() + HOME_SHORTCUT_SNOOZE_MS,
    };
    writeHomeShortcutState(userId, nextState);
    setHomeShortcutPromptState(nextState);
    setShowHomeShortcutPrompt(false);
    trackEvent('home_shortcut_prompt_snoozed', {
      category: 'Shortcut',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      mode: homeShortcutPromptMode,
      snooze_days: 7,
    });
  }, [getDeviceType, homeShortcutPromptMode, homeShortcutPromptState, i18n.language, userId]);

  const neverShowHomeShortcutPrompt = useCallback(() => {
    if (!userId) return;
    const nextState = {
      ...homeShortcutPromptState,
      dismissedForever: true,
    };
    writeHomeShortcutState(userId, nextState);
    setHomeShortcutPromptState(nextState);
    setShowHomeShortcutPrompt(false);
    trackEvent('home_shortcut_prompt_dismissed_forever', {
      category: 'Shortcut',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      mode: homeShortcutPromptMode,
    });
  }, [getDeviceType, homeShortcutPromptMode, homeShortcutPromptState, i18n.language, userId]);

  const markHomeShortcutDone = useCallback(() => {
    if (!userId) return;
    const nextState = {
      ...homeShortcutPromptState,
      completedAt: Date.now(),
      dismissedForever: true,
    };
    writeHomeShortcutState(userId, nextState);
    setHomeShortcutPromptState(nextState);
    setShowHomeShortcutPrompt(false);
    trackEvent('home_shortcut_prompt_done', {
      category: 'Shortcut',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      mode: homeShortcutPromptMode,
    });
  }, [getDeviceType, homeShortcutPromptMode, homeShortcutPromptState, i18n.language, userId]);

  const prepareHomeShortcutInstructions = useCallback(() => {
    if (homeShortcutPromptMode === 'astro') {
      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('id');
        url.searchParams.delete('new');
        url.searchParams.set('mode', 'astro');
        window.history.replaceState({}, document.title, url.toString());
      } catch {}
    }

    trackEvent('home_shortcut_instructions_opened', {
      category: 'Shortcut',
      device_type: getDeviceType(),
      ui_language: i18n.language,
      mode: homeShortcutPromptMode,
    });
  }, [getDeviceType, homeShortcutPromptMode, i18n.language]);

  const completedAssistantMessages = useMemo(
    () => chatHistory
      .map((msg, index) => ({ msg, index }))
      .filter(({ msg }) => !msg.isUser && !msg.isLoading && !msg.isSystemNote && Boolean(msg.text?.trim())),
    [chatHistory],
  );
  const latestCompletedAssistant = completedAssistantMessages.length
    ? completedAssistantMessages[completedAssistantMessages.length - 1]
    : null;
  const latestReadableAssistant = useMemo(
    () => [...completedAssistantMessages].reverse().find(({ msg }) => Boolean(msg.canRead && msg.readSources?.length)) ?? null,
    [completedAssistantMessages],
  );
  const announcementsSuppressed = Boolean(
    !isChatOpen ||
    loading ||
    isStreaming ||
    isThreadMessagesLoading ||
    loadingThreadId ||
    isReadingModalOpen ||
    showAstroFirstTimeDemo ||
    showAstroTour ||
    isRateLimitExceeded ||
    tokenlimitReached ||
    openShareMenuIndex !== null ||
    showPersonalMode ||
    showCompatibilityMode
  );
  const {
    slots: announcementSlots,
    dismissAnnouncementSlot,
    markAnnouncementActed,
  } = useSystemAnnouncements({
    assistantResponseCount: completedAssistantMessages.length,
    latestAssistantMessageIndex: latestCompletedAssistant?.index ?? null,
    mode: currentModeKind,
    threadKey: ThreadId ? String(ThreadId) : currentModeKind,
    suppressed: announcementsSuppressed,
    hasReadableAnswer: Boolean(latestReadableAssistant),
    isListeningMode,
    isQuizAvailable: canStartQuiz && !isQuizPreparing,
  });

  const handleAnnouncementAction = useCallback(async (action: SystemAnnouncementAction, slotKey: string) => {
    if (action.kind === 'open_quiz' && (!canStartQuiz || isQuizPreparing)) {
      return;
    }

    markAnnouncementActed(slotKey);

    if (action.kind === 'open_share') {
      window.dispatchEvent(new Event('sarvalok_open_share'));
      return;
    }

    if (action.kind === 'open_global_risk') {
      window.location.assign(localizedPath('/global-risk'));
      return;
    }

    if (action.kind === 'open_memory') {
      window.location.assign(localizedPath('/settings/memory'));
      return;
    }

    if (action.kind === 'external') {
      window.open(action.href, '_blank', 'noopener,noreferrer');
      return;
    }

    if (action.kind === 'open_astro') {
      await openAstroModeFromSharedControl();
      return;
    }

    if (currentModeKind === 'astro') {
      await enterHeritageMode();
    }

    if (action.kind === 'enable_listening') {
      enableListeningMode();
      setIsChatOpen(true);
      requestAnimationFrame(() => chatTextareaRef.current?.focus());
      return;
    }

    if (action.kind === 'open_filters') {
      setIsFilterPopupOpen(true);
      return;
    }

    if (action.kind === 'open_pranayama') {
      setIsPranayamaModalOpen(true);
      return;
    }

    if (action.kind === 'open_quiz') {
      await handleOpenQuizRef.current?.();
      return;
    }

    if (action.kind === 'open_journey') {
      SetJourney(true);
      return;
    }

    if (action.kind === 'open_reading_mode') {
      const source = latestReadableAssistant?.msg.readSources?.[0];
      if (source) {
        setReadingModalProps({ token: source.token, label: source.label, ci: source.ci });
        setIsReadingModalOpen(true);
      }
      return;
    }

    if (action.kind === 'enable_citation') {
      turnOffListeningMode();
      handleModeChange('citation');
      setIsChatOpen(true);
      requestAnimationFrame(() => chatTextareaRef.current?.focus());
      return;
    }

    if (action.kind === 'prefill_heritage_question') {
      const prompt = t(action.promptKey, action.defaultPrompt);
      setMessage(prompt);
      setIsChatOpen(true);
      requestAnimationFrame(() => chatTextareaRef.current?.focus());
    }
  }, [
    currentModeKind,
    enableListeningMode,
    enterHeritageMode,
    handleModeChange,
    canStartQuiz,
    isQuizPreparing,
    latestReadableAssistant,
    localizedPath,
    markAnnouncementActed,
    openAstroModeFromSharedControl,
    t,
    turnOffListeningMode,
  ]);

  const renderAnnouncementSlotsAfter = useCallback((messageIndex: number) => {
    const slotsForMessage = announcementSlots.filter((slot) => slot.afterMessageIndex === messageIndex);
    if (!slotsForMessage.length) return null;

    return slotsForMessage.map((slot) => (
      <SystemAnnouncementCard
        key={slot.slotKey}
        announcement={slot.announcement}
        eyebrow={t('chat.system_announcements.eyebrow', 'Sarvalok says')}
        title={t(slot.announcement.titleKey, slot.announcement.defaultTitle)}
        body={t(slot.announcement.bodyKey, slot.announcement.defaultBody)}
        primaryLabel={t(slot.announcement.primaryLabelKey, slot.announcement.defaultPrimaryLabel)}
        secondaryLabel={slot.announcement.secondaryLabelKey ? t(slot.announcement.secondaryLabelKey, slot.announcement.defaultSecondaryLabel || '') : undefined}
        dismissLabel={t('chat.system_announcements.dismiss', 'Dismiss message')}
        onPrimary={() => void handleAnnouncementAction(slot.announcement.primaryAction, slot.slotKey)}
        onSecondary={
          slot.announcement.secondaryAction
            ? () => void handleAnnouncementAction(slot.announcement.secondaryAction!, slot.slotKey)
            : undefined
        }
        onDismiss={() => dismissAnnouncementSlot(slot.slotKey)}
      />
    ));
  }, [announcementSlots, dismissAnnouncementSlot, handleAnnouncementAction, t]);

  const handleToggle = () => {
    setIsSidebarOpen(prev => !prev);
  };

  const toggleMenu = (threadId: string) => {
    setMenuOpen(prev => ({ ...prev, [threadId]: !prev[threadId] }));
  };

  const handleRename = (threadId: string) => {
    setIsRenaming(threadId);
    const thread = threads.find(t => t.id === threadId);
    setNewThreadName(thread?.chat_title || 'Untitled Chat');
    setMenuOpen(prev => ({ ...prev, [threadId]: false }));
  };

  const handleRenameSubmit = async (threadId: string) => {
    try {
      if (!newThreadName.trim()) {
        toast.error(t('chat.thread_name_empty'), { position: 'bottom-right' });
        return;
      }

      await renameThread(threadId, userId, newThreadName);
      const updatedThreads = threads.map(thread =>
        thread.id === threadId
          ? { ...thread, chat_title: newThreadName }
          : thread
      );
      setThreads(updatedThreads);
      if (userId) writeThreadMetaCache(userId, updatedThreads);
      toast.success(t('chat.rename_success'), { position: 'bottom-right' });
    } catch (error) {
      console.error('Error renaming thread:', error);
      toast.error(t('chat.rename_failed'), { position: 'bottom-right' });
    } finally {
      setIsRenaming(null);
      setNewThreadName('');
    }
  };

  const handleDelete = async (threadId: string) => {
    try {
      await deleteThread(threadId, userId);
      const updatedThreads = threads.filter((thread) => thread.id !== threadId);
      setThreads(updatedThreads);
      if (userId) writeThreadMetaCache(userId, updatedThreads);

      if (threadId === ThreadId) {
        if (updatedThreads.length > 0) {
          handleSelectChat(updatedThreads[0].id);
        } else {
          threadMessagesTokenRef.current += 1;
          sendMessageTokenRef.current += 1;
          exploreTopicsTokenRef.current += 1;
          sendMessageAbortControllerRef.current?.abort();
          sendMessageAbortControllerRef.current = null;
          try {
            localStorage.removeItem('thread_id');
          } catch {}
          clearThreadIdFromUrl();
          setIsPersonalHoroscopeChat(false);
          setIsThreadMessagesLoading(false);
          setLoadingThreadId(null);
          setLoading(false);
          setIsStreaming(false);
          setThreadId(undefined);
          activeThreadIdRef.current = undefined;
          setChatHistory([]);
          setIsChatOpen(false);
        }
      }

      toast.success(t('chat.delete_success'), { position: 'bottom-right' });
    } catch (error) {
      console.error('Error deleting thread:', error);
      toast.error(t('chat.delete_failed'), { position: 'bottom-right' });
    } finally {
      setMenuOpen(prev => ({ ...prev, [threadId]: false }));
    }
  };

  const currentHour = new Date().getHours();
  const greeting = currentHour < 12 ? t('chat.greeting_morning') : currentHour < 18 ? t('chat.greeting_afternoon') : t('chat.greeting_evening');

  useEffect(() => {
    const conn = (navigator as any)?.connection;
    const saveData = !!conn?.saveData;
    const effectiveType = String(conn?.effectiveType || '');
    const isSlow = effectiveType.includes('2g') || effectiveType === 'slow-2g';
    if (saveData || isSlow) return;

    const load = () => {
      void loadQuizModal();
    };

    if (typeof (window as any).requestIdleCallback === 'function') {
      const id = (window as any).requestIdleCallback(load, { timeout: 3000 });
      return () => (window as any).cancelIdleCallback?.(id);
    }

    const id = window.setTimeout(load, 1500);
    return () => window.clearTimeout(id);
  }, []);

  useEffect(() => {
    const conn = (navigator as any)?.connection;
    const saveData = !!conn?.saveData;
    const effectiveType = String(conn?.effectiveType || '');
    const isSlow = effectiveType.includes('2g') || effectiveType === 'slow-2g';
    if (saveData || isSlow) return;

    const load = () => {
      void loadPranayamaModal();
      void loadQuestlogModal();
    };

    if (typeof (window as any).requestIdleCallback === 'function') {
      const id = (window as any).requestIdleCallback(load, { timeout: 4000 });
      return () => (window as any).cancelIdleCallback?.(id);
    }

    const id = window.setTimeout(load, 2000);
    return () => window.clearTimeout(id);
  }, []);

  // Add handler for quiz modal close to update cooldown state
  const handleQuizModalClose = (cooldownUpdated = false) => {
    setShowQuiz(false);
    setIsQuizModalOpen(false);

    // This is the crucial part that re-checks the cooldown status
    if (cooldownUpdated) {
      const end = localStorage.getItem('quizCooldown');
      if (end) {
        setQuizCooldown(parseInt(end, 10));
      }
    }
  };

	  const handleOpenQuiz = useCallback(async () => {
    if (!canStartQuiz || isQuizPreparing) return;
    setIsQuizPreparing(true);
    try {
      const user = auth.currentUser;
      if (!user) return;

      let idToken = firebaseToken;
      let appCheckTok = appCheckToken;

      if (!idToken) {
        idToken = await user.getIdToken();
      }
      if (!appCheckTok) {
        const checkToken = await getToken(appCheck, false);
        appCheckTok = checkToken.token;
      }

      if (idToken !== firebaseToken) setFirebaseToken(idToken);
      if (appCheckTok !== appCheckToken) setAppCheckToken(appCheckTok);

      if (!localUserId) {
        const response = await axios.post(
          `${import.meta.env.VITE_APP_SERVER}/api/user/sync`,
          {},
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
              'X-Firebase-AppCheck': appCheckTok,
            },
          }
        );
        setLocalUserId(response.data.local_user_id);
      }

      setShowQuiz(true);
      setIsQuizModalOpen(true);
    } catch (error) {
      console.error("Failed to sync user with quiz database", error);
      toast.error(t('chat.quiz_server_unreachable'));
    } finally {
      setIsQuizPreparing(false);
    }
	  }, [appCheckToken, canStartQuiz, firebaseToken, isQuizPreparing, localUserId, t]);
  handleOpenQuizRef.current = handleOpenQuiz;

	  const dayQualityTodayIso = getClientLocalDateIso();
	  const dayQualityTomorrowIso = getClientLocalDateIso(addDaysClamped(new Date(), 1));
	  const selectedAstroTimelineDate = astroTimelineDate || dayQualityTodayIso;
	  const astroTimelineIsToday = selectedAstroTimelineDate === dayQualityTodayIso;
    const dayQualityUpdatingText = t('chat.day_quality.updating', 'Updating day quality...');
    const activeThreadMeta = threads.find((thread: any) => String(thread?.id) === String(ThreadId)) || null;
    const dinacharyaGeneratedDates = useMemo(() => {
      const set = new Set<string>();
      for (const msg of chatHistory) {
        if (msg?.isDinacharya && typeof msg?.dinacharyaGeneratedForDate === 'string' && msg.dinacharyaGeneratedForDate) {
          set.add(msg.dinacharyaGeneratedForDate);
        }
      }
      const legacyGeneratedDate = activeThreadMeta?.dinacharya_generated_for_date;
      if (typeof legacyGeneratedDate === 'string' && legacyGeneratedDate) {
        set.add(legacyGeneratedDate);
      }
      return set;
    }, [activeThreadMeta?.dinacharya_generated_for_date, chatHistory]);
    const handleDinacharyaDateSelect = useCallback((isoDate: string) => {
      if (!isoDate || isoDate === selectedAstroTimelineDate) return;
      setAstroTimelineDate(isoDate);
      void refreshGocharaAndHydrateTimeline(astroNavTokenRef.current, {
        targetDate: isoDate,
        modeOverride: astroTimelineMode,
        suppressSuccessToast: true,
      });
    }, [astroTimelineMode, refreshGocharaAndHydrateTimeline, selectedAstroTimelineDate]);
    const dinacharyaPromptDateLabel = selectedAstroTimelineDate === dayQualityTodayIso
      ? t('chat.dinacharya.prompt_today', 'today')
      : selectedAstroTimelineDate === dayQualityTomorrowIso
        ? t('chat.dinacharya.prompt_tomorrow', 'tomorrow')
        : formatTimelineDateForPrompt(selectedAstroTimelineDate);
    const showDinacharyaCard = Boolean(
      isPersonalHoroscopeChat &&
      userReportStatus?.has_horoscope &&
      ThreadId &&
      !isListeningMode &&
      !showPersonalMode &&
      !showCompatibilityMode
    );
	  const dayQualityRangeAnchor = new Date();
	  const dayQualityMinDate = getClientLocalDateIso(addYearsClamped(dayQualityRangeAnchor, -DAY_QUALITY_PICKER_RANGE_YEARS));
	  const dayQualityMaxDate = getClientLocalDateIso(addYearsClamped(dayQualityRangeAnchor, DAY_QUALITY_PICKER_RANGE_YEARS));
	
	  if (journey) {
    return (
      <>
        <JourneyPage onEnd={() => { SetJourney(false); }} />
      </>
    );
  }

  return (
    <>
      <SEO
        title={t('seo:chat.title', { defaultValue: 'Chat | Sarvalok AI Assistant' })}
        description={t('seo:chat.description', { defaultValue: 'Private chat interface for exploring authentic Dharma knowledge with source-grounded citations. Multilingual support and secure by design.' })}
        url="/chat"
        noIndex={true}
      />
      <ToastContainer
        position="top-right"
        style={{
          zIndex: 1100,
        }}
      />
      {!isChatOpen ? (
        <div
          aria-hidden="true"
          className="fixed inset-0 z-0 pointer-events-none dark:hidden"
          style={{
            backgroundImage: `url(${welcomeBg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        />
      ) : null}
      <div
        className={`relative z-10 flex min-w-0 overflow-x-hidden ${styles.pageBackground} ${isChatOpen ? 'lg:px-10' : ''}`}
        style={{
          minHeight: '100vh',
        }}
      >
      {bookmarkPreview && (
        <div className="fixed inset-0 z-[1000000] flex items-center justify-center bg-black/40 p-4">
          <div className="w-full max-w-2xl rounded-xl bg-white p-4 shadow-2xl">
            <div className="flex items-center justify-between">
              <div className="text-sm font-semibold text-gray-900">Saved answer</div>
              <button
                onClick={() => setBookmarkPreview(null)}
                className="p-2 rounded-full hover:bg-gray-100"
                aria-label="Close"
              >
                <X className="w-5 h-5 text-gray-600" />
              </button>
            </div>
            {!!bookmarkPreview.question && (
              <div className="mt-3">
                <div className="text-xs font-semibold text-gray-500">Question</div>
                <div className="mt-1 whitespace-pre-wrap text-sm text-gray-900">{bookmarkPreview.question}</div>
              </div>
            )}
            {!!(bookmarkPreview.answerText || bookmarkPreview.answerSnippet) && (
              <div className="mt-3">
                <div className="text-xs font-semibold text-gray-500">Answer</div>
                <div className="mt-1 max-h-[60vh] overflow-y-auto whitespace-pre-wrap text-sm text-gray-800">
                  {bookmarkPreview.answerText || bookmarkPreview.answerSnippet}
                </div>
	                              </div>
	                            )}
	                          </div>
	                        </div>
	                      )}
      <NotificationBanner />
      {/* Sidebar */}
      <div
        ref={sidebarRef} // ✅ Attach the ref to the sidebar main div
        style={{ top: headerOffsetPx, height: `calc(100dvh - ${headerOffsetPx}px)`, zIndex: 999999 }}
        className={`fixed left-0 z-30 w-64 bg-white text-gray-500 shadow-2xl transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} flex flex-col`}
      >
        <div className="flex items-center justify-between px-4 py-2">
        <div className="flex items-center gap-3">
          <div title={t('chat.new_chat')} className="flex items-center gap-2">
              <Plus style={{ cursor: "pointer" }} onClick={handleNewChat} className="w-6 h-6 text-gray-500" />
            </div>
          </div>
          <button title='Close Sidebar' onClick={handleToggle} className="p-2 focus:outline-none">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="icon-xl-heavy "><path fillRule="evenodd" clipRule="evenodd" d="M8.85719 3H15.1428C16.2266 2.99999 17.1007 2.99999 17.8086 3.05782C18.5375 3.11737 19.1777 3.24318 19.77 3.54497C20.7108 4.02433 21.4757 4.78924 21.955 5.73005C22.2568 6.32234 22.3826 6.96253 22.4422 7.69138C22.5 8.39925 22.5 9.27339 22.5 10.3572V13.6428C22.5 14.7266 22.5 15.6008 22.4422 16.3086C22.3826 17.0375 22.2568 17.6777 21.955 18.27C21.4757 19.2108 20.7108 19.9757 19.77 20.455C19.1777 20.7568 18.5375 20.8826 17.8086 20.9422C17.1008 21 16.2266 21 15.1428 21H8.85717C7.77339 21 6.89925 21 6.19138 20.9422C5.46253 20.8826 4.82234 20.7568 4.23005 20.455C3.28924 19.9757 2.52433 19.2108 2.04497 18.27C1.74318 17.6777 1.61737 17.0375 1.55782 16.3086C1.49998 15.6007 1.49999 14.7266 1.5 13.6428V10.3572C1.49999 9.27341 1.49998 8.39926 1.55782 7.69138C1.61737 6.96253 1.74318 6.32234 2.04497 5.73005C2.52433 4.78924 3.28924 4.02433 4.23005 3.54497C4.82234 3.24318 5.46253 3.11737 6.19138 3.05782C6.89926 2.99998 7.77341 2.99999 8.85719 3ZM6.35424 5.05118C5.74907 5.10062 5.40138 5.19279 5.13803 5.32698C4.57354 5.6146 4.1146 6.07354 3.82698 6.63803C3.69279 6.90138 3.60062 7.24907 3.55118 7.85424C3.50078 8.47108 3.5 9.26339 3.5 10.4V13.6C3.5 14.7366 3.50078 15.5289 3.55118 16.1458C3.60062 16.7509 3.69279 17.0986 3.82698 17.362C4.1146 17.9265 4.57354 18.3854 5.13803 18.673C5.40138 18.8072 5.74907 18.8994 6.35424 18.9488C6.97108 18.9992 7.76339 19 8.9 19H9.5V5H8.9C7.76339 5 6.97108 5.00078 6.35424 5.05118ZM11.5 5V19H15.1C16.2366 19 17.0289 18.9992 17.6458 18.9488C18.2509 18.8994 18.5986 18.8072 18.862 18.673C19.4265 18.3854 19.8854 17.9265 20.173 17.362C20.3072 17.0986 20.3994 16.7509 20.4488 16.1458C20.4992 15.5289 20.5 14.7366 20.5 13.6V10.4C20.5 9.26339 20.4992 8.47108 20.4488 7.85424C20.3994 7.24907 20.3072 6.90138 20.173 6.63803C19.8854 6.07354 19.4265 5.6146 18.862 5.32698C18.5986 5.19279 18.2509 5.10062 17.6458 5.05118C17.0289 5.00078 16.2366 5 15.1 5H11.5ZM5 8.5C5 7.94772 5.44772 7.5 6 7.5H7C7.55229 7.5 8 7.94772 8 8.5C8 9.05229 7.55229 9.5 7 9.5H6C5.44772 9.5 5 9.05229 5 8.5ZM5 12C5 11.4477 5.44772 11 6 11H7C7.55229 11 8 11.4477 8 12C8 12.5523 7.55229 13 7 13H6C5.44772 13 5 12.5523 5 12Z" fill="currentColor"></path></svg>
          </button>
        </div>
        <div className="px-3 pb-2 flex gap-2">
          <button
            onClick={() => setSidebarTab('history')}
            className={`sl-chat-sidebar-tab flex-1 px-3 py-2 rounded-lg text-xs font-semibold transition-colors ${sidebarTab === 'history' ? 'sl-chat-sidebar-tab-active bg-gray-200 text-black' : 'sl-chat-sidebar-tab-inactive bg-gray-50 text-gray-600 hover:bg-gray-100'}`}
          >
            {t('chat.history')}
          </button>
          <button
            onClick={() => {
              setSidebarTab('bookmarks');
              void ensureBookmarksLoaded();
            }}
            className={`sl-chat-sidebar-tab flex-1 px-3 py-2 rounded-lg text-xs font-semibold transition-colors flex items-center justify-center gap-2 ${sidebarTab === 'bookmarks' ? 'sl-chat-sidebar-tab-active bg-gray-200 text-black' : 'sl-chat-sidebar-tab-inactive bg-gray-50 text-gray-600 hover:bg-gray-100'}`}
          >
            <Bookmark className="w-4 h-4" />
            <span>Bookmarks</span>
          </button>
        </div>
        <div tabIndex={0} className={`flex-1 min-h-0 overflow-y-auto pb-24 focus:outline-none ${styles.threadList}`}>
          {sidebarTab === 'history' ? (
            <>
              {threads?.length > 0 ? (
                threads?.map((thread: any) => (
                  <div key={thread.id} className="relative">
                    {isRenaming === thread.id ? (
                      <div className="px-3 py-2 flex items-center gap-2">
                        <input
                          type="text"
                          value={newThreadName}
                          onChange={(e) => setNewThreadName(e.target.value)}
                          className="flex-1 px-2 py-1 border border-gray-300 rounded text-black"
                          autoFocus
                        />
                        <button
                          onClick={() => handleRenameSubmit(thread.id)}
                          className="p-1 bg-gray-600 text-white rounded hover:bg-gray-700"
                        >
                          <Check className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => setIsRenaming(null)}
                          className="p-1 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                        >
                          <X className="w-4 h-4" />
                        </button>
                      </div>
                    ) : (
                      <>
                        <button
                          style={{ fontSize: "14px" }}
                          onClick={() => handleSelectChat(thread.id)}
                          className={`sl-chat-thread-item w-full text-left px-3 py-2 transition-colors transform hover:scale-96 flex items-center justify-between ${
                            ThreadId === thread.id ? 'sl-chat-thread-item-active' : ''
                          }`}
                        >
                          <span className="sl-chat-thread-title text-black truncate block">{thread?.chat_title || thread?.messages?.[0]?.title || 'Untitled Chat'}</span>
                          <div onClick={(e) => { e.stopPropagation(); toggleMenu(thread.id); }} className="p-1 hover:bg-gray-200 rounded-full cursor-pointer">
                            <MoreHorizontal className="w-5 h-5 text-gray-500" />
                          </div>
                        </button>
                        {menuOpen[thread.id] && (
                          <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                            <button onClick={() => handleRename(thread.id)} className="w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 flex items-center gap-2 rounded-t-lg">
                              <Edit2 className="w-5 h-5" />
                              <span>Rename</span>
                            </button>
                            <button onClick={() => handleDelete(thread.id)} className="w-full text-left px-4 py-2 text-red-600 hover:bg-red-100 flex items-center gap-2 rounded-b-lg">
                              <Trash2 className="w-5 h-5" />
                              <span>Delete</span>
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ))
              ) : (
                pageloading ? (
                  <div className="flex items-center gap-3 text-black text-sm p-3">
                    <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-black"></div>
                    <span>{t('chat.quiz.loading')}</span>
                  </div>
                ) : (
                  <p className="text-black text-sm p-3">{t('chat.no_chats')}</p>
                )
              )}
            </>
          ) : (
            <>
              {bookmarksLoading ? (
                <div className="flex items-center gap-3 text-black text-sm p-3">
                  <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-black"></div>
                  <span>Loading bookmarks</span>
                </div>
              ) : bookmarks?.length > 0 ? (
                bookmarks.map((bm) => (
                  <div key={bm.id} className="relative">
                    <button
                      onClick={() => void openBookmark(bm)}
                      className="w-full text-left px-3 py-2 transition-colors transform hover:scale-96 flex items-start justify-between gap-2"
                    >
                      <div className="min-w-0">
                        <div className="text-black truncate text-sm">{bm.question || 'Saved answer'}</div>
                        {!!bm.answerSnippet && <div className="text-xs text-gray-500 truncate">{bm.answerSnippet}</div>}
                      </div>
                      <div
                        onClick={async (e) => {
                          e.stopPropagation();
                          const uid = auth.currentUser?.uid || userId;
                          if (!uid) return;
                          const id = String(bm.id);
                          if (!id) return;
                          if (deletingBookmarkId === id) return;
                          setDeletingBookmarkId(id);
                          setBookmarks(prev => prev.filter(b => String(b.id) !== id));
                          try {
                            await deleteBookmark(id, uid);
                          } catch (error) {
                            console.error('Error deleting bookmark:', error);
                            setBookmarks(prev => (prev.some(b => String(b.id) === id) ? prev : [bm, ...prev]));
                            toast.error('Failed to remove bookmark', { position: 'bottom-right' });
                          } finally {
                            setDeletingBookmarkId(prev => (prev === id ? null : prev));
                          }
                        }}
                        className="p-1 hover:bg-gray-200 rounded-full cursor-pointer"
                        title="Remove bookmark"
                      >
                        <Trash2 className="w-4 h-4 text-gray-500" />
                      </div>
                    </button>
                  </div>
                ))
              ) : (
                <p className="text-black text-sm p-3">No bookmarks yet</p>
              )}
            </>
          )}
        </div>
        <div className="mt-auto shrink-0 bg-white border-t border-gray-200 p-2 flex items-center justify-center">
          <LocalizedLink to="/pricing" className="flex items-center gap-2 rounded-lg p-2 w-full max-w-[48rem]">
            <Plus className="w-5 h-5 text-gray-500" />
            <div>
              <p className="text-sm font-medium text-gray-800">{t('chat.upgrade_plan')}</p>
              <p className="text-xs text-gray-500">{t('chat.more_benefits')}</p>
            </div>
          </LocalizedLink>
        </div>
      </div>

      {isSidebarOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden" onClick={() => setIsSidebarOpen(false)} />
      )}

      <div className={`flex-1 flex min-w-0 flex-col overflow-x-hidden transition-all duration-300 ease-in-out ${isSidebarOpen ? 'md:ml-64' : 'md:mx-32'}`}>
        <button onClick={handleToggle} style={{borderRadius:"50%",left:"-8px"}} className="fixed bg-gray-100 left-0 p-2 focus:outline-none z-50 md:z-40">
          <ArrowRightCircle className="w-6 h-6 text-gray-500" />
        </button>

        {isChatOpen && !showPersonalMode && !showCompatibilityMode && (
          <div className="sl-mode-tabs pointer-events-none fixed left-1/2 top-[calc(var(--app-header-h,72px)-0.1875rem)] z-40 -translate-x-1/2">
            <div className="pointer-events-auto inline-flex rounded-full border border-slate-200 bg-white/95 p-1 shadow-lg backdrop-blur-md dark:border-slate-700 dark:bg-slate-900/95">
              <button
                type="button"
                disabled={modeSwitchDisabled}
                aria-pressed={currentModeKind === 'heritage'}
                aria-label={t('chat.mode_tabs.heritage_aria', 'Switch to Heritage chat')}
                title={modeSwitchDisabled ? t('chat.mode_tabs.streaming_blocked', 'Finish the current answer before switching chats.') : (isEnglishLocale ? t('chat.mode_tabs.heritage_hint', 'For non-astrology questions') : undefined)}
                onClick={() => void handleModeTabClick('heritage')}
                className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900 ${
                  currentModeKind === 'heritage'
                    ? 'bg-slate-950 text-white font-semibold shadow-sm dark:bg-white dark:text-slate-950'
                    : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800'
                } ${modeSwitchDisabled ? 'cursor-not-allowed opacity-60' : ''}`}
              >
                {t('chat.mode_tabs.heritage', 'Heritage')}
              </button>
              <button
                type="button"
                disabled={modeSwitchDisabled}
                aria-pressed={currentModeKind === 'astro'}
                aria-label={t('chat.mode_tabs.astro_aria', 'Switch to Astro chat')}
                title={modeSwitchDisabled ? t('chat.mode_tabs.streaming_blocked', 'Finish the current answer before switching chats.') : (isEnglishLocale ? t('chat.mode_tabs.astro_hint', 'For birth chart, timing, muhurta, career, and personal astrology questions') : undefined)}
                onClick={() => void handleModeTabClick('astro')}
                className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900 ${
                  currentModeKind === 'astro'
                    ? 'bg-slate-950 text-white font-semibold shadow-sm dark:bg-white dark:text-slate-950'
                    : 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800'
                } ${modeSwitchDisabled ? 'cursor-not-allowed opacity-60' : ''}`}
              >
                {t('chat.mode_tabs.astro', 'Astro')}
              </button>
            </div>
          </div>
        )}

        {showPersonalMode && (
            <div className="flex-1 overflow-y-auto p-4 pt-20 flex justify-center items-start min-h-screen">
                 <div className="w-full max-w-3xl bg-white/95 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-white/20 mt-10 mb-10">
                    <div className="mb-6 flex items-start justify-between gap-4 border-b pb-4">
                        <div className="min-w-0 flex-1">
                            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-3">
                              <h2 className="flex items-center gap-2 text-2xl font-bold text-gray-800">
                                  <User className="w-6 h-6 text-indigo-600" />
                                  {(isIndianLocaleUser && isEnglishLocale) ? 'Jyotisha' : t('chat.astro.mode_title')}
                              </h2>
                              <AdvancedAuthenticTagline className="sm:translate-y-0.5" />
                            </div>
                            <p className="text-gray-500 text-sm mt-1">{t('chat.astro.mode_subtitle')}</p>
                        </div>
                        <button
                          onClick={() => {
                            if (personalModeSource === 'compatibility') {
                              returnToMainChat({ clearCompatibility: false });
                              setShowCompatibilityMode(true);
                            } else {
                              returnToMainChat();
                            }
                          }}
                          className="p-2 hover:bg-gray-100 rounded-full text-gray-500 hover:text-gray-800 transition-colors"
                        >
                            <X className="w-6 h-6" />
                        </button>
                    </div>
              <button
                type="button"
                onClick={() => {
                  setShowPersonalMode(false);
                  setCompatibilityResult(null);
                  setIsCompatibilityLoading(false);
                  setShowCompatibilityMode(true);
                }}
                className="mb-4 flex w-full items-center justify-between gap-2 rounded-xl border border-rose-100 bg-rose-50/80 px-3 py-2 text-left text-xs font-medium leading-snug text-rose-800 shadow-sm transition-colors hover:bg-rose-100 focus:outline-none focus:ring-2 focus:ring-rose-200 sm:text-sm"
              >
                <span className="flex min-w-0 items-center gap-2">
                  <Heart className="h-4 w-4 shrink-0" />
                  <span className="min-w-0">
                    {t('chat.astro.switch_to_compatibility', 'For matchmaking and relationship questions, switch to Astro Compatibility.')}
                  </span>
                </span>
                <ArrowRight className="h-4 w-4 shrink-0" />
              </button>
              <BirthChartForm onChartGenerated={handleChartResult} />
                 </div>
            </div>
        )}

        {showCompatibilityMode && (
            <div className="flex-1 overflow-y-auto p-4 pt-20 flex justify-center items-start min-h-screen">
                 <div className="w-full max-w-4xl bg-white/95 backdrop-blur-sm p-6 rounded-2xl shadow-xl border border-white/20 mt-10 mb-10">
                    <div className="flex items-center justify-between mb-6 border-b pb-4">
                        <div>
                            <h2 className="text-2xl font-bold text-gray-800 flex items-center gap-2">
                                <Heart className="w-6 h-6 text-pink-600" />
                                {(isIndianLocaleUser && isEnglishLocale) ? 'Kundli Match' : t('chat.astro.compatibility_title')}
                            </h2>
                            <p className="text-gray-500 text-sm mt-1">{t('chat.astro.compatibility_subtitle')}</p>
                        </div>
                        <button
                          onClick={() => {
                            returnToMainChat();
                          }}
                          className="p-2 hover:bg-gray-100 rounded-full text-gray-500 hover:text-gray-800 transition-colors"
                        >
                            <X className="w-6 h-6" />
                        </button>
                    </div>
                    {compatibilityResult ? (
                        <CompatibilityDisplay
                          data={compatibilityResult}
                          onReset={() => setCompatibilityResult(null)}
                          onDiscussInAstro={async () => {
                            const meta = compatibilityResult?.subject || compatibilityResult?.metadata?.subject || {};
                            const compatIds = Array.isArray(meta?.compat_subject_ids) ? meta.compat_subject_ids : [];
                            const addressed = String(meta?.addressed_subject_id || compatIds?.[0] || '').trim();
                            if (!compatIds.length) {
                              toast.error('Could not start a compatibility chat (missing saved subjects).', { position: 'bottom-right' });
                              return;
                            }
                            pendingThreadSubjectRef.current = {
                              active_subject_id: addressed || compatIds[0] || 'self',
                              active_subject_mode: 'compat_pair',
                              addressed_subject_id: addressed || compatIds[0] || null,
                              compat_subject_ids: compatIds,
                            };
                            await enterAstroMode({ forceNewThread: true });
                          }}
                        />
                    ) : isCompatibilityLoading ? (
                        <div className="flex items-center justify-center py-12">
                          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-gray-500" />
                        </div>
              ) : (
                <>
                <button
                  type="button"
                  onClick={() => {
                    setPersonalModeSource('compatibility');
                    setShowCompatibilityMode(false);
                    setShowPersonalMode(true);
                  }}
                  className="mb-4 flex w-full items-center justify-between gap-2 rounded-xl border border-indigo-100 bg-indigo-50/80 px-3 py-2 text-left text-xs font-medium leading-snug text-indigo-800 shadow-sm transition-colors hover:bg-indigo-100 focus:outline-none focus:ring-2 focus:ring-indigo-200 sm:text-sm"
                >
                  <span className="flex min-w-0 items-center gap-2">
                    <User className="h-4 w-4 shrink-0" />
                    <span className="min-w-0">
                      {t('chat.astro.switch_to_astro', 'For birth chart, muhurta, career, and personal timing questions, switch to Astro Mode.')}
                    </span>
                  </span>
                  <ArrowRight className="h-4 w-4 shrink-0" />
                </button>
                <MarriageCompatibilityForm onCompatibilityGenerated={handleCompatibilityResult} />
                </>
              )}
                 </div>
            </div>
        )}

        {!isChatOpen && !showPersonalMode && !showCompatibilityMode && (
          <div className="flex-1 flex flex-col justify-center items-center pt-5 pb-28" style={{ marginTop: '-45px' }}>
            {showLanguageDiscoveryBanner && (
              <LanguageDiscoveryBanner
                onSelectLanguage={handleLanguageDiscoverySelect}
                onDismiss={handleLanguageDiscoveryDismiss}
              />
            )}

            {/* Tip Notification - Positioned Below Navigation */}
            {showTipNotification && !showLanguageDiscoveryBanner && (
              <div className="mb-8 mx-2 hidden w-full justify-center md:flex">
                <div className="inline-flex max-w-[42rem] items-center gap-2 rounded-full border border-blue-200 bg-blue-50/95 px-4 py-2 shadow-sm backdrop-blur-sm">
                  <div className="flex-shrink-0">
                    <span className="text-base">💡</span>
                  </div>
                  <div className="min-w-0 flex-1 text-center text-sm text-blue-800 whitespace-nowrap overflow-hidden text-ellipsis">
                    <strong>{t('chat.tip_title')}</strong> {t('chat.tip_text')}
                  </div>
                  <button
                    onClick={handleTipNotificationClose}
                    className="flex-shrink-0 text-blue-600 hover:text-blue-800 transition-colors p-1 rounded-full hover:bg-blue-100"
                    aria-label="Close notification"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              </div>
            )}
            
            {/* Header Section - Fixed Width */}
            <div className="max-w-[48rem] mx-auto w-full">
              
              <h1
                className="text-[25px] leading-[48px] font-semibold text-center"
                style={{
                  background: 'linear-gradient(to right, #ff0000, #ffa500)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {greeting}, {userName}!
              </h1>
              <h1 className="text-[30px] leading-[48px] font-semibold text-center mb-12 text-gray-800">
                {t('chat.what_can_i_help')}
              </h1>
            </div>

            {/* Input Box Section - Independent Fixed Width */}
            <div className="max-w-[48rem] mx-auto w-full relative mb-8 px-4">
              <div className="sl-chat-welcome-input flex items-center gap-2.5 rounded-xl bg-white shadow-lg transition-shadow hover:shadow-xl">
                <div className="flex-grow">
                  <BlinkingPlaceholderTextarea
                    ref={welcomeTextareaRef}
                    placeholder={isListeningMode ? t('chat.placeholder_listening') : normalChatPlaceholder}
                    value={message}
                    onKeyPress={handleKeyPress}
                    onChange={handleInputChange}
                    maxLength={CHAT_INPUT_MAX_CHARS}
                    readOnly={isRefreshingTransits}
                    rows={2}
                    className={`w-full px-4 py-[18px] rounded-xl focus:outline-none text-[16px] resize-none min-h-[60px] ${styles['auto-expand-textarea']}`}
                  />
                </div>
                <div className="flex items-center pr-2 gap-1">
                  {/* Desktop Actions - Hidden on Mobile */}
                   <div className={`desktop-actions ${styles['desktop-actions']}`}>
                    <button title={t('chat.filters')} onClick={() => setIsFilterPopupOpen(true)} className="p-2 text-gray-600 hover:text-gray-800" >
                      <Filter className="w-5 h-5" />
                    </button>
                    <button title={t('chat.authority_settings')} onClick={() => setIsAuthorityPopupOpen(true)} className="p-2 text-gray-600 hover:text-gray-800">
                      <Settings className="w-5 h-5" />
                    </button>
                    <Tippy content={
                         <div className="text-sm max-w-xs space-y-1">
                           {t('chat.listening_mode_tooltip').split('\n').map((line, idx) => (
                             <div key={idx} className={idx === 0 ? 'mb-2' : ''}>{line}</div>
                           ))}
                         </div>
                       } placement="right" delay={[500, 100]} theme="listening-mode" popperOptions={{
                         modifiers: [
                           {
                             name: 'preventOverflow',
                             options: {
                               boundary: 'viewport',
                               padding: 8,
                             },
                           },
                         ],
                       }}>
                      <button
                        onClick={() => handleListeningModeChange()}
                        className={`sl-chat-listening-toggle p-2 rounded transition-all duration-200 ${
                          isListeningMode
                            ? 'sl-chat-toggle-active text-blue-500 bg-blue-50 shadow-sm'
                            : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'
                        }`}
                        title={t('chat.listening_mode')}
                      >
                        <Headphones className={`w-5 h-5 ${
                          isListeningMode ? 'drop-shadow-sm' : ''
                        }`} />
                      </button>
                    </Tippy>
                    <Tippy content={
                         <div className="text-sm max-w-xs">
                           {t('chat.fast_mode_tooltip')}
                         </div>
                       } placement="bottom" delay={[500, 100]} theme="fast-mode" popperOptions={{
                          modifiers: [
                           {
                             name: 'preventOverflow',
                             options: {
                               boundary: 'viewport',
                               padding: 8,
                             },
                           },
                         ],
                       }}>
                        <button
                          onClick={() => {
                            setIsFastSearch(!isFastSearch);
                          }}
                          className={`sl-chat-fast-toggle p-2 rounded transition-all duration-200 ${
                            isFastSearch
                              ? 'sl-chat-toggle-active text-yellow-500 bg-yellow-50 shadow-sm'
                              : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'
                           }`}
                           title={t('chat.fast_mode')}
                         >
                           <Zap className={`w-5 h-5 ${
                             isFastSearch ? 'drop-shadow-sm' : ''
                           }`} />
                         </button>
                       </Tippy>
                  </div>

                  {/* Hand-drawn arrow pointing to listening mode */}
                  <HandDrawnArrow 
                    className="sl-chat-try-arrow hidden md:block"
                    style={{
                      /* Previous: top: '-80px' (before slim header) */
                      top: '-64px',
                      right: '60px',
                      transform: 'rotate(-15deg)'
                    }}
                  />

                  {/* Mobile Actions Menu - Visible only on Mobile */}
                  <MobileActionsMenu
                    isFilterPopupOpen={isFilterPopupOpen}
                    setIsFilterPopupOpen={setIsFilterPopupOpen}
                    isAuthorityPopupOpen={isAuthorityPopupOpen}
                    setIsAuthorityPopupOpen={setIsAuthorityPopupOpen}
                    isListeningMode={isListeningMode}
                    handleListeningModeChange={handleListeningModeChange}
                    isFastSearch={isFastSearch}
                    setIsFastSearch={setIsFastSearch}
                    isPersonalHoroscopeChat={isPersonalHoroscopeChat}
                    citationMode={effectiveUiMode}
                    onCitationModeChange={handleModeChange}
                    astroPromptMode={astroPromptMode}
                    onAstroPromptModeChange={handleAstroPromptModeChange}
                  />

                  {/* Hidden on mobile — citation toggle lives in MobileActionsMenu on small screens */}
                  <div className="hidden md:flex">
                  {isPersonalHoroscopeChat ? (
                    <Tippy content={
                      <div className="text-sm max-w-xs space-y-1">
                        <div><span className="font-semibold">Guidance:</span> Direct, actionable predictions for your life — no technical jargon</div>
                        <div><span className="font-semibold">Detailed:</span> In-depth analysis of houses, karakas, dashas &amp; more.</div>
                      </div>
                    } placement="bottom" delay={[200, 0]}>
                      <span>
                        <VerticalCitationToggle
                          variant="astro"
                          mode={astroPromptMode}
                          onModeChange={(m) => handleAstroPromptModeChange(m as 'astro_standard_mode' | 'astro_advanced_mode')}
                          disabled={false}
                          className="mx-1"
                        />
                      </span>
                    </Tippy>
                  ) : (
                    <VerticalCitationToggle
                      mode={effectiveUiMode}
                      onModeChange={handleModeChange}
                      disabled={false}
                      className="mx-1"
                    />
                  )}
                  </div>

                  <SpeechToText onTranscriptChange={handleTranscriptChange} />
                  <div className="ml-1">
                    <button
                      onClick={() => handleSendMessage()}
                      className={`flex items-center justify-center p-2 rounded-md transition-colors bg-gray-800 hover:bg-gray-900 text-white disabled:opacity-50 ${styles['send-button']}`}
                      disabled={loading || isStreaming || isRefreshingTransits || !message.trim() || usageLimitReached}
                      title="Send"
                    >
                      <ArrowUp className="w-5 h-5 stroke-[2.5]" />
                    </button>
                  </div>
                </div>
              </div>
              {showWelcomeAstroRibbon && (
                <div className="mt-3 pointer-events-auto">
                  <div className="flex items-start gap-2 rounded-xl border border-indigo-200 bg-gradient-to-r from-indigo-50 to-purple-50 px-3 py-2.5 text-xs text-indigo-900 shadow-sm dark:border-indigo-800/70 dark:from-indigo-900/20 dark:to-purple-900/20 dark:text-indigo-100 sm:items-center sm:justify-between">
                    <div
                      role="button"
                      tabIndex={0}
                      onClick={() => { void handleWelcomeAstroRibbonActivate(); }}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                          event.preventDefault();
                          void handleWelcomeAstroRibbonActivate();
                        }
                      }}
                      aria-label={t('chat.astro_nudge.open_astro_mode_aria', { defaultValue: 'Open Astro Mode' })}
                      className="group relative flex min-w-0 flex-1 cursor-pointer items-start gap-2 rounded-lg p-1 pr-10 -m-1 text-left transition-colors duration-300 ease-out hover:bg-indigo-100/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400/70 dark:hover:bg-indigo-900/30 sm:items-center"
                    >
                      <div className="flex min-w-0 items-start gap-2 pl-1 transition-transform duration-300 ease-out group-hover:-translate-x-3 motion-reduce:transition-none motion-reduce:group-hover:translate-x-0 sm:items-center">
                        <Lightbulb className="mt-0.5 h-4 w-4 shrink-0 text-indigo-600 dark:text-indigo-300 sm:mt-0" />
                        <div className="min-w-0">
                          <div className="leading-relaxed">{t('chat.astro_nudge.welcome_ribbon_text')}</div>
                          {showIndianEnglishHindiAstroStrip && (
                            <div className="mt-1 leading-relaxed">
                              व्यक्तिगत प्रश्न?{' '}
                              <Link
                                to="/hi/chat?mode=astro"
                                className="font-semibold underline underline-offset-2 hover:opacity-90"
                                onClick={(event) => {
                                  event.stopPropagation();
                                }}
                              >
                                ज्योतिष मोड (हिंदी)
                              </Link>{' '}
                              खोलें।
                            </div>
                          )}
                        </div>
                      </div>
                      <ArrowRight
                        strokeWidth={1.75}
                        className="pointer-events-none absolute right-3 top-1/2 h-[18px] w-[18px] -translate-x-2 -translate-y-1/2 opacity-0 transition-all duration-300 ease-out group-hover:translate-x-0 group-hover:-translate-y-1/2 group-hover:opacity-100 motion-reduce:transition-none motion-reduce:opacity-100 motion-reduce:translate-x-0 motion-reduce:-translate-y-1/2"
                      />
                    </div>
                    <button
                      onClick={(event) => {
                        event.stopPropagation();
                        dismissWelcomeAstroRibbon();
                      }}
                      className="ml-auto shrink-0 rounded-full p-1 text-indigo-500 transition-colors hover:bg-indigo-100 hover:text-indigo-700 dark:text-indigo-300 dark:hover:bg-indigo-900/40 dark:hover:text-indigo-100"
                      aria-label={t('chat.astro_nudge.dismiss')}
                      title={t('chat.astro_nudge.dismiss')}
                    >
                      <X className="h-4 w-4" />
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Questions Section - Independent Layout */}
            <div className="w-full flex flex-col items-center">
              <div className="flex gap-3 mb-3 items-start flex-wrap justify-center md:flex-nowrap md:justify-start">
                {(personalModeEnabled || personalModeLoading) && (
                  <div className="flex flex-col gap-1 items-center">
                    <NoiseBackground
                      containerClassName="w-fit p-1 rounded-full"
                      gradientColors={[
                        "rgb(255, 100, 150)",
                        "rgb(100, 150, 255)",
                        "rgb(255, 200, 100)",
                      ]}
                    >
	                      <button
	                        ref={astroTourButtonRef}
	                        onClick={async ()=>{
                          const token = astroNavTokenRef.current;
                          if (userReportStatus.has_horoscope) {
	                              await enterAstroMode();
	                              if (token !== astroNavTokenRef.current) return;
	                              toast.info(t('chat.astro.resuming_horoscope'));
	                              await ensureTodayTimelineVisible(token);
	                          } else {
                              setPersonalModeSource('welcome');
                              setShowPersonalMode(true);
                              setShowCompatibilityMode(false);
                          }
                        }}
                        disabled={isRefreshingTransits || personalModeLoading}
	                        className="sl-chat-astro-mode-button h-full w-full cursor-pointer rounded-full bg-gradient-to-r from-neutral-100 via-neutral-100 to-white px-3 py-1.5 text-[14px] text-black shadow-[0px_2px_0px_0px_var(--color-neutral-50)_inset,0px_0.5px_1px_0px_var(--color-neutral-400)] transition-all duration-100 active:scale-98 dark:from-black dark:via-black dark:to-neutral-900 dark:text-white dark:shadow-[0px_1px_0px_0px_var(--color-neutral-950)_inset,0px_1px_0px_0px_var(--color-neutral-800)] flex items-center gap-2 whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-60"
                      >
                        {personalModeLoading ? (
                          <Loader2 className="w-4 h-4 animate-spin" />
                        ) : tooltipsEnabled ? (
                          <TooltipProvider delayDuration={0}>
                            <Tooltip>
                              <TooltipTrigger asChild>
                                <span className="inline-flex shrink-0">
                                  <User className="w-4 h-4" />
                                </span>
                              </TooltipTrigger>
                              <TooltipContent side="top" align="center" sideOffset={8} className="z-[9999] max-w-[340px] text-xs leading-relaxed">
                                {t('chat.astro.mode_tooltip')}
                              </TooltipContent>
                            </Tooltip>
                          </TooltipProvider>
                        ) : (
                          <User className="w-4 h-4" />
                        )}
                        {(isIndianLocaleUser && isEnglishLocale) ? 'Jyotisha' : t('chat.astro.mode_title')}
                      </button>
                    </NoiseBackground>
                    {userReportStatus.has_horoscope && (
                        <button 
                            onClick={()=>{
                              astroNavTokenRef.current += 1;
                              try { localStorage.removeItem(getAstroThreadStorageKey()); } catch {}
                              const currentSubjectId = getThreadSubjectMeta(
                                activeThreadIdRef.current || ThreadId || null,
                              ).active_subject_id || userReportStatus.default_subject_id || 'self';
                              try {
                                localStorage.removeItem(getAstroChartsStorageKey(currentSubjectId));
                              } catch {}
                              setNatalChartSvgs(null);
                              setIsRefreshingTransits(false);
                              setIsPersonalHoroscopeChat(false);
                              setAstroDayTimeline(null);
                              setAstroTimelineDate('');
                              setShowDayTimeline(true);
                              const keyGeneral = getGeneralThreadStorageKey();
                              const storedGeneral = localStorage.getItem(keyGeneral);
                              if (storedGeneral) {
                                void selectThread(storedGeneral, { personalMode: false, persist: true });
                              }
                              setPersonalModeSource('welcome');
                              setShowPersonalMode(true);
                              setShowCompatibilityMode(false);
                            }}
                            className="inline-flex items-center text-[11px] font-medium text-white bg-black/45 hover:bg-black/60 px-2 py-0.5 rounded-full backdrop-blur-sm shadow-sm transition-colors"
                            style={{ textShadow: '0 1px 2px rgba(0, 0, 0, 0.65)' }}
                        >
                            {t('chat.astro.reset_new_report')}
                        </button>
                    )}
                  </div>
                )}
                {(personalModeEnabled || personalModeLoading) && (
                  <div className="flex flex-col gap-1 items-center">
                    <NoiseBackground
                      containerClassName="w-fit p-1 rounded-full"
                      gradientColors={[
                        "rgb(255, 100, 150)",
                        "rgb(100, 150, 255)",
                        "rgb(255, 200, 100)",
                      ]}
                    >
	                      <button
	                        ref={compatTourButtonRef}
	                        onClick={async () => {
                          const token = compatibilityNavTokenRef.current;
                          setShowPersonalMode(false);
                          setCompatibilityResult(null);
                          setIsCompatibilityLoading(false);

                          if (!userReportStatus.has_compatibility) {
                            setShowCompatibilityMode(true);
                            setIsChatOpen(false);
                            return;
                          }

                          toast.info(t('chat.astro.resuming_compatibility'));
                          if (userReportStatus.has_horoscope) {
                            setShowCompatibilityMode(false);
                            const astroToken = astroNavTokenRef.current;
	                            await enterAstroMode();
	                            if (token !== compatibilityNavTokenRef.current) return;
	                            if (astroToken !== astroNavTokenRef.current) return;
	                            await ensureTodayTimelineVisible(astroToken);
	                            return;
                          }

                          setShowCompatibilityMode(true);
                          setIsChatOpen(false);
                          setIsCompatibilityLoading(true);
                          try {
                            const headers = await getSecureHeaders();
                            if (token !== compatibilityNavTokenRef.current) return;
                            const API_BASE_URL = import.meta.env.VITE_APP_SERVER;
                            const res = await fetch(`${API_BASE_URL}/api/astrology/report/compatibility?t=${Date.now()}`, {
                              method: 'GET',
                              headers,
                              cache: 'no-store',
                            });
                            if (res.ok) {
                              const data = await res.json();
                              if (token !== compatibilityNavTokenRef.current) return;
                              setCompatibilityResult(data?.data ?? data);
                            } else {
                              const raw = await res.text();
                              console.error('Failed to fetch compatibility report', res.status, raw);
                              toast.error(t('chat.astro.compatibility_load_error'));
                            }
                          } catch (e) {
                            console.error('Failed to fetch compatibility report', e);
                            toast.error(t('chat.astro.compatibility_load_error'));
                          } finally {
                            if (token === compatibilityNavTokenRef.current) {
                              setIsCompatibilityLoading(false);
                            }
                          }
                        }}
                        disabled={personalModeLoading}
	                        className="sl-chat-astro-mode-button h-full w-full cursor-pointer rounded-full bg-gradient-to-r from-neutral-100 via-neutral-100 to-white px-3 py-1.5 text-[14px] text-black shadow-[0px_2px_0px_0px_var(--color-neutral-50)_inset,0px_0.5px_1px_0px_var(--color-neutral-400)] transition-all duration-100 active:scale-98 dark:from-black dark:via-black dark:to-neutral-900 dark:text-white dark:shadow-[0px_1px_0px_0px_var(--color-neutral-950)_inset,0px_1px_0px_0px_var(--color-neutral-800)] flex items-center gap-2 whitespace-nowrap disabled:cursor-not-allowed disabled:opacity-60"
                      >
                        {personalModeLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Heart className="w-4 h-4"/>}
                        {(isIndianLocaleUser && isEnglishLocale) ? 'Kundli Match' : t('chat.astro.compatibility_title')}
                      </button>
                    </NoiseBackground>
                    {userReportStatus.has_compatibility && (
                        <button 
                            onClick={()=>{
                                compatibilityNavTokenRef.current += 1;
                                threadMessagesTokenRef.current += 1;
                                sendMessageTokenRef.current += 1;
                                exploreTopicsTokenRef.current += 1;
                                sendMessageAbortControllerRef.current?.abort();
                                sendMessageAbortControllerRef.current = null;
                                try { localStorage.removeItem('boyFormData'); } catch {}
                                try { localStorage.removeItem('girlFormData'); } catch {}
                                setCompatibilityResult(null);
                                setIsCompatibilityLoading(false);
                                setIsThreadMessagesLoading(false);
                                setLoadingThreadId(null);
                                setLoading(false);
                                setIsStreaming(false);
                                setShowCompatibilityMode(true);
                                setShowPersonalMode(false);
                                setIsChatOpen(false);
                            }}
                            className="inline-flex items-center text-[11px] font-medium text-white bg-black/45 hover:bg-black/60 px-2 py-0.5 rounded-full backdrop-blur-sm shadow-sm transition-colors"
                            style={{ textShadow: '0 1px 2px rgba(0, 0, 0, 0.65)' }}
                        >
                            {t('chat.astro.reset_new_report')}
                        </button>
                    )}
                  </div>
                )}
                <button
                  onClick={()=>{SetJourney(true)}}
                  className="action-button flex items-center gap-2 px-3 py-1.5 rounded-xl text-[14px] bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors whitespace-nowrap"
                >
                  <AcUnit fontSize="small" />
                  {t('chat.journey_into_wisdom')}
                </button>
                <button
                  onClick={()=>{setIsPranayamaModalOpen(true)}}
                  onMouseEnter={() => { void loadPranayamaModal(); }}
                  onFocus={() => { void loadPranayamaModal(); }}
                  onTouchStart={() => { void loadPranayamaModal(); }}
                  className="action-button flex items-center gap-2 px-3 py-1.5 rounded-xl text-[14px] bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors whitespace-nowrap"
                >
                  <YogashashtraIcon fontSize="small" />
                  {t('chat.pranayama_practice')}
                </button>
                <LocalizedLink
                  to="/dashboard"
                  className="action-button flex items-center gap-2 px-3 py-1.5 rounded-xl text-[14px] bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors whitespace-nowrap"
                >
                  <Wrench className="w-4 h-4"/>
                  {t('chat.tools', 'Tools')}
                </LocalizedLink>
                <button
                  onClick={()=>{setIsTodoModalOpen(true)}}
                  onMouseEnter={() => { void loadQuestlogModal(); }}
                  onFocus={() => { void loadQuestlogModal(); }}
                  onTouchStart={() => { void loadQuestlogModal(); }}
                  className="action-button flex items-center gap-2 px-3 py-1.5 rounded-xl text-[14px] bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors whitespace-nowrap"
                >
                  <Check fontSize="small" />
                  {t('chat.todo_manager')}
                </button>
                <Tippy content={
                     !canStartQuiz
                       ? t('chat.quiz_cooldown')
                       : t('chat.take_quiz')
                   }
                >
                  {/* The button is wrapped in a span for Tippy to work when disabled */}
                  <span
                    onMouseEnter={() => { void loadQuizModal(); }}
                    onFocus={() => { void loadQuizModal(); }}
                  >
                    <button
                      onClick={handleOpenQuiz}
                      disabled={!canStartQuiz || isQuizPreparing}
                      className="action-button flex items-center gap-2 px-3 py-1.5 rounded-xl text-[14px] bg-gray-100 text-gray-800 hover:bg-gray-200 transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isQuizPreparing && (
                        <span className="animate-spin rounded-full h-3 w-3 border-t-2 border-gray-700" />
                      )}
                      <Trophy className="w-4 h-4"/>
                       {t('chat.indic_quiz')}
                    </button>
                  </span>
                </Tippy>
              </div>

              {!isListOpen ? (
                <div className="flex justify-center gap-2.5 flex-wrap px-2">
                  {Object.keys(questionData).map((category) => {
                    const MuiIcon = categoryIconsMui[category as keyof typeof categoryIconsMui];
                    return (
                      <button
                        key={category}
                        className="sacred-category-button group relative flex items-center gap-2 px-4 py-3 rounded-2xl text-[14px] font-medium transition-all duration-300 ease-out transform hover:scale-105 hover:-translate-y-1 overflow-hidden"
                        onClick={() => { setIsListOpen(true); setSelectedCategory(category); }}
                      >
                        {/* Gradient background */}
                        <div className="absolute inset-0 bg-gradient-to-br from-white/90 via-slate-50/80 to-blue-50/70 backdrop-blur-sm border border-white/40 rounded-2xl shadow-lg group-hover:shadow-xl transition-all duration-300"></div>
                        
                        {/* Hover shimmer effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700 ease-out"></div>
                        
                        {/* Icon with gradient background */}
                        <div className="relative z-10 w-7 h-7 rounded-full bg-gradient-to-br from-orange-400 to-amber-500 flex items-center justify-center shadow-md group-hover:shadow-lg transition-all duration-300 group-hover:scale-110">
                          <MuiIcon fontSize="small" className="text-white drop-shadow-sm" />
                        </div>
                        
                        {/* Text with main label and Sanskrit subscript */}
                        <div className="relative z-10 text-slate-700 group-hover:text-slate-800 transition-colors duration-300 drop-shadow-sm flex flex-col items-start leading-tight">
                          <span className="text-[14px] font-medium">
                            {categoryLabels[category as keyof typeof categoryLabels]?.main || category.charAt(0).toUpperCase() + category.slice(1)}
                          </span>
                          <span className="text-[11px] font-normal text-slate-500 group-hover:text-slate-600 transition-colors duration-300 -mt-0.5">
                            {categoryLabels[category as keyof typeof categoryLabels]?.sanskrit || category}
                          </span>
                        </div>
                        
                        {/* Subtle glow on hover */}
                        <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-orange-200/0 to-amber-200/0 group-hover:from-orange-200/20 group-hover:to-amber-200/20 transition-all duration-300"></div>
                      </button>
                    );
                  })}
                </div>
              ) : (
                <div className="w-full flex justify-center">
                  {selectedCategory && (
                    <div ref={listRef} className="max-w-2xl w-full mx-4 relative">
                      <button
                        type="button"
                        onClick={() => {
                          setIsListOpen(false);
                          setSelectedCategory('');
                        }}
                        className="absolute right-0 top-0 z-10 inline-flex items-center justify-center w-3.5 h-3.5 scale-110 rounded-full bg-white border border-gray-300 text-gray-500 hover:text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-colors"
                        aria-label="Close list"
                      >
                        <X className="w-2.5 h-2.5" />
                      </button>
                      <ul className="space-y-2 pt-1">
                        {questionData?.[selectedCategory]?.map((question: string, qIndex: number) => (
                          <li
                            key={qIndex}
                            onClick={() => {
                              setMessage('');
                              setIsListOpen(false);
                              setIsChatOpen(true);
                              handleSendMessage(question);
                            }}
                            className="group w-full text-left px-4 py-3 bg-white border border-gray-200 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 hover:border-gray-300 hover:shadow-sm transition-all duration-200 flex items-start gap-3 cursor-pointer"
                          >
                            <ArrowUp className="mt-0.5 w-4 h-4 text-gray-400 group-hover:text-gray-600 transition-colors" />
                            <span dangerouslySetInnerHTML={{ __html: question }} className="text-sm leading-relaxed"></span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              )}
              
              {/* Add ticker below category buttons when list is closed */}
              {!isListOpen && (
                <div className="w-full mt-4">
                  <NewTicker onItemClick={(item) => {
                    setIsListOpen(false);
                    setSelectedCategory('');
                    setIsChatOpen(true);
                    setMessage(`Explain in detail about ${item}`);
                    requestAnimationFrame(() => chatTextareaRef.current?.focus());
                  }} />
                </div>
              )}
            </div>
          </div>
        )}

        {isChatOpen && !showPersonalMode && !showCompatibilityMode && (
          <div
            ref={scrollContainerRef}
            onScroll={handleMessagesScroll}
            className={
              // "relative flex-1 flex flex-col overflow-y-auto p-2"
              "relative flex-1 flex min-w-0 flex-col overflow-x-hidden overflow-y-auto p-2 w-full"
            }
            style={{
              marginTop: `${headerOffsetPx}px`,
              transition: 'margin-top 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
              paddingBottom: `calc(var(--chat-input-height, 80px) + 1rem)`,
              scrollPaddingBottom: `calc(var(--chat-input-height, 80px) + 1rem)`,
              // No scrollPaddingTop needed when container starts below header
              scrollPaddingTop: undefined as unknown as string
            }}
          >
            <img
              src={chatLeaf}
              alt=""
              aria-hidden="true"
              className={styles.chatLeaf}
            />
            <div className="relative">
              {showAstroConversationTip && isPersonalHoroscopeChat && (
                <div className="hidden md:block absolute top-0 -translate-y-1 left-0 right-0 z-20 pointer-events-auto">
                  <div className="max-w-[48rem] mx-auto px-4">
                    <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 flex items-center gap-3 shadow-sm">
                      <div className="flex-shrink-0 text-blue-700">
                        <Lightbulb className="w-5 h-5" />
                      </div>
                      <div className="flex-1 text-sm text-blue-800">
                        <strong>Tip:</strong> Deselect fast mode and use manuscript filter for highest accuracy.
                      </div>
                      <button
                        onClick={() => setShowAstroConversationTip(false)}
                        className="flex-shrink-0 text-blue-600 hover:text-blue-800 transition-colors p-1 rounded hover:bg-blue-100"
                        aria-label="Close notification"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {/* CENTERED CHAT LAYOUT WRAPPER — controls the max-width of the message area.
                  To revert to full-width messages (original layout), simply remove this wrapper div
                  and keep only the inner chatRef div directly. Responsive to sidebar state. */}
              <div className={`mx-auto min-w-0 w-full px-2 transition-all duration-300 ${isSidebarOpen ? 'max-w-[72rem]' : 'max-w-[56rem]'}`}>
                <div ref={chatRef} className={`min-w-0 overflow-x-hidden bg-white rounded-lg p-4 ${styles.chatScrollArea}`}>
              {isRefreshingTransits && (
                <div className="flex justify-center my-3">
                  <div className="bg-amber-50 dark:bg-amber-950/30 border border-amber-200 dark:border-amber-800 rounded-lg px-4 py-2.5 text-xs text-amber-700 dark:text-amber-300 flex items-center gap-2">
                    <div className="animate-spin rounded-full h-3.5 w-3.5 border-2 border-amber-400 border-t-transparent" />
                    {dayQualityUpdatingText}
                  </div>
                </div>
              )}
              {isThreadMessagesLoading && (
                <div className="flex items-center justify-center py-6">
                  <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-gray-500" />
                </div>
              )}
              {isPersonalHoroscopeChat &&
                natalChartSvgs?.north_indian_data_uri &&
                natalChartSvgs?.south_indian_data_uri && (
                  <div className="mb-6 flex justify-start">
                    <div className="max-w-[100%]">
                      <div className="flex flex-wrap gap-4 items-start">
                        <div className="flex-1 min-w-[260px] max-w-[420px]">
                          <div className="font-semibold mb-2 text-gray-700">North Indian Style</div>
                          <img
                            src={natalChartSvgs.north_indian_data_uri}
                            alt="North Indian Vedic chart"
                            className="w-full max-w-[400px] h-auto border border-gray-200 rounded-xl bg-white"
                          />
                        </div>
                        <div className="flex-1 min-w-[260px] max-w-[420px]">
                          <div className="font-semibold mb-2 text-gray-700">South Indian Style</div>
                          <img
                            src={natalChartSvgs.south_indian_data_uri}
                            alt="South Indian Vedic chart"
                            className="w-full max-w-[400px] h-auto border border-gray-200 rounded-xl bg-white"
                          />
                        </div>
                      </div>
                      {showDayTimeline && (
                        <div className="mt-4 w-full">
                          {/* Basic/Advanced toggle — only show when real data is loaded */}
                          {astroDayTimeline && (astroDayTimeline.segments?.length ?? 0) > 0 && (
                            <div className="flex items-center justify-end mb-2">
                              <div className="inline-flex rounded-lg border border-gray-200 bg-white overflow-hidden">
                                <button
                                  type="button"
                                  onClick={async () => {
	                                    if (astroTimelineMode === 'basic') return;
	                                    setAstroTimelineMode('basic');
                                    await refreshGocharaAndHydrateTimeline(astroNavTokenRef.current, {
                                      modeOverride: 'basic',
                                      targetDate: selectedAstroTimelineDate,
                                      suppressSuccessToast: true,
                                    });
	                                  }}
                                  disabled={isRefreshingTransits}
                                  className={`px-3 py-1.5 text-xs font-medium flex items-center gap-1.5 ${
                                    astroTimelineMode === 'basic'
                                      ? 'bg-gray-900 text-white'
                                      : 'text-gray-700 hover:bg-gray-50'
                                  } ${isRefreshingTransits ? 'opacity-50 cursor-not-allowed' : ''}`}
                                >
                                  {isRefreshingTransits && astroTimelineMode === 'basic' && (
                                    <div className="animate-spin rounded-full h-3 w-3 border-2 border-current border-t-transparent" />
                                  )}
                                  Basic
                                </button>
                                <Tippy
                                  disabled={!tooltipsEnabled}
                                  content={
                                    <div className="max-w-[220px] rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs text-gray-700 shadow-lg">
                                      {t('chat.day_quality.advanced_mode_hint', 'Advanced mode considers more birth-chart factors, so the day quality may differ from Basic mode.')}
                                    </div>
                                  }
                                  placement="top"
                                  delay={[120, 0]}
                                  appendTo={() => document.body}
                                >
                                  <span className="inline-flex">
                                    <button
                                      type="button"
                                      onClick={async () => {
	                                    if (astroTimelineMode === 'advanced') return;
	                                    setAstroTimelineMode('advanced');
                                        await refreshGocharaAndHydrateTimeline(astroNavTokenRef.current, {
                                          modeOverride: 'advanced',
                                          targetDate: selectedAstroTimelineDate,
                                          suppressSuccessToast: true,
                                        });
	                                  }}
                                      disabled={isRefreshingTransits}
                                      className={`px-3 py-1.5 text-xs font-medium flex items-center gap-1.5 ${
                                        astroTimelineMode === 'advanced'
                                          ? 'bg-gray-900 text-white'
                                          : 'text-gray-700 hover:bg-gray-50'
                                      } ${isRefreshingTransits ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    >
                                      {isRefreshingTransits && astroTimelineMode === 'advanced' && (
                                        <div className="animate-spin rounded-full h-3 w-3 border-2 border-current border-t-transparent" />
                                      )}
                                      Advanced
                                    </button>
                                  </span>
                                </Tippy>
                              </div>
                            </div>
                          )}
                          <div className="relative">
                            {astroDayTimeline && (astroDayTimeline.segments?.length ?? 0) > 0 ? (
	                              <DayQualityTimeline
	                                timeline={astroDayTimeline}
	                                timelineDate={selectedAstroTimelineDate}
	                                isToday={astroTimelineIsToday}
	                                headerControl={
	                                  <div className="flex flex-col gap-2 sm:items-end">
	                                    <DayQualityDatePicker
	                                      value={selectedAstroTimelineDate}
	                                      minDate={dayQualityMinDate}
	                                      maxDate={dayQualityMaxDate}
                                      hitCost={DAY_QUALITY_DATE_PICK_HIT_COST}
                                      disabled={isRefreshingTransits}
                                      onSelect={async (nextDate) => {
                                        await refreshGocharaAndHydrateTimeline(astroNavTokenRef.current, {
                                          targetDate: nextDate,
                                          suppressSuccessToast: true,
                                        });
                                      }}
	                                    />
	                                    {!astroTimelineIsToday && (
	                                      <button
	                                        type="button"
                                        disabled={isRefreshingTransits}
                                        onClick={() => refreshGocharaAndHydrateTimeline(astroNavTokenRef.current, {
                                          targetDate: getClientLocalDateIso(),
                                          suppressSuccessToast: true,
                                        })}
	                                        className={`rounded-full border border-gray-200 bg-white px-3 py-1.5 text-xs font-semibold text-gray-700 shadow-sm transition hover:bg-gray-50 ${
	                                          isRefreshingTransits ? 'cursor-not-allowed opacity-60' : ''
	                                        }`}
	                                      >
	                                        {t('chat.day_quality.reset_to_today', 'Reset to today')}
	                                      </button>
	                                    )}
	                                  </div>
	                                }
	                                onSegmentPick={({ label, startMin, endMin }) => {
	                                  const promptDate = astroTimelineIsToday
	                                    ? 'today'
	                                    : `on ${formatTimelineDateForPrompt(selectedAstroTimelineDate)}`;
	                                  setMessage(`Is ${formatTimelineMin(startMin)}–${formatTimelineMin(endMin)} (${label}) a good time for my next step ${promptDate}?`);
	                                  requestAnimationFrame(() => chatTextareaRef.current?.focus());
	                                }}
	                              />
                            ) : timelineFetchFailed && !isRefreshingTransits ? (
                              <div className="h-10 w-full rounded-lg border border-gray-200 bg-gray-50 flex items-center justify-center gap-2">
                                <span className="text-xs text-gray-500">{t('chat.day_quality.load_failed', 'Could not load day quality')}</span>
                                <button
                                  type="button"
		                                  onClick={() => refreshGocharaAndHydrateTimeline(astroNavTokenRef.current, {
		                                    modeOverride: astroTimelineMode,
		                                    targetDate: selectedAstroTimelineDate,
		                                  })}
                                  className="p-1 text-gray-500 hover:text-gray-800 transition-colors"
                                  title="Retry"
                                >
                                  <RotateCcw className="w-3.5 h-3.5" />
                                </button>
                              </div>
                            ) : !isRefreshingTransits && !(astroDayTimeline?.segments?.length) ? (
                              <div className="relative h-10 w-full rounded-lg border border-gray-200 overflow-hidden">
                                {/* Greyed-out placeholder bar */}
                                <div className="absolute inset-0 flex">
                                  <div className="h-full bg-gray-200" style={{ width: '15%' }} />
                                  <div className="h-full bg-gray-300" style={{ width: '12%' }} />
                                  <div className="h-full bg-gray-200" style={{ width: '18%' }} />
                                  <div className="h-full bg-gray-200/70" style={{ width: '10%' }} />
                                  <div className="h-full bg-gray-300" style={{ width: '14%' }} />
                                  <div className="h-full bg-gray-200" style={{ width: '16%' }} />
                                  <div className="h-full bg-gray-300" style={{ width: '15%' }} />
                                </div>
                                <div className="absolute inset-0 flex items-center justify-center">
                                  <button
                                    type="button"
                                    onClick={() => refreshGocharaAndHydrateTimeline(astroNavTokenRef.current, {
                                      modeOverride: astroTimelineMode,
                                      targetDate: selectedAstroTimelineDate,
                                    })}
                                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-white/90 border border-gray-300 text-xs font-medium text-gray-600 hover:text-gray-900 hover:bg-white transition-colors shadow-sm"
                                    title="Refresh day quality"
                                  >
                                    <RotateCcw className="w-3 h-3" />
                                    {t('chat.day_quality.title', 'Personalized Day Quality')}
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="h-10 w-full rounded-lg border border-gray-200 bg-gray-50" />
                            )}
                            {isRefreshingTransits && (
                              <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-white/60 backdrop-blur-[1px]">
                                <div className="flex items-center gap-2 text-xs font-medium text-gray-700">
                                  <div className="animate-spin rounded-full h-3.5 w-3.5 border-2 border-gray-500 border-t-transparent" />
		                                  {dayQualityUpdatingText}
		                                </div>
		                              </div>
		                            )}
	                          </div>
	                          {astroTimelinePickError && (
	                            <div className="mt-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
	                              {astroTimelinePickError}
	                            </div>
	                          )}
	                        </div>
	                      )}
                    </div>
                  </div>
                )}
              {showDinacharyaCard && (
                <DinacharyaCTACard
                  currentDate={selectedAstroTimelineDate}
                  todayDate={dayQualityTodayIso}
                  tomorrowDate={dayQualityTomorrowIso}
                  generatedDates={dinacharyaGeneratedDates}
                  isGenerating={isDinacharyaGenerating}
                  disabled={loading || isStreaming || isThreadMessagesLoading || isRefreshingTransits}
                  onSelectDate={handleDinacharyaDateSelect}
                  onGenerate={() => {
                    void handleSendMessage(
                      t(
                        'chat.dinacharya.generate_prompt_for_date',
                        'Generate my personalized Daily Vedic Routine for {{relativeDate}}.',
                        { relativeDate: dinacharyaPromptDateLabel }
                      ),
                      {
                        dinacharyaMode: true,
                        dinacharyaGocharaDate: selectedAstroTimelineDate,
                      }
                    );
                  }}
                />
              )}
              {chatHistory.map((msg, index) => (
                msg.isSystemNote ? (
                  <div key={index} className="flex justify-center my-3">
                    <div className="bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-800 rounded-lg px-4 py-2 text-xs text-blue-700 dark:text-blue-300 max-w-md text-center leading-relaxed">
                      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                        {msg.text}
                      </ReactMarkdown>
                    </div>
                  </div>
                ) : (
                <React.Fragment key={index}>
	                  <div
	                    id={`message-block-${index}`}
	                    data-turn-index={typeof msg.turnIndex === 'number' ? msg.turnIndex : undefined}
	                    data-chat-jump-id={getChatJumpMessageId(index, msg)}
	                    ref={(el) => {
	                      const messageId = getChatJumpMessageId(index, msg);
	                      if (el) {
	                        chatJumpMessageRefs.current[messageId] = el;
	                      } else {
	                        delete chatJumpMessageRefs.current[messageId];
	                      }
	                    }}
	                    style={index === 0 ? { scrollMarginTop: `${Math.max(headerOffsetPx - 12, 0)}px` } : undefined}
	                    className={`mb-4 flex min-w-0 ${msg.isUser ? 'justify-end' : 'justify-start'} relative group ${msg.isUser ? styles.userBubbleGroup : ''}`}
	                  >
	                    {msg.isUser && (() => {
	                      const targetId = findPreviousUserMessageId(index);
	                      if (!targetId || visibleChatJumpMessageIds.has(targetId)) return null;
	                      const label = t('chat.jump_to_previous_question', 'Jump to previous question');
	                      return (
	                        <button
	                          type="button"
	                          onClick={(e) => {
	                            e.stopPropagation();
	                            scrollToChatJumpMessage(targetId);
	                          }}
	                          className={`${styles.chatJumpArrow} mt-2 mr-2`}
	                          title={label}
	                          aria-label={label}
	                        >
	                          <ChevronUp className="w-4 h-4" />
	                        </button>
	                      );
	                    })()}
	                    <div
	                      className={`max-w-[100%] min-w-0 p-4 rounded-xl ${msg.isUser
	                          ? 'bg-gray-100 text-black  transform translate-y-[-2px]'
	                          : 'text-gray-700 transform translate-y-[-1px]'
	                        } ${highlightedChatJumpMessageId === getChatJumpMessageId(index, msg) ? styles.chatJumpHighlight : ''}`}
	                    >
                      {msg.isUser ? (
	                        <div
	                          className="whitespace-pre-wrap relative focus:outline-none"
	                          tabIndex={-1}
	                          onTouchStart={(e) => {
	                            (e.currentTarget as HTMLDivElement).focus();
	                          }}
	                        >
	                          <div
	                            className={`float-right ml-2 mb-1 flex items-center gap-1 ${styles.userBubbleActions}`}
	                          >
	                            <button
	                              onClick={(e) => {
	                                e.stopPropagation();
	                                void handleRememberMessage(index, msg);
	                              }}
	                              disabled={rememberingMessageIndex === index}
	                              className="rounded-md border border-gray-200 bg-white/90 px-2 py-1 text-[11px] font-medium text-gray-700 shadow-sm transition hover:text-gray-900 active:scale-95 disabled:cursor-not-allowed disabled:opacity-60"
	                              title="Remember this"
	                              aria-label="Remember this message"
	                            >
	                              {rememberingMessageIndex === index ? 'Saving' : 'Remember'}
	                            </button>
	                            <button
	                              onClick={(e) => {
	                                e.stopPropagation();
	                                navigator.clipboard.writeText(msg.text);
	                                toast.success(t('chat.message_copied'), { position: 'bottom-right' });
	                              }}
	                              className="rounded-md bg-white/85 p-1 text-gray-600 shadow-sm hover:text-gray-800 active:scale-95"
	                              title="Copy"
	                              aria-label="Copy question"
	                            >
	                              <Copy className="w-4 h-4" />
	                            </button>
	                          </div>
	                          {msg.text}
                          {(() => {
                            const nextMsg = chatHistory[index + 1];
                            const showCosmicLoader =
                              !!nextMsg &&
                              !nextMsg.isUser &&
                              !!nextMsg.isLoading &&
                              !nextMsg.text?.trim() &&
                              !nextMsg.thoughtText?.trim();

                            if (!showCosmicLoader) return null;

                            return (
                              <div className="clear-both flex justify-end">
                                <CosmicLoader isLoading={true} mode={msg.personalMode ? 'astro' : 'general'} />
                              </div>
                            );
                          })()}
                        </div>
                      ) : (
                        <div className="relative">
                          {msg.isLoading && !msg.text?.trim() && !msg.thoughtText?.trim() && (
                            <LoadingIndicator isFastMode={msg.isDinacharya ? false : isFastSearch} isListeningMode={isListeningMode} loading={loading} currentTip={currentTip} isFading={isFading} />
                          )}

                          {!!msg.thoughtText?.trim() && (
                            <details
                              open={thinkingPanelOpen[index] ?? (msg.isLoading ? true : false)}
                              onToggle={(e) => {
                                const nextOpen = (e.currentTarget as HTMLDetailsElement).open;
                                setThinkingPanelOpen(prev => ({ ...prev, [index]: nextOpen }));
                              }}
                              className="mt-3 rounded-lg border border-amber-200/70 bg-amber-50/60 px-3 py-2 text-amber-950"
                            >
                              <summary className="cursor-pointer select-none text-xs font-semibold tracking-wide text-amber-900/80">
                                Thinking
                              </summary>
                              <div className="mt-2 whitespace-pre-wrap text-sm text-amber-950/90">
                                {msg.thoughtText}
                              </div>
                            </details>
                          )}

                          {hasFailedMessage && index === chatHistory.length - 1 && !msg.isUser && !msg.isLoading && !msg.text?.trim() && (
                            <div className="mt-3">
                              <button
                                type="button"
                                onClick={handleRetryMessage}
                                disabled={retryingMessage}
                                className="inline-flex items-center gap-2 px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800 transition-colors disabled:opacity-50"
                                title={t('chat.retry', 'Retry')}
                              >
                                <RotateCcw className="w-4 h-4" />
                                {t('chat.retry_generation', 'Retry')}
                              </button>
                            </div>
                          )}

                          {!!msg.text && (
                            <div className="mt-3">
                              <div className={msg.isDinacharya && printingDinacharyaIndex === index ? 'dinacharya-printable' : undefined}>
                                {msg.isDinacharya && !msg.isLoading && (
                                  <DinacharyaActionsBar
                                    generatedForDate={msg.dinacharyaGeneratedForDate}
                                    onPrint={() => handlePrintDinacharya(index)}
                                    onDownloadPdf={() => void handleDownloadDinacharyaPdf(index, msg)}
                                    isPdfGenerating={pdfGeneratingDinacharyaIndex === index}
                                  />
                                )}
                                {(effectiveUiMode === 'normal' && !isListeningMode && !msg.text.includes('[MEDIA:')) ? (
                                  <div className="prose prose-lg max-w-none dark:prose-invert" style={{ lineHeight: "1.7" }}>
                                  <AnswerMarkdown
                                    text={getDisplayedAnswerText(index, msg).replace(/\n/g, '  \n')}
                                    messageIndex={index}
                                    isDinacharya={Boolean(msg.isDinacharya)}
                                    onSend={handleSendMessage}
                                  />
                                </div>
                              ) : (
                                <MessageComponent msg={msg} handleSendMessage={handleSendMessage} messageIndex={index} translationEnabled={translationEnabled} mode={mode} />
                              )
                            }
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    {/* --- Progressive Context Expansion UI --- */}
                    {!msg.isUser && msg.text && !msg.isLoading && (
                      <>
                        {/* Expansion text (shown after expand completes) */}
                        {msg.expansionText && (
                          <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
                            <p className="text-xs text-gray-500 dark:text-gray-400 mb-2 font-medium">{t('chat.additional_findings', 'Additional findings')}</p>
                            <div className="prose prose-sm dark:prose-invert max-w-none text-gray-800 dark:text-gray-200">
                              <ReactMarkdown remarkPlugins={[remarkGfm]}>{msg.expansionText}</ReactMarkdown>
                            </div>
                          </div>
                        )}
                        {/* "More details" link — hidden when rate limited */}
                        {msg.canExpand && !msg.expansionText && !msg.isExpanding && !isRateLimitExceeded && (
                          <button
                            onClick={() => handleExpand(index)}
                            className="text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 hover:underline mt-3 flex items-center gap-1"
                          >
                            <Plus className="w-4 h-4" />
                            {t('chat.more_details', 'More details')} ({msg.remainingCount} {t('chat.sources', 'sources')})
                          </button>
                        )}
                        {/* Expanding spinner */}
                        {msg.isExpanding && !msg.expansionText && (
                          <div className="text-sm text-gray-500 dark:text-gray-400 mt-3 flex items-center gap-2">
                            <div className="w-4 h-4 border-2 border-gray-300 dark:border-gray-500 border-t-blue-500 rounded-full animate-spin" />
                            {t('chat.more_details_loading', 'Searching deeper...')}
                          </div>
                        )}
                      </>
                    )}
	                    {!msg.isUser && msg.text && (
	                      <div className="relative top-[8px] max-w-full transition-opacity duration-200">
	                        <div className="flex max-w-full flex-wrap items-center gap-y-1">
	                          {(() => {
	                            const targetId = findPreviousUserMessageId(index);
	                            if (!targetId || visibleChatJumpMessageIds.has(targetId)) return null;
	                            const label = t('chat.jump_to_answer_question', "Jump to this answer's question");
	                            return (
	                              <button
	                                type="button"
	                                onClick={(e) => {
	                                  e.stopPropagation();
	                                  scrollToChatJumpMessage(targetId);
	                                }}
	                                className={`${styles.chatJumpArrow} mr-1`}
	                                title={label}
	                                aria-label={label}
	                              >
	                                <ChevronUp className="w-4 h-4" />
	                              </button>
	                            );
	                          })()}
	                          <ShastricBasisBadge mode={effectiveUiMode} />
                          <button
                            onClick={() => toggleBookmarkForAnswer(index, msg)}
                            className="p-1 text-gray-600 hover:text-gray-800 mr-1"
                            title="Bookmark"
                          >
                            <Bookmark className="w-5 h-5" fill={(typeof msg.turnIndex === 'number' && bookmarkedTurnsForActiveThread.has(msg.turnIndex)) ? 'currentColor' : 'none'} />
                          </button>
                          <button
                            onClick={() => {
                              navigator.clipboard.writeText(getCopyableAnswerText(index, msg));
                              toast.success(t('chat.message_copied'), { position: 'bottom-right' });
                            }}
                            className="p-1 text-gray-600 hover:text-gray-800 mr-1"
                            title="Copy"
                          >
                            <Copy className="w-5 h-5" />
                          </button>
                          <TTSButton text={msg.text.split('**questions**')[0].trim() || msg.text.split('**Questions**')[0].trim() || msg.text} />
                          {/* Reading Mode dropdown — hidden when rate limited */}
                          {msg.canRead && msg.readSources && msg.readSources.length > 0 &&
                           !isPersonalHoroscopeChat && !showCompatibilityMode && !isListeningMode && !isRateLimitExceeded && (
                            <ReadingDropdownButton
                              sources={msg.readSources}
                              onSelect={(source) => {
                                if (showReadingNudge && readingNudgeMessageIndex === index) {
                                  hideReadingNudge(true);
                                }
                                setReadingModalProps({ token: source.token, label: source.label, ci: source.ci });
                                setIsReadingModalOpen(true);
                              }}
                              t={t}
                              showNudge={showReadingNudge && readingNudgeMessageIndex === index}
                              nudgeLabel={t('chat.reading_nudge_label', 'Read source passages')}
                              onNudgeDismiss={() => {
                                hideReadingNudge(true);
                              }}
                              onOpen={() => {
                                if (showReadingNudge && readingNudgeMessageIndex === index) {
                                  hideReadingNudge(true);
                                }
                              }}
                            />
                          )}
                          {hasFailedMessage && index === chatHistory.length - 1 && !msg.isUser && !!msg.text?.trim() && (
                            <button
                              type="button"
                              onClick={handleRetryMessage}
                              disabled={retryingMessage}
                              className="inline-flex items-center gap-2 px-3 py-1.5 bg-black text-white rounded-md hover:bg-gray-800 transition-colors mr-2 disabled:opacity-50"
                              title={t('chat.retry', 'Retry')}
                            >
                              <RotateCcw className="w-4 h-4" />
                              {t('chat.retry', 'Retry')}
                            </button>
                          )}
                          <button
                            type="button"
                            onClick={() => setShowInfoTipsPopup(true)}
                            className="p-1 text-gray-600 hover:text-gray-800 mr-1"
                            title="Tips for Better Answers"
                          >
                            <Info className="w-5 h-5" />
                          </button>
                          {translationEnabled && effectiveUiMode === 'normal' && !isListeningMode && (
                            <div className="relative mr-1">
                              {!answerLanguagesLoaded ? (
                                <button
                                  onClick={() => fetchSupportedAnswerLanguages()}
                                  disabled={answerLanguagesLoading}
                                  className="p-1 text-gray-600 mr-1 disabled:opacity-70 disabled:cursor-not-allowed"
                                  title={answerLanguagesLoading ? 'Loading languages' : 'Load languages'}
                                >
                                  {answerLanguagesLoading ? (
                                    <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-gray-500" />
                                  ) : (
                                    <Languages className="w-5 h-5" />
                                  )}
                                </button>
                              ) : answerTranslations[getAnswerTranslationKey(index)]?.loading ? (
                                <button
                                  disabled
                                  className="p-1 text-gray-600 mr-1 opacity-70 cursor-not-allowed"
                                  title="Translating"
                                >
                                  <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-gray-500" />
                                </button>
                              ) : answerTranslations[getAnswerTranslationKey(index)]?.translated ? (
                                <button
                                  onClick={() => handleAnswerTranslateSelection(index, answerTranslations[getAnswerTranslationKey(index)]?.targetLang || 'en')}
                                  className="p-1 text-gray-600 hover:text-gray-800"
                                  title={answerTranslations[getAnswerTranslationKey(index)]?.showingTranslated ? 'Show original text' : 'Show translated text'}
                                >
                                  <Languages className="w-5 h-5" />
                                </button>
                              ) : (
                                <Tippy
                                  content={
                                    <div className="bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg p-3" style={{ maxWidth: '250px' }}>
                                      <div className="text-sm font-medium mb-2 text-gray-700 dark:text-gray-300">Translate to:</div>
                                      <div className="max-h-40 overflow-y-auto">
                                        {supportedAnswerLanguages.map((lang) => (
                                          <button
                                            key={lang.code}
                                            onClick={() => handleAnswerTranslateSelection(index, lang.code)}
                                            disabled={answerTranslations[getAnswerTranslationKey(index)]?.loading}
                                            className="w-full text-left px-2 py-1 text-xs text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
                                          >
                                            {lang.name}
                                          </button>
                                        ))}
                                      </div>
                                    </div>
                                  }
                                  interactive={true}
                                  placement="top"
                                  trigger="click"
                                  appendTo={() => document.body}
                                >
                                  <button className="p-1 text-gray-600 hover:text-gray-800" title="Translate">
                                    <Languages className="w-5 h-5" />
                                  </button>
                                </Tippy>
                              )}
                            </div>
                          )}
                          {!msg.personalMode && !isPersonalHoroscopeChat && !showPersonalMode && !showCompatibilityMode && (
                            <div className="relative" data-share-menu-root="true">
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  toggleShareMenu(index);
                                }}
                                className="p-1 text-gray-600 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-200 mr-1"
                                title={t('chat.share_friend.answer_share_label', 'Share')}
                                aria-haspopup="true"
                                aria-expanded={openShareMenuIndex === index}
                              >
                                <MoreHorizontal className="w-5 h-5" />
                              </button>
                              <div
                                id={`share-dropdown-${index}`}
                                style={{ top: "-17px" }}
                                className={`absolute right-0 z-10 max-w-[calc(100vw-2rem)] flex-wrap items-center rounded-lg border border-slate-200 bg-white p-2 shadow-lg dark:border-slate-700 dark:bg-slate-900 ${
                                  openShareMenuIndex === index ? 'flex' : 'hidden'
                                }`}
                              >
                                {(() => {
                                  const title = t(
                                    'chat.share_friend.answer_fallback_text',
                                    'I found Sarvalok useful for source-grounded Dharma questions. You might like it too.'
                                  );
                                  const buttonClassName = 'flex items-center px-4 py-2 text-gray-800 hover:bg-gray-100 dark:text-gray-100 dark:hover:bg-slate-800';
                                  return (
                                    <>
                                      <WhatsappShareButton
                                        url={buildLocalizedHomepageShareUrl('whatsapp', i18n.language, 'answer_menu_fallback')}
                                        title={title}
                                        onClick={() => {
                                          recordSafeAnswerShare('whatsapp');
                                          closeShareMenu();
                                        }}
                                        className={buttonClassName}
                                      >
                                        <WhatsApp className="w-5 h-5 mr-2" />
                                      </WhatsappShareButton>
                                      <TwitterShareButton
                                        url={buildLocalizedHomepageShareUrl('x', i18n.language, 'answer_menu_fallback')}
                                        title={title}
                                        onClick={() => {
                                          recordSafeAnswerShare('x');
                                          closeShareMenu();
                                        }}
                                        className={buttonClassName}
                                      >
                                        <Twitter className="w-5 h-5 mr-2" />
                                      </TwitterShareButton>
                                      <FacebookShareButton
                                        url={buildLocalizedHomepageShareUrl('facebook', i18n.language, 'answer_menu_fallback')}
                                        title={title}
                                        onClick={() => {
                                          recordSafeAnswerShare('facebook');
                                          closeShareMenu();
                                        }}
                                        className={buttonClassName}
                                      >
                                        <Facebook className="w-5 h-5 mr-2" />
                                      </FacebookShareButton>
                                      <TelegramShareButton
                                        url={buildLocalizedHomepageShareUrl('telegram', i18n.language, 'answer_menu_fallback')}
                                        title={title}
                                        onClick={() => {
                                          recordSafeAnswerShare('telegram');
                                          closeShareMenu();
                                        }}
                                        className={buttonClassName}
                                      >
                                        <Telegram className="w-5 h-5 mr-2" />
                                      </TelegramShareButton>
                                    </>
                                  );
                                })()}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      )}
                    </div>
                  </div>
                  {renderAnnouncementSlotsAfter(index)}
                </React.Fragment>
                )
              ))}
              </div>
            </div>

            {showHomeShortcutPrompt && (
              <HomeShortcutPrompt
                mode={homeShortcutPromptMode}
                onShowInstructions={prepareHomeShortcutInstructions}
                onSnooze={snoozeHomeShortcutPrompt}
                onNeverShow={neverShowHomeShortcutPrompt}
                onDone={markHomeShortcutDone}
              />
            )}

            {/* ✅ FIX 2: Explore and Questions are now direct children of the scroll container,
                ensuring they appear directly after the last message without a large gap. */}
            {(() => {
              const personalAstroVisible = isPersonalHoroscopeChat && !isListeningMode;
              const personalExploreItems = personalAstroVisible
                ? shuffledAstroQuestions.filter(q => !clickedAstroQuestions.has(q)).slice(0, 8)
                : [];
              const exploreItemsToRender = personalAstroVisible ? personalExploreItems : topics;
              const showExploreCard = personalAstroVisible
                ? exploreItemsToRender.length > 0
                : showExplore && exploreItemsToRender.length > 0;

              if (!showExploreCard) return null;

              const titleText = isListeningMode
                ? "Explore Audio"
                : personalAstroVisible
                  ? "Unlock Your Chart"
                  : "Beyond Known Texts";

              return (
                <>
                  <style>
                    {`
                      /* Fonts loaded globally via @fontsource in main.tsx */
                      .font-garamond { font-family: 'EB Garamond', serif; }
                      .font-inter { font-family: 'Inter', sans-serif; }

                      .topic-explorer-wrapper {
                        background: #f8fafc; /* bg-slate-50 */
                      }
                      .dark .topic-explorer-wrapper {
                        background: #020617; /* bg-slate-950 */
                      }

                      .topic-explorer-container {
                        background: rgba(248, 250, 252, 0.8); /* slate-50 with transparency */
                        border: 1px solid rgba(226, 232, 240, 0.7); /* slate-200 */
                        border-radius: 16px;
                        backdrop-filter: blur(10px);
                        -webkit-backdrop-filter: blur(10px);
                        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.07);
                      }
                      .dark .topic-explorer-container {
                        background: rgba(30, 41, 59, 0.7); /* slate-800 */
                        border-color: rgba(51, 65, 85, 0.8); /* slate-700 */
                      }

                      .explorer-header {
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                      }

                      .diya-icon-container {
                        background: linear-gradient(135deg, #ffd700, #ffb347);
                        box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.5);
                        animation: pulse-icon 3s infinite ease-in-out;
                      }

                      .topic-suggestion {
                        display: flex;
                        align-items: center;
                        padding: 12px;
                        margin-bottom: 8px;
                        background: rgba(255, 255, 255, 0.6);
                        border: 1px solid rgba(226, 232, 240, 0.9); /* slate-200 */
                        border-radius: 10px;
                        cursor: pointer;
                        transition: all 0.25s ease;
                        color: #475569; /* slate-600 */
                        font-size: 14px;
                        font-weight: 400;
                        text-align: left;
                        width: 100%;
                        position: relative;
                        overflow: hidden;
                      }
                      .topic-suggestion:disabled {
                        cursor: not-allowed;
                        opacity: 0.6;
                      }
                      .dark .topic-suggestion {
                        background: rgba(51, 65, 85, 0.5); /* slate-700 */
                        border-color: rgba(71, 85, 105, 0.8); /* slate-600 */
                        color: #cbd5e1; /* slate-300 */
                      }

                      .topic-suggestion:hover {
                        background: #ffffff;
                        border-color: rgba(249, 115, 22, 0.4);
                        transform: translateY(-2px) scale(1.02);
                        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
                        color: #1e293b; /* slate-800 */
                      }
                      .dark .topic-suggestion:hover {
                        background: rgba(71, 85, 105, 0.9); /* slate-600 */
                        color: #ffffff;
                      }

                      .topic-suggestion::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: -100%;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(90deg, transparent, rgba(249, 115, 22, 0.08), transparent);
                        transition: left 0.6s ease;
                      }
                      .topic-suggestion:hover::before {
                        left: 100%;
                      }

                      .suggestion-arrow {
                        margin-right: 12px;
                        color: #94a3b8; /* slate-400 */
                        transition: color 0.25s ease, transform 0.25s ease;
                        flex-shrink: 0;
                      }
                      .topic-suggestion:hover .suggestion-arrow {
                        color: #f97316; /* orange-500 */
                        transform: translateX(2px);
                      }

                      .suggestion-text {
                        transition: font-weight 0.25s ease;
                      }
                      .topic-suggestion:hover .suggestion-text {
                        font-weight: 500;
                      }

                      .topic-suggestion-grid {
                        display: grid;
                        grid-template-columns: 1fr;
                        gap: 10px;
                      }

                      @media (min-width: 640px) {
                        .topic-suggestion-grid {
                          grid-template-columns: repeat(2, minmax(0, 1fr));
                        }
                      }

                      @keyframes fadeInUp {
                        from { opacity: 0; transform: translateY(15px); }
                        to { opacity: 1; transform: translateY(0); }
                      }

                      /* Sacred Category Button Styles */
                      .sacred-category-button {
                        position: relative;
                        background: transparent;
                        border: none;
                        cursor: pointer;
                      }
                      
                      .sacred-category-button::before {
                        content: '';
                        position: absolute;
                        inset: 0;
                        border-radius: 1rem;
                        padding: 1px;
                        background: linear-gradient(135deg, rgba(249, 115, 22, 0.3), rgba(245, 158, 11, 0.2), rgba(59, 130, 246, 0.1));
                        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
                        mask-composite: xor;
                        -webkit-mask-composite: xor;
                        opacity: 0;
                        transition: opacity 0.3s ease;
                      }
                      
                      .sacred-category-button:hover::before {
                        opacity: 1;
                      }
                      
                      .dark .sacred-category-button .absolute:first-child {
                        background: linear-gradient(135deg, rgba(30, 41, 59, 0.9), rgba(51, 65, 85, 0.8), rgba(71, 85, 105, 0.7));
                        border-color: rgba(148, 163, 184, 0.3);
                      }
                      
                      .dark .sacred-category-button span {
                        color: #cbd5e1;
                      }
                      
                      .dark .sacred-category-button:hover span {
                        color: #f1f5f9;
                      }

                      @keyframes pulse-icon {
                        0%, 100% {
                          transform: scale(1);
                          box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.5);
                        }
                        50% {
                          transform: scale(1.1);
                          box-shadow: 0 6px 16px rgba(255, 215, 0, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.6);
                        }
                      }
                    `}
                  </style>

                  <div className="topic-explorer-wrapper w-full flex items-center justify-center p-4">
                    <div className={`topic-explorer-container ${personalAstroVisible ? 'max-w-3xl' : 'max-w-xl'} w-full p-6`}>
                      <div className="explorer-header">
                        <div className="diya-icon-container w-9 h-9 mr-4 rounded-full flex items-center justify-center shrink-0">
                          <DiyaIcon className="text-white/90" />
                        </div>

                        <h3 className="font-garamond text-2xl font-medium text-slate-800 dark:text-slate-100">
                          <span className="border-b-2 border-orange-500 pb-1">
                            {titleText}
                          </span>
                        </h3>
                      </div>

                      <div className={`font-inter ${personalAstroVisible ? 'topic-suggestion-grid' : ''}`}>
                        {exploreItemsToRender.map((topic, index) => (
                          <button
                            key={`${index}-${topic}`}
                            onClick={() => {
                              if (personalAstroVisible) {
                                setClickedAstroQuestions(prev => {
                                  const next = new Set(prev);
                                  next.add(topic);
                                  return next;
                                });
                              }
                              handleSendMessage(topic);
                            }}
                            className="topic-suggestion"
                            disabled={personalAstroVisible && loading}
                          >
                            <ArrowUpIcon className="suggestion-arrow w-4 h-4" />
                            <span className="suggestion-text">{topic}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </>
              );
            })()}

            {questions?.length > 0 && (
              <div className="mt-6 space-y-2">
                {questions?.map((question: string, qIndex: number) => (
                  <button
                    key={qIndex}
                    onClick={() => {
                      handleSendMessage(question);
                    }}
                    className="group w-full text-left px-4 py-3 bg-white border border-gray-200 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-50 hover:border-gray-300 hover:shadow-sm transition-all duration-200 flex items-start gap-3"
                  >
                    <ArrowUp className="mt-0.5 w-4 h-4 text-gray-400 group-hover:text-gray-600 transition-colors" />
                    <span dangerouslySetInnerHTML={{ __html: question }} className="text-sm leading-relaxed"></span>
                  </button>
                ))}
              </div>
            )}
            
            {/* ✅ FIX 2: This spacer is now at the end of all content. It creates the
                necessary empty space at the bottom to allow the last message to be
                scrolled to the top of the viewport. */}
            <div className="flex-shrink-0 h-[40vh]" />

            <div ref={messagesEndRef} />
            
            <div
              ref={chatInputRef}
              className={`fixed bottom-0 left-0 right-0 p-2 z-10 pointer-events-none chat-input-container ${isSidebarOpen ? 'md:pl-64' : 'md:pl-0'}`}
            >
              {showAstroNudge && isChatOpen && (
                <div className="max-w-[48rem] mx-auto mb-1.5 pointer-events-auto">
                  <div className="flex flex-col gap-2 rounded-lg border border-indigo-200 bg-gradient-to-r from-indigo-50 to-purple-50 px-3 py-2 text-xs shadow-sm dark:border-indigo-800/70 dark:from-indigo-900/20 dark:to-purple-900/20 sm:flex-row sm:items-center sm:justify-between">
                    <div className="flex min-w-0 items-start gap-2 text-indigo-900 dark:text-indigo-100">
                      <Lightbulb className="mt-0.5 h-4 w-4 shrink-0 text-indigo-600 dark:text-indigo-300 sm:mt-0" />
                      <span className="leading-relaxed">{t('chat.astro_nudge.banner_text')}</span>
                    </div>
                    <div className="flex items-center justify-end gap-2">
                      <button
                        onClick={() => { void openAstroModeFromNudge(); }}
                        className="rounded-full bg-indigo-600 px-2.5 py-1 text-[11px] font-medium text-white transition-colors hover:bg-indigo-700"
                      >
                        {userReportStatus.has_horoscope ? t('chat.astro_nudge.cta_open') : t('chat.astro_nudge.cta_start')}
                      </button>
                      <button
                        onClick={dismissAstroNudgeForCurrentThread}
                        className="rounded-full p-1 text-indigo-500 transition-colors hover:bg-indigo-100 hover:text-indigo-700 dark:text-indigo-300 dark:hover:bg-indigo-900/40 dark:hover:text-indigo-100"
                        aria-label={t('chat.astro_nudge.dismiss')}
                        title={t('chat.astro_nudge.dismiss')}
                      >
                        <X className="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {isFreePlan && !upgradeBannerDismissed && isChatOpen && !showAstroNudge && (
                <div className="max-w-[48rem] mx-auto mb-1.5 pointer-events-auto">
                  <div className="sl-chat-quota-banner flex items-center justify-between rounded-lg px-3 py-1.5 bg-gradient-to-r from-slate-50 to-orange-50 border border-slate-200 shadow-sm text-xs">
                    <div className="flex items-center gap-2 text-slate-600 dark:text-slate-300">
                      <span className="text-orange-500">✦</span>
                      <span className="font-medium">{t('chat.upgrade_banner_free')}</span>
                      {isRemainingHitsReady && (
                        <>
                          <span className="text-slate-400 dark:text-slate-500">·</span>
                          <span>{t('chat.upgrade_banner_tokens', { count: remainingHits.toLocaleString() })}</span>
                        </>
                      )}
                    </div>
                    <div className="flex items-center gap-2">
                      <LocalizedLink
                        to="/pricing"
                        className="px-2.5 py-0.5 rounded-full bg-orange-500 text-white font-medium hover:bg-orange-600 transition-colors text-[11px]"
                      >
                        {t('chat.upgrade_banner_cta')} →
                      </LocalizedLink>
                      <button
                        onClick={() => { setUpgradeBannerDismissed(true); try { sessionStorage.setItem('upgrade_banner_dismissed', '1'); } catch {} }}
                        className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 ml-0.5"
                        aria-label="Dismiss"
                      >
                        ×
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className={`max-w-[48rem] mx-auto flex flex-col gap-1 rounded-lg p-2 bg-white border border-gray-200 shadow-lg pointer-events-auto ${styles['mobile-input-container']}`}>
                {tokenlimitReached ? (
                  <div className="flex items-center justify-between text-red-600">
                <span>{t('chat.token_limit_chat_end_message')}</span>
                    <button
                      onClick={handleNewChat}
                      style={{ whiteSpace: "nowrap" }}
                      className="ml-2 p-2 bg-black text-white rounded-lg h flex items-center gap-2"
                    >
                <Plus /> {t('chat.new_chat')}
                    </button>
                  </div>
                ) : (
                  <>
                    {/* No longer gated on an existing thread. Switching profile
                        now starts a fresh chat, so requiring a thread would hide
                        this control the instant it was used — and "who is this
                        chat about?" is precisely the question worth answering
                        before the first message. With no thread open,
                        `getThreadSubjectMeta(null)` reports the pending choice. */}
                    {isPersonalHoroscopeChat && availableSubjectsForPicker.length > 1 && (
                      <div className="flex items-center justify-start">
                        <select
                          value={getThreadSubjectMeta(activeThreadIdRef.current || ThreadId || null).active_subject_id || 'self'}
                          onChange={(e) => { void handleActiveSubjectChange(e.target.value); }}
                          className="block w-auto max-w-[280px] rounded-full bg-white px-3 py-1 text-[11px] sm:text-xs font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                          title={t('chat.subject_picker.title')}
                        >
                          {availableSubjectsForPicker.map((subject) => {
                            // Relation is a backend enum; resolve it rather than
                            // printing "Priya · sister" into a translated UI.
                            const label = subject.id === 'self'
                              ? (subject.display_name || t('chat.subject_picker.you'))
                              : `${subject.display_name || t('chat.subject_picker.person')}${
                                  subject.relation
                                    ? ` · ${t(`chat.astro_form.subject.relations.${subject.relation}`, { defaultValue: subject.relation })}`
                                    : ''
                                }`;
                            return (
                              <option key={subject.id} value={subject.id}>{label}</option>
                            );
                          })}
                        </select>
                      </div>
                    )}

                    <div className="flex items-center gap-2.5">
                      {!isSidebarOpen&& <ArrowLeftCircle className="w-7 h-7 md:w-6 md:h-6" style={{cursor:"pointer"}} onClick={handleNewChat} />}{/* back arrow: mobile 28px, desktop 24px (original: no className = 24px default) */}

                      <BlinkingPlaceholderTextarea
                        ref={chatTextareaRef}
                        animatedPlaceholders={
                          isPersonalHoroscopeChat && !isListeningMode && !showAstroFirstTimeDemo
                            ? astroPlaceholders
                            : undefined
                        }
                        placeholder={
                          isPersonalHoroscopeChat && !isListeningMode
                            ? ''
                            : (isListeningMode ? t('chat.placeholder_listening') : normalChatPlaceholder)
                        }
                        value={message}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        maxLength={CHAT_INPUT_MAX_CHARS}
                        readOnly={isRefreshingTransits}
                        rows={1}
                        className={`flex-1 px-4 py-1 focus:outline-none resize-none rounded-lg text-gray-700 ${styles['auto-expand-textarea']}`}
                      />

                      <div className={`desktop-actions ${styles['desktop-actions']}`}>
                        <button onClick={() => setIsFilterPopupOpen(true)} className="p-2 text-gray-600 hover:text-gray-800" title={t('chat.filters')}>
                          <Filter className="w-5 h-5" />
                        </button>
                        <button onClick={() => setIsAuthorityPopupOpen(true)} className="p-2 text-gray-600 hover:text-gray-800" title={t('chat.authority_settings')}>
                          <Settings className="w-5 h-5" />
                        </button>
                      <Tippy disabled={showAudioModeReminder && canShowAudioModeReminder} content={
                          <div className="text-sm max-w-xs space-y-1">
                            {t('chat.listening_mode_tooltip').split('\n').map((line, idx) => (
                              <div key={idx} className={idx === 0 ? 'mb-2' : ''}>{line}</div>
                            ))}
                          </div>
                        } placement="right" delay={[500, 100]} theme="listening-mode" popperOptions={{
                         modifiers: [
                           {
                             name: 'preventOverflow',
                             options: {
                               boundary: 'viewport',
                               padding: 8,
                             },
                           },
                         ],
                        }}>
                        <button
                          ref={conversationAudioToggleRef}
                          onClick={() => handleListeningModeChange()}
                          className={`sl-chat-listening-toggle p-2 rounded transition-all duration-200 ${
                            isListeningMode
                              ? 'sl-chat-toggle-active text-blue-500 bg-blue-50 shadow-sm'
                              : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'
                          }`}
                          title={t('chat.listening_mode')}
                        >
                          <Headphones className={`w-5 h-5 ${
                            isListeningMode ? 'drop-shadow-sm' : ''
                          }`} />
                        </button>
                        </Tippy>
                        <Tippy content={
                          <div className="text-sm max-w-xs">
                            {t('chat.fast_mode_tooltip')}
                          </div>
                        } placement="bottom" delay={[500, 100]} theme="fast-mode" popperOptions={{
                          modifiers: [
                           {
                             name: 'preventOverflow',
                             options: {
                               boundary: 'viewport',
                               padding: 8,
                             },
                           },
                         ],
                        }}>
                          <button
                            onClick={() => {
                              setIsFastSearch(!isFastSearch);
                            }}
                            className={`sl-chat-fast-toggle p-2 rounded transition-all duration-200 ${
                              isFastSearch
                                ? 'sl-chat-toggle-active text-yellow-500 bg-yellow-50 shadow-sm'
                                : 'text-gray-400 hover:text-gray-600 hover:bg-gray-50'
                            }`}
                            title={t('chat.fast_mode')}
                          >
                            <Zap className={`w-5 h-5 ${
                              isFastSearch ? 'drop-shadow-sm' : ''
                            }`} />
                          </button>
                        </Tippy>
                      </div>

                      <div className="mobile-actions md:hidden">
                        <MobileActionsMenu
                          isFilterPopupOpen={isFilterPopupOpen}
                          setIsFilterPopupOpen={setIsFilterPopupOpen}
                          isAuthorityPopupOpen={isAuthorityPopupOpen}
                          setIsAuthorityPopupOpen={setIsAuthorityPopupOpen}
                          isListeningMode={isListeningMode}
                          handleListeningModeChange={handleListeningModeChange}
                          isFastSearch={isFastSearch}
                          setIsFastSearch={setIsFastSearch}
                          isPersonalHoroscopeChat={isPersonalHoroscopeChat}
                          citationMode={effectiveUiMode}
                          onCitationModeChange={handleModeChange}
                          astroPromptMode={astroPromptMode}
                          onAstroPromptModeChange={handleAstroPromptModeChange}
                        />
                      </div>

                    {/* Hidden on mobile — citation toggle lives in MobileActionsMenu on small screens */}
                    <div className="hidden md:flex">
                    {isPersonalHoroscopeChat ? (
                      <Tippy content={
                        <div className="text-sm max-w-xs space-y-1">
                          <div><span className="font-semibold">Guidance:</span> Direct, actionable predictions for your life — no technical jargon</div>
                          <div><span className="font-semibold">Detailed:</span> In-depth analysis of houses, karakas, dashas &amp; more.</div>
                        </div>
                      } placement="bottom" delay={[200, 0]}>
                        <span>
                          <VerticalCitationToggle
                            variant="astro"
                            mode={astroPromptMode}
                            onModeChange={(m) => handleAstroPromptModeChange(m as 'astro_standard_mode' | 'astro_advanced_mode')}
                            disabled={false}
                            className="mx-1"
                          />
                        </span>
                      </Tippy>
                    ) : (
                      <VerticalCitationToggle
                        mode={effectiveUiMode}
                        onModeChange={handleModeChange}
                        disabled={false}
                        className="mx-1"
                      />
                    )}
                    </div>

                    <SpeechToText onTranscriptChange={handleTranscriptChange} />
                    <div className="ml-2">
                      <button
                        onClick={(loading || isStreaming) ? handleStopGenerating : () => handleSendMessage()}
                        className={`flex items-center justify-center p-2 rounded-md transition-colors bg-gray-800 hover:bg-gray-900 text-white disabled:opacity-50 ${styles['send-button']}`}
                        disabled={isRefreshingTransits || (!message.trim() && !(loading || isStreaming)) || (usageLimitReached && !(loading || isStreaming))}
                        title={(loading || isStreaming) ? "Stop" : "Send"}
                      >
                        {(loading || isStreaming) ? <Square className="w-5 h-5" /> : <ArrowUp className="w-5 h-5 stroke-[2.5]" />}
                      </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            </div>
          </div>
        )}

        {isRateLimitExceeded && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[200] p-4">{/* was z-50; raised to appear above reading modal */}
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg transform transition-all duration-300 ease-in-out overflow-hidden">
              <div className="px-5 pt-5 pb-4 sm:px-6 sm:pt-6">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex items-start gap-3">
                    <div className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-700">
                      <Zap className="h-5 w-5" />
                    </div>
                    <div>
                      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-emerald-700">
                        {usageLimitKind === 'free_trial'
                          ? t('chat.upgrade_modal.free_trial_eyebrow', 'Free trial complete')
                          : usageLimitKind === 'subscription_inactive'
                            ? t('chat.upgrade_modal.subscription_inactive_eyebrow', 'Subscription paused')
                          : t('chat.upgrade_modal.plan_eyebrow', 'Credits used')}
                      </p>
                      <h2 className="mt-1 text-xl font-semibold text-gray-900 sm:text-2xl">
                        {usageLimitKind === 'free_trial'
                          ? t('chat.free_trial_over_title', 'Your free trial is complete')
                          : usageLimitKind === 'subscription_inactive'
                            ? t('chat.subscription_inactive_title', 'Your subscription needs attention')
                          : t('chat.plan_credits_exhausted_title', "You've used this month's credits")}
                      </h2>
                    </div>
                  </div>
                  <button
                    onClick={() => setIsRateLimitExceeded(false)}
                    className="rounded-full p-1.5 text-2xl leading-none text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
                    aria-label={t('common.close', 'Close')}
                  >
                    ×
                  </button>
                </div>
                <p className="mt-4 text-sm leading-6 text-gray-600">
                  {usageLimitKind === 'free_trial'
                    ? t('chat.free_trial_over_modal_message', 'Upgrade to keep your research and Jyotisha work flowing.')
                    : usageLimitKind === 'subscription_inactive'
                      ? t('chat.subscription_inactive_modal_message', 'Renew, top up, or choose a plan to continue fresh answers.')
                    : t('chat.plan_credits_exhausted_message', 'Top up or upgrade to continue without waiting for your next refresh.')}
                </p>
              </div>
              <div className="border-y border-gray-100 bg-gray-50/80 px-5 py-4 sm:px-6">
                <div className="space-y-3">
                  {(usageLimitKind === 'free_trial'
                    ? [
                        t('chat.upgrade_modal.free_trial_benefit_credits', 'More credits for uninterrupted research'),
                        t('chat.upgrade_modal.free_trial_benefit_astro', 'Up to 25x more Jyotisha generations than leading alternatives*'),
                        t('chat.upgrade_modal.free_trial_benefit_tools', 'Premium Astrology, Compatibility, and Day Quality tools'),
                        t('chat.upgrade_modal.free_trial_benefit_cancel', 'Cancel anytime. No long-term lock-in.')
                      ]
                    : usageLimitKind === 'subscription_inactive'
                    ? [
                        t('chat.upgrade_modal.subscription_benefit_renew', 'Renew, top up, or choose a plan that fits how you use Sarvalok'),
                        t('chat.upgrade_modal.subscription_benefit_resume', 'Resume chat, Jyotisha, compatibility, and Day Quality tools'),
                        t('chat.upgrade_modal.subscription_benefit_saved', 'Your saved research and chats stay available after renewal'),
                        t('chat.upgrade_modal.subscription_benefit_cancel', 'Change or cancel your plan anytime')
                      ]
                    : [
                        t('chat.upgrade_modal.plan_benefit_topup', 'Top up instantly or upgrade for a larger monthly allowance'),
                        t('chat.upgrade_modal.plan_benefit_research', 'Keep research, citations, and manuscript filters uninterrupted'),
                        t('chat.upgrade_modal.plan_benefit_tools', 'Premium Astrology, Compatibility, and Day Quality tools'),
                        t('chat.upgrade_modal.plan_benefit_cancel', 'Change or cancel your plan anytime')
                      ]).map((benefit) => (
                    <div key={benefit} className="flex items-start gap-3 text-sm text-gray-700">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
                        <Check className="h-3.5 w-3.5" />
                      </span>
                      <span>{benefit}</span>
                    </div>
                  ))}
                </div>
                {usageLimitKind === 'free_trial' && (
                  <p className="mt-3 text-[11px] leading-4 text-gray-500">
                    {t('chat.upgrade_modal.free_trial_footnote', '*Based on Sarvalok’s credit model and comparable Jyotisha generation limits.')}
                  </p>
                )}
              </div>
              <div className="px-5 pb-5 pt-4 sm:px-6 sm:pb-6">
                <LocalizedLink
                  to="/pricing"
                  style={{ backgroundColor: "#000" }}
                  className="w-full bg-gray-900 text-white py-3 px-4 rounded-xl hover:bg-gray-800 transition-colors block text-center font-semibold shadow-lg shadow-gray-900/10"
                >
                  {usageLimitKind === 'free_trial'
                    ? t('chat.upgrade_modal.free_trial_cta', 'Choose a Plan')
                    : usageLimitKind === 'subscription_inactive'
                      ? t('chat.upgrade_modal.subscription_cta', 'Renew, Top Up, or Choose a Plan')
                    : t('chat.upgrade_modal.plan_cta', 'See Plans & Top-Ups')}
                </LocalizedLink>
                <p className="mt-3 text-center text-xs text-gray-500">
                  {usageLimitKind === 'free_trial'
                    ? t('chat.upgrade_modal.free_trial_reassurance', 'Start small, cancel anytime.')
                    : usageLimitKind === 'subscription_inactive'
                      ? t('chat.upgrade_modal.subscription_reassurance', 'Your access resumes as soon as your plan is active.')
                    : t('chat.upgrade_modal.plan_reassurance', 'Your access resumes as soon as credits are added.')}
                </p>
              </div>
            </div>
          </div>
        )}

        {isAuthorityPopupOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4 overflow-y-auto">
            <div className="bg-white w-full max-w-md max-h-[85vh] overflow-y-auto p-4 sm:p-6 rounded-xl shadow-2xl transform transition-transform duration-200">
              <h2 className="text-xl font-semibold mb-6 text-gray-800 flex items-center gap-2">
                <Settings className="w-6 h-6 text-gray-600" />
                {t('chat.authority.title')}
              </h2>

              <div className="mb-6">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="text-sm text-gray-600 mb-2 block">{t('chat.authority.min_label')}</label>
                    <div className="flex items-center gap-2">
                      <input
                        type="range"
                        min="0"
                        max="10"
                        value={authorityRange[0]}
                        onChange={(e) => {
                          const newMin = parseInt(e.target.value);
                          handleAuthorityChange(newMin, authorityRange[1]);
                        }}
                        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                        style={{ accentColor: '#3b82f6' }}
                      />
                      <input
                        type="number"
                        min="0"
                        max="10"
                        value={authorityRange[0]}
                        onChange={(e) => {
                          const newMin = Math.min(parseInt(e.target.value) || 0, 10);
                          handleAuthorityChange(newMin, authorityRange[1]);
                        }}
                        className="w-16 px-2 py-1 border border-gray-300 rounded-lg text-center text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="text-sm text-gray-600 mb-2 block">{t('chat.authority.max_label')}</label>
                    <div className="flex items-center gap-2">
                      <input
                        type="range"
                        min="0"
                        max="10"
                        value={authorityRange[1]}
                        onChange={(e) => {
                          const newMax = parseInt(e.target.value);
                          handleAuthorityChange(authorityRange[0], newMax);
                        }}
                        className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                        style={{ accentColor: '#3b82f6' }}
                      />
                      <input
                        type="number"
                        min="0"
                        max="10"
                        value={authorityRange[1]}
                        onChange={(e) => {
                          const newMax = Math.max(parseInt(e.target.value) || 0, 0);
                          handleAuthorityChange(authorityRange[0], newMax);
                        }}
                        className="w-16 px-2 py-1 border border-gray-300 rounded-lg text-center text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-4 text-sm text-gray-500">
                  <p>{t('chat.authority.range_label', { min: authorityRange[0], max: authorityRange[1] })}</p>
                  <br/>
                  <div  className="flex items-center mb-2">
<button
                  onClick={() => {handleAuthorityChange(0,10)}}
                  className="px-4 py-2 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-lg hover:from-gray-700 hover:to-gray-800 transition-all duration-200 shadow-md hover:shadow-lg"
                >
                  {t('chat.authority.reset')}
                </button>
</div>
                  {authorityError && (
                    <p className="text-gray-500 text-xs mt-1">{authorityError}</p>
                  )}

                  <p className="text-gray-600 text-xs mt-1">
                    {t('chat.authority.help_text')}
                    <br /> {t('chat.authority.helper_tip')}
                  </p>
                </div>
              </div>

              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setIsAuthorityPopupOpen(false)}
                  className="px-4 py-2 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-lg hover:from-gray-700 hover:to-gray-800 transition-all duration-200 shadow-md hover:shadow-lg"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        )}

        {isFilterPopupOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4 overflow-y-auto">
            <div className="bg-white w-full max-w-md max-h-[85vh] overflow-y-auto p-4 sm:p-6 rounded-xl shadow-2xl transform transition-transform duration-200">
              <h2 className="text-xl font-semibold mb-6 text-gray-800 flex items-center gap-2">
                <Filter className="w-6 h-6 text-gray-600" />
                Select Filters
              </h2>

              <div className="mb-6 max-h-[55vh] overflow-y-auto pl-2">
                {availableFilters.length > 0 ? (
                  availableFilters.map((filter: any, index: any) => (
                    <div key={index} className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        checked={selectedFilters.includes(filter)}
                        onChange={() => handleFilterChange(filter)}
                        className="w-4 h-4 text-blue-600 border-gray-300 rounded"
                      />
                      <label className="ml-2 text-gray-700 cursor-pointer" onClick={() => handleFilterChange(filter)}>{filter}</label>
                    </div>
                  ))
                ) : (
                  <p className="text-gray-500">No filters available</p>
                )}


<div  className="flex items-center mb-2">
{selectedFilters.length>0&&<button
                  onClick={() => {localStorage.removeItem("selectedFilters"); setSelectedFilters([])}}
                  className="px-4 py-2 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-lg hover:from-gray-700 hover:to-gray-800 transition-all duration-200 shadow-md hover:shadow-lg"
                >
                  Clear filters
                </button>}
</div>
                <p className="text-gray-600 text-xs mt-1">
                 Select filters if you want to explore something specific.
                  <br/>

                </p>
              </div>

              <div className="flex justify-end gap-2">
                <button
                  onClick={() => setIsFilterPopupOpen(false)}
                  className="px-4 py-2 bg-gradient-to-r from-gray-600 to-gray-700 text-white rounded-lg hover:from-gray-700 hover:to-gray-800 transition-all duration-200 shadow-md hover:shadow-lg"
                >
                  {t('chat.ok')}
                </button>
              </div>
              <p className="text-gray-600 text-xs mt-2">Answers from manuscripts may be affected by its quality, which can be incomplete, aged, or difficult to read.</p>
            </div>
          </div>
        )}
      </div>

      {isPranayamaModalOpen && (
        <Suspense fallback={null}>
          <PranayamaModalLazy
            isOpen={isPranayamaModalOpen}
            onClose={() => setIsPranayamaModalOpen(false)}
          />
        </Suspense>
      )}

      {isTodoModalOpen && (
        <Suspense fallback={null}>
          <QuestlogModalLazy
            show={isTodoModalOpen}
            onHide={() => setIsTodoModalOpen(false)}
          />
        </Suspense>
      )}

      {/* Quiz Modal */}
      {showQuiz && (
        <Suspense fallback={null}>
          <QuizModalLazy
            isOpen={isQuizModalOpen}
            onClose={handleQuizModalClose}
            localUserId={localUserId}
            firebaseToken={firebaseToken}
            appCheckToken={appCheckToken}
          />
        </Suspense>
      )}

	      {/* Reading Mode Modal */}
	      {isReadingModalOpen && readingModalProps && (
	        <Suspense fallback={null}>
	          <ReadingModalLazy
	            isOpen={isReadingModalOpen}
            onClose={() => { setIsReadingModalOpen(false); setReadingModalProps(null); }}
            initialToken={readingModalProps.token}
            initialLabel={readingModalProps.label}
            initialCi={readingModalProps.ci}
            locale={i18n.language}
            onRateLimited={() => {
              openUsageLimitModal(isFreePlanRef.current ? 'free trial exhausted' : 'plan credits exhausted');
            }}
          />
	        </Suspense>
	      )}

		      {showAstroFirstTimeDemo && (
		        <AstroFirstTimeDemo
		          {...astroFirstTimeDemoStrings}
		          loop={false}
		          onComplete={handleAstroFirstTimeDemoClose}
		          onDismiss={handleAstroFirstTimeDemoClose}
		        />
		      )}

		      {showAstroTour && (
		        <AstroSpotlightTour
		          targetRefs={astroTourTargetRefs}
		          onClose={handleAstroTourClose}
	          duration={5000}
	        />
	      )}

        {showAudioModeReminder && canShowAudioModeReminder && (
          <AudioModeReminderBubble
            targetRef={conversationAudioToggleRef}
            onDismiss={dismissAudioModeReminder}
            onTurnOff={turnOffListeningMode}
            eyebrow={t('chat.audio_mode_reminder.eyebrow')}
            message={
              audioModeReminderStep === 1
                ? t('chat.audio_mode_reminder.first')
                : t('chat.audio_mode_reminder.second')
            }
            ctaLabel={t('chat.audio_mode_reminder.cta')}
            dismissLabel={t('chat.audio_mode_reminder.dismiss')}
            autoCloseMs={10000}
          />
        )}

        {atmosphereReady && isChatOpen && !showPersonalMode && !showCompatibilityMode && (
          <Suspense fallback={null}>
            <ChatAtmospherePlayerLazy
              isChatOpen={isChatOpen}
              isListeningMode={isListeningMode}
            />
          </Suspense>
        )}
	
	      {/* "Save this for whom?" — only for threads where the destination is
	          genuinely ambiguous. Self/general threads never reach this. */}
	      <MemorySubjectPickerDialog
        open={!!memoryPicker}
        targets={memoryPicker?.targets.targets ?? []}
        defaultTarget={memoryPicker?.targets.defaultTarget ?? null}
        labels={Object.fromEntries(
          availableSubjectsForPicker.map((s: any) => [s.id, s.display_name || '']),
        )}
        saving={rememberingMessageIndex !== null}
        onCancel={() => setMemoryPicker(null)}
        onSave={(subjectId) => {
          if (!memoryPicker) return;
          // `confirmed` = true only here: the user chose a row and pressed Save.
          void doSaveMemory(memoryPicker.index, memoryPicker.text, subjectId, true);
        }}
      />

	      {/* Info Tips Popup */}
	      <InfoTipsPopup
        isVisible={showInfoTipsPopup}
        onClose={() => setShowInfoTipsPopup(false)}
      />
    </div>
    </>
  );
};

export default ChatPage;
